function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4uyp4", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$2cc1f4c2e655a1a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3HwlS;
    var $e9YVH;
    var $lw2HC;
    var $ghVG7;
    var $epm3G;
    var $2riGj;
    var $4dRjY;
    var $l8ruj;
    const $2cc1f4c2e655a1a2$var$View = ()=>{
        const [, { resetDraftArticleData: resetDraftArticleData }] = (0, (0, parcelRequire("lw2HC")).useArticleId)();
        (0, $5uXOq.useEffect)(()=>()=>{
                resetDraftArticleData(true);
            }, [
            resetDraftArticleData
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "knowledge-hub-browse-all-articles"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2riGj")).KnowledgeHubAppBase), {
            appName: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
            shouldRemoveMargin: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)()
        }, ({ match: match, query: query, pageContext: pageContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghVG7")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("epm3G")).default), {
                page: match?.params?.pageId,
                sortBy: query?.sortBy,
                cursor: query?.cursor,
                searchQuery: query?.searchQuery,
                spaceKey: query?.spaceKey,
                activationId: pageContext?.activationId
            }))));
    };
    var $2cc1f4c2e655a1a2$export$2e2bcd8739ae039 = $2cc1f4c2e655a1a2$var$View;
});
parcelRegister("lw2HC", function(module, exports) {
    $parcel$export(module.exports, "initialCreateCategoryData", ()=>$ba746da67c53f4b3$export$4947e9942a5d137c);
    $parcel$export(module.exports, "KnowledgeCommonSubscriber", ()=>$ba746da67c53f4b3$export$d226f0c95b79366b);
    $parcel$export(module.exports, "UserCapabilitiesSubscriber", ()=>$ba746da67c53f4b3$export$42b7b5df8c1dee52);
    $parcel$export(module.exports, "useFlagData", ()=>$ba746da67c53f4b3$export$a9ac4a6dcb7104bf);
    $parcel$export(module.exports, "useGetCategory", ()=>$ba746da67c53f4b3$export$3fa52226f8fff61e);
    $parcel$export(module.exports, "useDraftShareId", ()=>$ba746da67c53f4b3$export$2602997fd4d9b312);
    $parcel$export(module.exports, "useArticleId", ()=>$ba746da67c53f4b3$export$a5eb46485735066a);
    $parcel$export(module.exports, "useIsFetchingDraftDetails", ()=>$ba746da67c53f4b3$export$428db75bed41f9d);
    $parcel$export(module.exports, "useRedirectionData", ()=>$ba746da67c53f4b3$export$e30071c464cba7f9);
    $parcel$export(module.exports, "useUserCapabilities", ()=>$ba746da67c53f4b3$export$7ae10e817e068c57);
    $parcel$export(module.exports, "useIsPermittedSpaces", ()=>$ba746da67c53f4b3$export$60270d772f1f3c76);
    $parcel$export(module.exports, "useCategoriesData", ()=>$ba746da67c53f4b3$export$56b47c5ebac10997);
    $parcel$export(module.exports, "useCreateCategoryData", ()=>$ba746da67c53f4b3$export$1e7300097c003415);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $kz5Uo;
    var $cSB1I;
    const $ba746da67c53f4b3$export$61e797cf03b496e1 = {
        hasConfluenceLicense: false,
        articleUserCapabilities: {
            canCreateArticle: false
        },
        spaceUserCapabilities: {
            editableSpaces: [],
            readableSpaces: []
        }
    };
    const $ba746da67c53f4b3$export$4947e9942a5d137c = {
        isSubmitting: false,
        formValues: {
            name: '',
            description: ''
        },
        error: {
            formError: undefined,
            fieldErrors: undefined
        },
        createdCategory: null
    };
    const $ba746da67c53f4b3$export$d4c72bab9d6cc13a = {
        draftShareId: '',
        articleId: '',
        published: false,
        closed: false,
        deleted: false,
        redirectionData: {
            onPublishRedirectUrl: '',
            onCloseRedirectUrl: ''
        },
        isFetchingDraftDetails: false,
        spacesPermitted: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        permittedSpaces: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        userCapabilities: {
            isLoading: false,
            error: null,
            data: {
                ...$ba746da67c53f4b3$export$61e797cf03b496e1
            }
        },
        linkedSpaces: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        showConfluenceCreatePageError: false,
        categoriesData: {
            isLoading: true,
            categories: [],
            isCategoriesSupported: false,
            error: null
        },
        createCategoryData: {
            ...$ba746da67c53f4b3$export$4947e9942a5d137c
        },
        spaceKey: '',
        flags: []
    };
    const $ba746da67c53f4b3$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $ba746da67c53f4b3$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("kz5Uo")).actions,
        name: 'KnowledgeCommonStore'
    });
    const $ba746da67c53f4b3$export$d226f0c95b79366b = (0, (0, parcelRequire("51nlc")).createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9);
    const $ba746da67c53f4b3$export$42b7b5df8c1dee52 = (0, (0, parcelRequire("51nlc")).createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        displayName: 'UserCapabilitiesSubscriber',
        selector: (0, (0, parcelRequire("cSB1I")).getUserCapabilities)
    });
    const $ba746da67c53f4b3$export$a3c47cea95d8bbd1 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCommonFlags)
    });
    const $ba746da67c53f4b3$export$a9ac4a6dcb7104bf = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getKnowledgeCommonFlags)
    });
    const $ba746da67c53f4b3$export$3fa52226f8fff61e = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCategory)
    });
    const $ba746da67c53f4b3$export$2602997fd4d9b312 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getDraftShareId)
    });
    const $ba746da67c53f4b3$export$a5eb46485735066a = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getArticleId)
    });
    const $ba746da67c53f4b3$export$428db75bed41f9d = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getIsFetchingDraftDetails)
    });
    const $ba746da67c53f4b3$export$e30071c464cba7f9 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getRedirectionData)
    });
    const $ba746da67c53f4b3$export$7ae10e817e068c57 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getUserCapabilities)
    });
    const $ba746da67c53f4b3$export$60270d772f1f3c76 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getPermittedSpaces)
    });
    const $ba746da67c53f4b3$export$40685b8df387d08 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getLinkedSpaces)
    });
    const $ba746da67c53f4b3$export$56b47c5ebac10997 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCategoriesData)
    });
    const $ba746da67c53f4b3$export$1e7300097c003415 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCreateCategoryData)
    });
});
parcelRegister("kz5Uo", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$78ea76781fae4c5f$export$e324594224ef24da);
    var $lx7EO;
    var $heXZI;
    var $dsFMC;
    var $aInVL;
    var $3twc2;
    var $klUDT;
    var $2tTYZ;
    var $ik7FP;
    var $dAXEk;
    var $dIiIO;
    var $gpe3Z;
    var $1TU0Q;
    var $jIuZj;
    var $eP4xZ;
    var $8QyFO;
    var $1VmcQ;
    const $78ea76781fae4c5f$export$e324594224ef24da = {
        setRedirectionData: (0, parcelRequire("1TU0Q")).setRedirectionData,
        resetRedirectionData: (0, parcelRequire("1TU0Q")).resetRedirectionData,
        publishSuccess: (0, parcelRequire("aInVL")).publishSuccess,
        savedSuccess: (0, parcelRequire("3twc2")).savedSuccess,
        fetchDraftAndNavigateToEditor: (0, parcelRequire("ik7FP")).fetchDraftAndNavigateToEditor,
        navigateCreateDraftRoute: (0, parcelRequire("gpe3Z")).navigateCreateDraftRoute,
        fetchCreateArticlePermission: (0, parcelRequire("2tTYZ")).fetchCreateArticlePermission,
        fetchLinkedSpaces: (0, parcelRequire("dAXEk")).fetchLinkedSpaces,
        resetDraftArticleData: (0, parcelRequire("8QyFO")).resetDraftArticleData,
        articleDeleteSuccess: (0, parcelRequire("lx7EO")).articleDeleteSuccess,
        fetchUserCapabilities: (0, parcelRequire("dIiIO")).fetchUserCapabilities,
        fetchCategories: (0, parcelRequire("klUDT")).fetchCategories,
        reorderCategories: (0, parcelRequire("eP4xZ")).reorderCategories,
        createCategory: (0, parcelRequire("heXZI")).createCategory,
        handleFormInputChange: (0, parcelRequire("heXZI")).handleFormInputChange,
        resetCreatedCategory: (0, parcelRequire("heXZI")).resetCreatedCategory,
        updateCategorySuccess: (0, parcelRequire("1VmcQ")).updateCategorySuccess,
        deleteCategorySuccess: (0, parcelRequire("dsFMC")).deleteCategorySuccess,
        removeCommonFlag: (0, parcelRequire("jIuZj")).removeCommonFlag
    };
});
parcelRegister("lx7EO", function(module, exports) {
    $parcel$export(module.exports, "articleDeleteSuccess", ()=>$cfa855108534d4c5$export$7e6f4a244457270c);
    const $cfa855108534d4c5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                deleted: true,
                articleId: articleId
            });
        };
});
parcelRegister("heXZI", function(module, exports) {
    $parcel$export(module.exports, "createCategory", ()=>$015500bcb6a585cb$export$7ce9dbcc6d544b1);
    $parcel$export(module.exports, "handleFormInputChange", ()=>$015500bcb6a585cb$export$8e52c4bd9075cb96);
    $parcel$export(module.exports, "resetCreatedCategory", ()=>$015500bcb6a585cb$export$98485bfbe8c8269a);
    var $jcw0u;
    var $8zOmE;
    var $fPjip;
    var $j8qrr;
    var $lw2HC;
    const $015500bcb6a585cb$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
            const { formValues: formValues } = {
                ...getState().createCategoryData
            };
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: true
                }
            });
            try {
                const category = await (0, (0, parcelRequire("j8qrr")).createCategory)(projectId, formValues, activationId);
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: [
                            ...getState().categoriesData.categories,
                            category
                        ]
                    },
                    createCategoryData: {
                        ...(0, (0, parcelRequire("lw2HC")).initialCreateCategoryData),
                        createdCategory: category
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
            } catch (error) {
                const { fieldErrors: fieldErrors, formError: formError } = (0, (0, parcelRequire("fPjip")).toErrors)(error);
                setState({
                    ...getState(),
                    createCategoryData: {
                        ...getState().createCategoryData,
                        isSubmitting: false,
                        error: {
                            formError: formError,
                            fieldErrors: fieldErrors
                        }
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'categoryCreate',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
            }
        };
    const $015500bcb6a585cb$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    formValues: {
                        ...getState().createCategoryData.formValues,
                        [field]: value
                    }
                }
            });
        };
    const $015500bcb6a585cb$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    createdCategory: null
                }
            });
        };
});
parcelRegister("fPjip", function(module, exports) {
    $parcel$export(module.exports, "toErrors", ()=>$fdef67eb1eab7980$export$b0ccdd1765e7cb42);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $i2U8h;
    var $guSo6;
    const $fdef67eb1eab7980$var$errorKeyToMessage = {
        'jsd.apollo.error.limit.exceeded': (0, (0, parcelRequire("i2U8h")).default).categoriesLimitExceeded,
        'jsd.apollo.error.project.permission.no.view.project.permission': (0, (0, parcelRequire("i2U8h")).default).categoriesNoPermission,
        'jsd.apollo.field.error.category.name.cannot.be.blank': (0, (0, parcelRequire("i2U8h")).default).categoriesNameFieldBlank,
        'jsd.apollo.field.error.category.exceeded.name.length': (0, (0, parcelRequire("i2U8h")).default).categoriesNameFieldTooLong,
        'jsd.apollo.field.error.category.description.cannot.be.blank': (0, (0, parcelRequire("i2U8h")).default).categoriesDescriptionFieldBlank,
        'jsd.apollo.field.error.category.exceeded.description.length': (0, (0, parcelRequire("i2U8h")).default).categoriesDescriptionFieldTooLong
    };
    const $fdef67eb1eab7980$export$b0ccdd1765e7cb42 = (errorResponse)=>{
        const fieldErrorsResponse = errorResponse.fieldErrors || {};
        const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
                ...acc,
                [field]: {
                    message: $fdef67eb1eab7980$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, (0, parcelRequire("i2U8h")).default).categoriesGenericMessage
                }
            }), {});
        const formError = errorResponse.errorKey ? {
            message: $fdef67eb1eab7980$var$errorKeyToMessage[errorResponse.errorKey] || (0, (0, parcelRequire("i2U8h")).default).categoriesGenericMessage
        } : undefined;
        return {
            formError: formError,
            fieldErrors: fieldErrors
        };
    };
    const $fdef67eb1eab7980$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, (0, parcelRequire("guSo6")).createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw({
                nativeError: errorResponse,
                formattedError: $fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)
            }));
    const $fdef67eb1eab7980$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, (0, parcelRequire("guSo6")).updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw($fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)));
});
parcelRegister("i2U8h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ed327d012ea36dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ed327d012ea36dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        categoriesGenericMessage: {
            "id": "servicedesk-knowledge-services.categories-generic-message",
            "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
        },
        categoriesNoPermission: {
            "id": "servicedesk-knowledge-services.categories-no-permission",
            "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
        },
        categoriesLimitExceeded: {
            "id": "servicedesk-knowledge-services.categories-limit-exceeded",
            "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
        },
        categoriesNameFieldBlank: {
            "id": "servicedesk-knowledge-services.categories-name-field-blank",
            "defaultMessage": "Name cannot be blank"
        },
        categoriesDescriptionFieldBlank: {
            "id": "servicedesk-knowledge-services.categories-description-field-blank",
            "defaultMessage": "Description cannot be blank"
        },
        categoriesNameFieldTooLong: {
            "id": "servicedesk-knowledge-services.categories-name-field-too-long",
            "defaultMessage": "Name cannot be longer than 100 characters"
        },
        categoriesDescriptionFieldTooLong: {
            "id": "servicedesk-knowledge-services.categories-description-field-too-long",
            "defaultMessage": "Description cannot be longer than 150 characters"
        }
    });
});
parcelRegister("guSo6", function(module, exports) {
    $parcel$export(module.exports, "listCategories", ()=>$61a0664d6d43d351$export$db54be5b1772ef4b);
    $parcel$export(module.exports, "createCategory", ()=>$61a0664d6d43d351$export$7ce9dbcc6d544b1);
    $parcel$export(module.exports, "updateCategory", ()=>$61a0664d6d43d351$export$daaacb0271870c9);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $5OrSA;
    var $2Lj35;
    const $61a0664d6d43d351$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
    };
    const $61a0664d6d43d351$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category/`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}`, {
            method: 'DELETE'
        });
    };
    const $61a0664d6d43d351$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
            method: 'POST',
            body: JSON.stringify(payload)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $61a0664d6d43d351$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        let body = {
            articleId: articleId,
            featured: isFeatured
        };
        body = {
            ...body,
            spaceKey: spaceKey
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article`, {
            method: 'POST',
            body: JSON.stringify(body)
        });
    };
    const $61a0664d6d43d351$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
            method: 'DELETE'
        });
    const $61a0664d6d43d351$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}`, {
            method: 'PUT',
            body: JSON.stringify(payload)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    const $61a0664d6d43d351$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        let body = {
            featured: isFeatured
        };
        body = {
            ...body,
            spaceKey: spaceKey
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article/${articleId}`, {
            method: 'PUT',
            body: JSON.stringify(body)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $61a0664d6d43d351$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
            method: 'PUT',
            body: JSON.stringify(categories)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
});
parcelRegister("5OrSA", function(module, exports) {
    $parcel$export(module.exports, "fetchJson$", ()=>$f90c86f7d1f72b9b$export$2ba52855e389d39e);
    $parcel$export(module.exports, "fetchText$", ()=>$f90c86f7d1f72b9b$export$64ab95a52860b608);
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $561FV = parcelRequire("561FV");
    var $kVLXA = parcelRequire("kVLXA");
    var $487fd;
    var $7f4tk;
    var $7zmUm;
    const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
            response: {
                errors: [
                    {
                        errorMessage: message
                    }
                ],
                reasonKey: 'generic.error',
                reasonCode: `${statusCode}`
            },
            statusCode: statusCode,
            traceId: traceId
        });
    const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
        const traceId = error.traceId;
        try {
            const response = JSON.parse(error.message);
            if ((0, ($parcel$interopDefault($561FV)))(response, 'message') && (0, ($parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
            return {
                response: response,
                statusCode: error.statusCode,
                traceId: traceId
            };
        } catch (e) {
            return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
        }
    };
    const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, (0, parcelRequire("7f4tk")).default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
    const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, (0, parcelRequire("487fd")).default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
    const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, (0, parcelRequire("7zmUm")).default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
});
parcelRegister("487fd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96196282ac54fa24$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("1oQta");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $x9xyg;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $96196282ac54fa24$var$noContentStatus = 204;
    const $96196282ac54fa24$var$transformUrl = (url)=>{
        const lUrl = url.replace(/\//g, '_');
        const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
        return resUrl;
    };
    function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
        const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
        let key;
        const isPerformanceCheckEnabled = !!perf;
        if (isPerformanceCheckEnabled) {
            const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
            key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
            (0, (0, parcelRequire("x9xyg")).setMark)(`BEGIN_${key}`);
        }
        return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), opts), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (isPerformanceCheckEnabled) (0, (0, parcelRequire("x9xyg")).setMark)(`END_${key}`);
            if (!response.ok) {
                const { status: status } = response;
                return response.text().then((str)=>{
                    const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                    if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, str, traceId);
                    else throw new (0, (0, parcelRequire("jJZqs")).default)(status, str);
                });
            }
            if (typeof headersProcessor === 'function') headersProcessor(response.headers);
            if (response.status === $96196282ac54fa24$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return response.json();
        });
    }
    var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;
});
parcelRegister("7zmUm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$198ed207dec01cca$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $198ed207dec01cca$var$noContentStatus = 204;
    var $198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), options), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
                else throw new (0, (0, parcelRequire("jJZqs")).default)(status);
            }
            if (response.status === $198ed207dec01cca$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return (0, $kVLXA.Observable).of(response.responseText || 'OK');
        });
});
parcelRegister("2Lj35", function(module, exports) {
    $parcel$export(module.exports, "categoryGuidToString", ()=>$6a4fff955a10b2dc$export$43162cfd3260b2fe);
    $parcel$export(module.exports, "toCategoryGuid", ()=>$6a4fff955a10b2dc$export$be5c80c4ad1faf99);
    const $6a4fff955a10b2dc$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
    const $6a4fff955a10b2dc$export$43162cfd3260b2fe = (guid)=>guid;
    const $6a4fff955a10b2dc$export$be5c80c4ad1faf99 = (guid)=>guid;
});
const $45c806b56a43da0e$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $45c806b56a43da0e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $d7e8e0de2b5415e5$export$d42203c46ecda0b5 = 'ncs';
const $d7e8e0de2b5415e5$export$22ba648868203514 = 'synchrony';
const $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c = 'JSM';
const $d7e8e0de2b5415e5$export$a40257481ddef37e = 'atlassianAccount';
const $d7e8e0de2b5415e5$export$d57b6b390e78d90f = 'jsm-nebula';
const $d7e8e0de2b5415e5$export$85314a8fbb8155e1 = 'MONTHLY';
const $d7e8e0de2b5415e5$export$d1eb58f682ad65ad = 'ANNUAL';
const $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4 = 'INACTIVE';
parcelRegister("j8qrr", function(module, exports) {
    $parcel$export(module.exports, "createCategory", ()=>$50b96e14ac428fad$export$7ce9dbcc6d544b1);
    var $7f4tk;
    const $50b96e14ac428fad$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
    const $50b96e14ac428fad$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
        const url = $50b96e14ac428fad$export$f0b37505cff627e3(projectId, activationId);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };
});
parcelRegister("dsFMC", function(module, exports) {
    $parcel$export(module.exports, "deleteCategorySuccess", ()=>$3c95377777bb5342$export$aa2eaa46022bd60b);
    const $3c95377777bb5342$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                    ]
                }
            });
        };
});
parcelRegister("aInVL", function(module, exports) {
    $parcel$export(module.exports, "publishSuccess", ()=>$7490ef4194dfdc47$export$a435a3808fe5155f);
    const $7490ef4194dfdc47$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                published: true,
                articleId: articleId,
                draftShareId: draftShareId,
                spaceKey: spaceKey
            });
        };
});
parcelRegister("3twc2", function(module, exports) {
    $parcel$export(module.exports, "savedSuccess", ()=>$7e5a4ff1e4d62f76$export$2bf589c797fe6b4f);
    const $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                closed: true,
                articleId: articleId,
                draftShareId: draftShareId
            });
        };
});
parcelRegister("klUDT", function(module, exports) {
    $parcel$export(module.exports, "fetchCategories", ()=>$1022d05f23af34ff$export$416ec9f5729de215);
    var $jcw0u;
    var $8zOmE;
    var $1d66W;
    const $1022d05f23af34ff$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: true
                }
            });
            try {
                const { categories: categories, categoriesSupported: categoriesSupported } = await (0, (0, parcelRequire("1d66W")).fetchCategories)(projectId, activationId);
                setState({
                    ...getState(),
                    categoriesData: {
                        categories: categories,
                        isCategoriesSupported: categoriesSupported,
                        isLoading: false,
                        error: null
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                    projectId: projectId
                });
            } catch (error) {
                setState({
                    ...getState(),
                    categoriesData: {
                        ...initialState.categoriesData,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'onFetchCategoriesFailure',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
            }
        };
});
parcelRegister("1d66W", function(module, exports) {
    $parcel$export(module.exports, "fetchCategories", ()=>$b7d9de4ee333d2ce$export$416ec9f5729de215);
    var $7f4tk;
    const $b7d9de4ee333d2ce$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
    const $b7d9de4ee333d2ce$export$416ec9f5729de215 = (projectId, activationId)=>{
        const url = $b7d9de4ee333d2ce$export$5cf4b2ebebe43941(projectId, activationId);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("2tTYZ", function(module, exports) {
    $parcel$export(module.exports, "fetchCreateArticlePermission", ()=>$ac71c34762d51de0$export$c5bf032e1fb1ad18);
    var $8zOmE;
    var $cVUDi;
    var $5ukFp;
    const $ac71c34762d51de0$var$EVENT_NAME = 'createPermissionsForSpace';
    const $ac71c34762d51de0$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: true
                }
            });
            try {
                const { promotedSpaces: promotedSpaces } = await (0, (0, parcelRequire("5ukFp")).getCreatePermissionsForSpace)(cloudId, spaceKeys);
                const permittedSpaces = promotedSpaces.spaces.map(({ id: id, text: text })=>({
                        spaceKey: id,
                        spaceName: text
                    }));
                setState({
                    ...initialState,
                    spacesPermitted: {
                        ...initialState.spacesPermitted,
                        isLoading: false,
                        data: permittedSpaces,
                        totalSize: promotedSpaces.spaces.length
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${$ac71c34762d51de0$var$EVENT_NAME} succedded`);
            } catch (error) {
                setState({
                    ...initialState,
                    spacesPermitted: {
                        ...initialState.spacesPermitted,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
            }
        };
});
parcelRegister("cVUDi", function(module, exports) {
    $parcel$export(module.exports, "fireErrorAnalyticsEvents", ()=>$9d8927ca77b8220f$export$b84e314c48e09c44);
    $parcel$export(module.exports, "getPageOnDelete", ()=>$9d8927ca77b8220f$export$99689dbe56145ad5);
    $parcel$export(module.exports, "fireCustomErrorAnalytics", ()=>$9d8927ca77b8220f$export$3d13cbe76aeaf5e8);
    $parcel$export(module.exports, "getViewArticleUrl", ()=>$9d8927ca77b8220f$export$4b1de73aa951498c);
    $parcel$export(module.exports, "getAllDraftsUrl", ()=>$9d8927ca77b8220f$export$939c0821a1193768);
    $parcel$export(module.exports, "getAllArticlesUrl", ()=>$9d8927ca77b8220f$export$240e98bbb8304c52);
    $parcel$export(module.exports, "getFlag", ()=>$9d8927ca77b8220f$export$a19b74191e00c5e);
    $parcel$export(module.exports, "getCommonFlagData", ()=>$9d8927ca77b8220f$export$f44d45dc3db56277);
    $parcel$export(module.exports, "filterSupportedBillingPeriod", ()=>$9d8927ca77b8220f$export$9f13ed259dc4b1bf);
    $parcel$export(module.exports, "formatTrialEndDate", ()=>$9d8927ca77b8220f$export$da56c66ce2766e02);
    var $jcw0u;
    var $jJZqs;
    var $8zOmE;
    var $fyKAM;
    const $9d8927ca77b8220f$var$TEAM_NAME = 'jsm-nebula';
    const $9d8927ca77b8220f$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
    const $9d8927ca77b8220f$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
    const $9d8927ca77b8220f$export$53ee51427129200c = (statusCode)=>$9d8927ca77b8220f$export$1a5a4674dd906e7e(statusCode) || $9d8927ca77b8220f$export$d31fd506ce75fa65(statusCode);
    const $9d8927ca77b8220f$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
        if (error && typeof error.statusCode === 'number') {
            const { statusCode: statusCode } = error;
            const lowPriorityError = statusCode >= 400 && statusCode < 500;
            const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
            const transformedError = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : new (0, (0, parcelRequire("jJZqs")).default)(statusCode);
            const errorObj = {
                error: transformedError,
                meta: {
                    id: errorMetaId,
                    packageName: packageName,
                    teamName: $9d8927ca77b8220f$var$TEAM_NAME
                },
                ...attributes && {
                    attributes: attributes
                }
            };
            (0, (0, parcelRequire("jcw0u")).default)(errorObj);
        } else (0, (0, parcelRequire("jcw0u")).default)({
            error: error instanceof Error ? error : new Error(JSON.stringify(error)),
            meta: {
                id: `${id}__JS_ERROR`,
                packageName: packageName,
                teamName: $9d8927ca77b8220f$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        });
    };
    const $9d8927ca77b8220f$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
        const lastPage = Math.ceil(updateDataSize / perPage);
        return currentPage > lastPage ? lastPage : currentPage;
    };
    const $9d8927ca77b8220f$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
        if (error && typeof error.statusCode === 'number' && !$9d8927ca77b8220f$export$53ee51427129200c(error.statusCode)) event && (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, id);
        $9d8927ca77b8220f$export$b84e314c48e09c44(error, id, packageName, attributes);
    };
    const $9d8927ca77b8220f$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
    const $9d8927ca77b8220f$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
    const $9d8927ca77b8220f$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
    const $9d8927ca77b8220f$export$a19b74191e00c5e = (title, description, flagType)=>({
            title: title,
            description: description,
            id: (0, (0, parcelRequire("fyKAM")).generateNanoId)(),
            flagType: flagType
        });
    const $9d8927ca77b8220f$export$a6125e21263de883 = (state)=>{
        const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
        const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
        const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
        const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
        const isArticleDeleted = Boolean(articleId && deleted);
        return {
            isDraftPublished: isDraftPublished,
            isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
            isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
            isArticleDeleted: isArticleDeleted
        };
    };
    const $9d8927ca77b8220f$export$f44d45dc3db56277 = (state, messages)=>{
        let flag = {
            id: '',
            title: {
                id: '',
                defaultMessage: '',
                description: ''
            },
            description: {
                id: '',
                defaultMessage: '',
                description: ''
            },
            type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
        };
        const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
        if (showConfluenceCreatePageError) {
            flag = {
                id: 'draftErrorFlag',
                title: messages.confluenceCreatePageFailureTitle,
                description: messages.confluenceCreatePageFailureDescription,
                type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
            };
            return flag;
        }
        const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $9d8927ca77b8220f$export$a6125e21263de883(state);
        if (isDraftPublished) flag = {
            id: 'draftPublishedFlag',
            title: messages.draftSuccessFlagTitle,
            description: messages.draftSuccessFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isDraftSavedWithUnpublishedChanges) flag = {
            id: 'draftSavedFlag',
            title: messages.draftSuccessSavedFlagTitle,
            description: messages.draftSuccessSavedFlagDescription || '',
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isArticleSavedWithUnpublishedChanges) flag = {
            id: 'draftPublishedFlag',
            title: messages.articleSuccessSavedFlagTitle,
            description: messages.articleSuccessSavedFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isArticleDeleted) flag = {
            id: 'articleDeletedFlag',
            title: messages.articleDeletedFlagTitle,
            description: messages.articleDeletedFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        return flag;
    };
    const $9d8927ca77b8220f$export$9f13ed259dc4b1bf = (billingPeriod)=>{
        if (billingPeriod === (0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1)) return 0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1;
        if (billingPeriod === (0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad)) return 0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad;
        return 0, $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4;
    };
    const $9d8927ca77b8220f$export$da56c66ce2766e02 = (trialEndDate)=>{
        if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
        return null;
    };
});
const $3026c2757a468eb7$export$516433e8a6db7503 = 'SUCCESS';
const $3026c2757a468eb7$export$a0a5e05447abb018 = 'WARNING';
const $3026c2757a468eb7$export$f215947b3d76a6b7 = 'ERROR';
const $3026c2757a468eb7$export$21bdd502a5302e06 = 'INFO';
parcelRegister("fyKAM", function(module, exports) {
    $parcel$export(module.exports, "generateNanoId", ()=>$ef446b866ecb6566$export$a4f5444a5996c185);
    var $9J4h7;
    const $ef446b866ecb6566$export$a4f5444a5996c185 = ()=>(0, (0, parcelRequire("9J4h7")).nanoid)(12);
    const $ef446b866ecb6566$export$e73c8bd0f20705a = ()=>(0, (0, parcelRequire("9J4h7")).nanoid)();
});
parcelRegister("9J4h7", function(module, exports) {
    $parcel$export(module.exports, "nanoid", ()=>$714ba1f43c1bc4b0$export$ac4959f4f1338dfc);
    let $714ba1f43c1bc4b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
    let $714ba1f43c1bc4b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
        let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
        let step = -~(1.6 * mask * defaultSize / alphabet.length);
        return (size = defaultSize)=>{
            let id = '';
            while(true){
                let bytes = getRandom(step);
                let j = step;
                while(j--){
                    id += alphabet[bytes[j] & mask] || '';
                    if (id.length === size) return id;
                }
            }
        };
    };
    let $714ba1f43c1bc4b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$714ba1f43c1bc4b0$export$a5cee9e955a615e5(alphabet, size, $714ba1f43c1bc4b0$export$4385e60b38654f68);
    let $714ba1f43c1bc4b0$export$ac4959f4f1338dfc = (size = 21)=>{
        let id = '';
        let bytes = crypto.getRandomValues(new Uint8Array(size));
        while(size--)id += (0, $11cc6b8f5f8db98c$export$2b646eea95309f00)[bytes[size] & 63];
        return id;
    };
});
const $11cc6b8f5f8db98c$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
parcelRegister("5ukFp", function(module, exports) {
    $parcel$export(module.exports, "getCreatePermissionsForSpace", ()=>$4d7a1d82dc21430a$export$a4d40fb662e5fd46);
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$4d7a1d82dc21430a$export$b764c9ef97480a8e);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    const $4d7a1d82dc21430a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
        const queryString = (0, $ebyGx.stringify)({
            promotedSpaceKey: spaceKeys,
            promotedSpacesLimit: spaceKeys.length,
            otherSpacesLimit: 0
        });
        return (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
    };
    const $4d7a1d82dc21430a$export$b764c9ef97480a8e = (projectKey)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);
});
parcelRegister("ik7FP", function(module, exports) {
    $parcel$export(module.exports, "fetchDraftAndNavigateToEditor", ()=>$76ec8efa1f92f234$export$e8292dc9536b9de8);
    var $dTS1V;
    var $8zOmE;
    var $cVUDi;
    var $gpe3Z;
    var $1TU0Q;
    const $76ec8efa1f92f234$var$EVENT_NAME = 'createNewConfluencePage';
    const $76ec8efa1f92f234$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            try {
                setState({
                    ...getState(),
                    isFetchingDraftDetails: true
                });
                const createContentParams = {
                    spaceKey: spaceKey,
                    parentProductContentContainerId: String(projectId),
                    parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
                    title: topicName
                };
                const { contentId: contentId, draftShareId: draftShareId } = await (0, (0, parcelRequire("dTS1V")).createContent)(createContentParams);
                setState({
                    ...getState(),
                    articleId: contentId,
                    draftShareId: draftShareId,
                    isFetchingDraftDetails: false
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${$76ec8efa1f92f234$var$EVENT_NAME} succedded`, {
                    topicId: topicId
                });
                dispatch((0, (0, parcelRequire("1TU0Q")).setRedirectionData)({
                    onCloseRedirectUrl: onCloseRedirectUrl,
                    onPublishRedirectUrl: onPublishRedirectUrl
                }));
                dispatch((0, (0, parcelRequire("gpe3Z")).navigateCreateDraftRoute)({
                    routerActions: routerActions,
                    projectKey: projectKey,
                    topicId: topicId,
                    selectedSpaceKey: spaceKey
                }));
            } catch (error) {
                setState({
                    ...getState(),
                    isFetchingDraftDetails: false,
                    showConfluenceCreatePageError: true
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, $76ec8efa1f92f234$var$EVENT_NAME, 'knowledgeCommon');
            }
        };
});
parcelRegister("dTS1V", function(module, exports) {
    $parcel$export(module.exports, "createContent", ()=>$2144a235c2b8fe30$export$41c7a4cacf5bab80);
    var $eeFBS;
    const $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
        'parentProduct',
        'parentProductContentContainerId',
        'spaceKey'
    ];
    const $2144a235c2b8fe30$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
    const $2144a235c2b8fe30$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
        const payload = {
            type: 'page',
            status: 'draft',
            metadata: {
                properties: {
                    editor: {
                        value: 'v2'
                    }
                },
                frontend: {
                    embedded: true
                }
            },
            space: {
                key: spaceKey
            },
            title: title,
            body: body
        };
        if (parentPageId) payload.ancestors = [
            {
                id: parentPageId
            }
        ];
        const baseurl = domain ? `https://${domain}` : domain;
        const unlicensedAccessHeader = $2144a235c2b8fe30$var$getUnlicensedAccessHeader({
            parentProduct: parentProduct,
            parentProductContentContainerId: parentProductContentContainerId,
            spaceKey: spaceKey
        });
        let response;
        try {
            response = await fetch(`${baseurl}/wiki/rest/api/content`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    credentials: 'include',
                    ...unlicensedAccessHeader
                },
                body: JSON.stringify(payload)
            });
        } catch (e) {
            throw new Error(`Network failure ${e}`);
        }
        const responseJson = await response.json();
        if (!response.ok) throw new (0, (0, parcelRequire("eeFBS")).CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
        return {
            draftShareId: $2144a235c2b8fe30$var$getDraftShareId(responseJson),
            spaceKey: responseJson?.space?.key,
            contentId: responseJson?.id,
            status: responseJson?.status,
            subType: responseJson?.subType
        };
    };
    const $2144a235c2b8fe30$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
    const $2144a235c2b8fe30$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
        const headerValue = {
            parentProduct: parentProduct,
            parentProductContentContainerId: parentProductContentContainerId,
            spaceKey: spaceKey
        };
        const isValidHeader = $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
        return isValidHeader ? {
            [$2144a235c2b8fe30$export$4de094b68e927f31]: JSON.stringify(headerValue)
        } : undefined;
    };
});
parcelRegister("eeFBS", function(module, exports) {
    $parcel$export(module.exports, "CreateError", ()=>$5ee25365aafd3194$export$91ee1703d5a5ab8b);
    class $5ee25365aafd3194$export$91ee1703d5a5ab8b extends Error {
        constructor(message, statusCode){
            super(message);
            this.statusCode = statusCode;
        }
    }
});
parcelRegister("gpe3Z", function(module, exports) {
    $parcel$export(module.exports, "navigateCreateDraftRoute", ()=>$4f804a011e2794bb$export$4e7c7ad076f5f5fc);
    var $6udl5;
    const $4f804a011e2794bb$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey, topicId: topicId })=>async ({ getState: getState })=>{
            const { articleId: articleId, draftShareId: draftShareId } = {
                ...getState()
            };
            const EDIT_DRAFT_ROUTE = (0, (0, parcelRequire("6udl5")).getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId);
            routerActions.push(EDIT_DRAFT_ROUTE);
        };
});
parcelRegister("6udl5", function(module, exports) {
    $parcel$export(module.exports, "getDraftEditUrl", ()=>$ed1cffe35d42c3de$export$5e8433ae3ce7c696);
    $parcel$export(module.exports, "isDraftCreatedWithNCS", ()=>$ed1cffe35d42c3de$export$fc0fa1dc4749f854);
    $parcel$export(module.exports, "findCategory", ()=>$ed1cffe35d42c3de$export$93e9d221203aed67);
    const $ed1cffe35d42c3de$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId)=>{
        let draftEditUrl = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
        if (topicId) draftEditUrl += `&topicId=${topicId}`;
        return draftEditUrl;
    };
    const $ed1cffe35d42c3de$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $d7e8e0de2b5415e5$export$d42203c46ecda0b5);
    const $ed1cffe35d42c3de$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
        if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
        return undefined;
    };
});
parcelRegister("1TU0Q", function(module, exports) {
    $parcel$export(module.exports, "setRedirectionData", ()=>$35239289cee1669b$export$c026d4a8850c302d);
    $parcel$export(module.exports, "resetRedirectionData", ()=>$35239289cee1669b$export$7c6d6762f8b5b4db);
    const $35239289cee1669b$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                redirectionData: redirectionData
            });
        };
    const $35239289cee1669b$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                redirectionData: {
                    onPublishRedirectUrl: '',
                    onCloseRedirectUrl: ''
                }
            });
        };
});
parcelRegister("dAXEk", function(module, exports) {
    $parcel$export(module.exports, "fetchLinkedSpaces", ()=>$1976703425aa0479$export$1999596e4ea30c16);
    var $5ukFp;
    const $1976703425aa0479$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("5ukFp")).getLinkedSpaces)(projectKey);
                const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                        spaceKey: spaceKey,
                        spaceName: spaceName
                    }));
                setState({
                    ...initialState,
                    linkedSpaces: {
                        ...initialState.linkedSpaces,
                        isLoading: false,
                        data: linkedSpaces,
                        totalSize: linkedSpaces.length
                    }
                });
            } catch (error) {
                setState({
                    ...initialState,
                    linkedSpaces: {
                        ...initialState.linkedSpaces,
                        isLoading: false,
                        error: error
                    }
                });
            }
        };
});
parcelRegister("dIiIO", function(module, exports) {
    $parcel$export(module.exports, "fetchUserCapabilities", ()=>$c701340a34445280$export$d1eac56717011ed4);
    var $8zOmE;
    var $cVUDi;
    var $8FVnr;
    const $c701340a34445280$var$EVENT_NAME = 'fetchUserCapabilities';
    const $c701340a34445280$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: true
                }
            });
            try {
                const data = await (0, (0, parcelRequire("8FVnr")).fetchUserCapabilities)(projectId, activationId);
                setState({
                    ...getState(),
                    userCapabilities: {
                        ...initialState.userCapabilities,
                        isLoading: false,
                        data: data,
                        error: null
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${$c701340a34445280$var$EVENT_NAME} succeeded`);
            } catch (error) {
                setState({
                    ...getState(),
                    userCapabilities: {
                        ...initialState.userCapabilities,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, `${$c701340a34445280$var$EVENT_NAME} failed`, 'knowledgeCommon');
            }
        };
});
parcelRegister("8FVnr", function(module, exports) {
    $parcel$export(module.exports, "fetchUserCapabilities", ()=>$11ef201d32e47a4e$export$d1eac56717011ed4);
    var $7f4tk;
    const $11ef201d32e47a4e$export$d1eac56717011ed4 = (projectId, activationId)=>{
        const url = `${(0, $45c806b56a43da0e$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("jIuZj", function(module, exports) {
    $parcel$export(module.exports, "removeCommonFlag", ()=>$3807c62af5ab354f$export$a2af96a4f99f3900);
    const $3807c62af5ab354f$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
            const { flags: currentFlags } = getState();
            const flags = currentFlags.filter(({ id: id })=>id !== flagId);
            setState({
                ...getState(),
                flags: flags
            });
        };
});
parcelRegister("eP4xZ", function(module, exports) {
    $parcel$export(module.exports, "reorderCategories", ()=>$d1c7d54ec7e0876f$export$32f957e287d37daa);
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $8zOmE;
    var $261Bl;
    var $1wnS6;
    const $d1c7d54ec7e0876f$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
        const newCategories = [
            ...categories
        ];
        const movedItem = newCategories.splice(fromIndex, 1)[0];
        if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
        return newCategories;
    };
    const $d1c7d54ec7e0876f$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
            const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
            const initiallyOrderedCategories = [
                ...getState().categoriesData.categories
            ];
            const newlyOrderedCategories = $d1c7d54ec7e0876f$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: newlyOrderedCategories
                }
            });
            try {
                const { categories: categories } = await (0, (0, parcelRequire("1wnS6")).orderCategories)({
                    projectId: projectId,
                    activationId: activationId,
                    categories: [
                        {
                            categoryId: categoryToBeMovedId,
                            order: toIndex
                        }
                    ]
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                    id: (0, (0, parcelRequire("261Bl")).categoryGuidToString)(categoryToBeMovedId)
                });
                const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
                const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
                if (!(0, ($parcel$interopDefault($ajpes)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                    setState({
                        ...getState(),
                        categoriesData: {
                            ...getState().categoriesData,
                            categories: categories
                        }
                    });
                    onReorderMismatch();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'reorderCategories',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: [
                            ...initiallyOrderedCategories
                        ]
                    }
                });
                onReorderFailure();
            }
        };
});
parcelRegister("261Bl", function(module, exports) {
    $parcel$export(module.exports, "categoryGuidToString", ()=>$21d0c574129f0705$export$43162cfd3260b2fe);
    $parcel$export(module.exports, "toCategoryGuid", ()=>$21d0c574129f0705$export$be5c80c4ad1faf99);
    const $21d0c574129f0705$export$43162cfd3260b2fe = (guid)=>guid;
    const $21d0c574129f0705$export$be5c80c4ad1faf99 = (guid)=>guid;
});
parcelRegister("1wnS6", function(module, exports) {
    $parcel$export(module.exports, "orderCategories", ()=>$56b61b6811b7fda7$export$e90b3dc42a0ddf96);
    var $7f4tk;
    const $56b61b6811b7fda7$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'PUT',
            body: JSON.stringify(categories)
        });
    };
});
parcelRegister("8QyFO", function(module, exports) {
    $parcel$export(module.exports, "resetDraftArticleData", ()=>$c895191ddea664b2$export$e4dbf2710e8c685d);
    const $c895191ddea664b2$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                draftShareId: '',
                closed: false,
                published: false,
                showConfluenceCreatePageError: false,
                spaceKey: '',
                ...resetDelete && {
                    deleted: false,
                    articleId: ''
                }
            });
        };
});
parcelRegister("1VmcQ", function(module, exports) {
    $parcel$export(module.exports, "updateCategorySuccess", ()=>$10ef8418d41dbca6$export$7d46e556893bba77);
    const $10ef8418d41dbca6$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
                }
            });
        };
});
parcelRegister("cSB1I", function(module, exports) {
    $parcel$export(module.exports, "getDraftShareId", ()=>$b10361f0e26ced23$export$f31b9480a5e4fdcf);
    $parcel$export(module.exports, "getArticleId", ()=>$b10361f0e26ced23$export$2d21c0faccc1d33f);
    $parcel$export(module.exports, "getIsFetchingDraftDetails", ()=>$b10361f0e26ced23$export$19d926b900e1c065);
    $parcel$export(module.exports, "getRedirectionData", ()=>$b10361f0e26ced23$export$fdde4bb390e025db);
    $parcel$export(module.exports, "getPermittedSpaces", ()=>$b10361f0e26ced23$export$4a419b2d3bb6a3fc);
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$b10361f0e26ced23$export$b764c9ef97480a8e);
    $parcel$export(module.exports, "getUserCapabilities", ()=>$b10361f0e26ced23$export$f7db3ef62579b328);
    $parcel$export(module.exports, "getCategoriesData", ()=>$b10361f0e26ced23$export$b416461ac52d8504);
    $parcel$export(module.exports, "getCreateCategoryData", ()=>$b10361f0e26ced23$export$e0cf4a4b69bbc694);
    $parcel$export(module.exports, "getCategory", ()=>$b10361f0e26ced23$export$410364bbb673ddbc);
    $parcel$export(module.exports, "getCommonFlags", ()=>$b10361f0e26ced23$export$b94d9d28300025a9);
    $parcel$export(module.exports, "getKnowledgeCommonFlags", ()=>$b10361f0e26ced23$export$1a5b9662b382779c);
    var $cVUDi;
    var $6udl5;
    const $b10361f0e26ced23$export$c9cab98530df1a79 = ({ published: published })=>published;
    const $b10361f0e26ced23$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
    const $b10361f0e26ced23$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
    const $b10361f0e26ced23$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
    const $b10361f0e26ced23$export$fdde4bb390e025db = (state)=>state.redirectionData;
    const $b10361f0e26ced23$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
    const $b10361f0e26ced23$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
    const $b10361f0e26ced23$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
    const $b10361f0e26ced23$export$b416461ac52d8504 = (state)=>state.categoriesData;
    const $b10361f0e26ced23$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
    const $b10361f0e26ced23$export$410364bbb673ddbc = (state, categoryId)=>(0, (0, parcelRequire("6udl5")).findCategory)(state.categoriesData, categoryId);
    const $b10361f0e26ced23$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
    const $b10361f0e26ced23$export$1a5b9662b382779c = (state, messages)=>(0, (0, parcelRequire("cVUDi")).getCommonFlagData)({
            ...state
        }, messages);
});
parcelRegister("ghVG7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$271aace1fac64940$export$2e2bcd8739ae039);
    var $8RXs9;
    var $bC2fB;
    var $gLt7z;
    var $ealBh;
    const $271aace1fac64940$var$mapStateToProps = (state)=>({
            projectKey: (0, (0, parcelRequire("gLt7z")).getProjectKey)(state),
            baseUrl: (0, (0, parcelRequire("gLt7z")).getBaseUrl)(state)
        });
    var $271aace1fac64940$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($271aace1fac64940$var$mapStateToProps, {})((0, (0, parcelRequire("8RXs9")).default)((0, (0, parcelRequire("ealBh")).default)));
});
parcelRegister("gLt7z", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$5ee05ac4f84233bf$export$f654b28f82155665);
    $parcel$export(module.exports, "getLocale", ()=>$5ee05ac4f84233bf$export$180605366c04f0cd);
    $parcel$export(module.exports, "getProjectKey", ()=>$5ee05ac4f84233bf$export$667f2a0f99c75faa);
    $parcel$export(module.exports, "getProjectId", ()=>$5ee05ac4f84233bf$export$89040d072f281f85);
    $parcel$export(module.exports, "getIsProjectSimplified", ()=>$5ee05ac4f84233bf$export$5bde43fbba6edf90);
    $parcel$export(module.exports, "getIsAdmin", ()=>$5ee05ac4f84233bf$export$7d046765d192af80);
    $parcel$export(module.exports, "getActivationId", ()=>$5ee05ac4f84233bf$export$3ad4bb31a1816ff6);
    $parcel$export(module.exports, "getCloudId", ()=>$5ee05ac4f84233bf$export$fdd2c0ba94025c3c);
    const $5ee05ac4f84233bf$export$f654b28f82155665 = (_)=>'';
    const $5ee05ac4f84233bf$export$180605366c04f0cd = (state)=>state.app.locale;
    const $5ee05ac4f84233bf$export$667f2a0f99c75faa = (state)=>state.app.projectKey;
    const $5ee05ac4f84233bf$export$89040d072f281f85 = (state)=>state.app.projectId;
    const $5ee05ac4f84233bf$export$5bde43fbba6edf90 = (state)=>state.app.isProjectSimplified;
    const $5ee05ac4f84233bf$export$7d046765d192af80 = (state)=>state.app.isAdmin;
    const $5ee05ac4f84233bf$export$3ad4bb31a1816ff6 = (state)=>state.app.activationId;
    const $5ee05ac4f84233bf$export$fdd2c0ba94025c3c = (state)=>state.app.cloudId;
});
parcelRegister("ealBh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7526018970629bef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $jbwMx;
    class $7526018970629bef$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        renderKnowledgeBaseBreadcrumb() {
            const { children: children, baseUrl: baseUrl, projectKey: projectKey, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: {
                    href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge`,
                    text: formatMessage((0, (0, parcelRequire("jbwMx")).default).knowledgeBase),
                    type: 'jsd-knowledge-base'
                }
            }, children);
        }
        render() {
            return this.renderKnowledgeBaseBreadcrumb();
        }
    }
});
parcelRegister("jbwMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7699cc1a8f21589$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7699cc1a8f21589$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        articlesPageHeader: {
            "id": "servicedesk.knowledge-hub.common.i18n.articles-page-header",
            "defaultMessage": "Articles"
        },
        knowledgeBase: {
            "id": "servicedesk.knowledge-hub.common.i18n.knowledge-base",
            "defaultMessage": "Knowledge base"
        },
        noCategoryText: {
            "id": "servicedesk.knowledge-hub.common.i18n.no-category-text",
            "defaultMessage": "Uncategorized"
        },
        editInConfluence: {
            "id": "servicedesk.knowledge-hub.common.i18n.edit-in-confluence",
            "defaultMessage": "Edit in Confluence"
        }
    });
});
parcelRegister("epm3G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9aa860c7f19dc37d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $8QpSo;
    var $cb25w;
    var $9tOEo;
    var $jzjy1;
    var $iQv12;
    var $bC2fB;
    var $6z7Gx;
    var $akqdW;
    var $l1emQ;
    var $kHzxc;
    var $gMZw6;
    var $goH2j;
    var $fCYod;
    var $gXg4u;
    var $gLt7z;
    var $fhG9v;
    var $knU3A;
    var $k5cJw;
    var $z7Rc8;
    var $kpAEt;
    var $l7HvK;
    var $6oq8N;
    var $eyGOx;
    const $9aa860c7f19dc37d$var$KnowledgeHubBrowseAllArticlesWithPush = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("akqdW")).default), null, ({ push: push })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eyGOx")).default), {
                ...props,
                push: push
            }));
    const $9aa860c7f19dc37d$var$withRouterPush = (0, (0, parcelRequire("l1emQ")).withRouter)($9aa860c7f19dc37d$var$KnowledgeHubBrowseAllArticlesWithPush);
    const $9aa860c7f19dc37d$var$mapStateToPropsFactory = ()=>{
        const spaceKeysFactory = (0, (0, parcelRequire("8QpSo")).default)((spaceKey)=>spaceKey ? JSON.parse(spaceKey) : {});
        const articlesPageFactory = (0, (0, parcelRequire("8QpSo")).default)((state, articleIds)=>({
                totalSize: (0, (0, parcelRequire("fhG9v")).getCategoryTotalSize)(state, 'all-articles'),
                articles: (0, (0, parcelRequire("gXg4u")).getArticlesByIds)(state, articleIds).reduce((acc, curr)=>curr.error ? acc : [
                        ...acc,
                        curr
                    ], [])
            }));
        return (state, ownProps)=>{
            const page = (0, (0, parcelRequire("6oq8N")).default)(ownProps.page, 1);
            const { cursor: cursor } = ownProps;
            const sortBy = ownProps.sortBy ?? '-lastModified';
            const searchQuery = ownProps.searchQuery ? ownProps.searchQuery : '';
            const spaceKeys = spaceKeysFactory(ownProps.spaceKey);
            const articleIds = (0, (0, parcelRequire("fhG9v")).getArticleIdsForCategory)(state, 'all-articles', page);
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(state);
            let error;
            let articlesPage;
            if (!articleIds) articlesPage = undefined;
            else if (articleIds.error && !Array.isArray(articleIds)) error = articleIds;
            else articlesPage = articlesPageFactory(state, articleIds);
            return {
                appLinkOrError: (0, (0, parcelRequire("fCYod")).getAppLinkOrError)(state),
                linkedState: (0, (0, parcelRequire("knU3A")).getHubLinkedState)(state),
                spaceKey: (0, (0, parcelRequire("knU3A")).getLinkedConfluenceSpace)(state),
                confluenceUrl: (0, (0, parcelRequire("knU3A")).getLinkedConfluenceUrl)(state),
                limit: (0, (0, parcelRequire("fhG9v")).getBrowseLimit)(state),
                isLoading: (0, (0, parcelRequire("fhG9v")).isBrowseLoading)(state, 'all-articles'),
                categoriesSupported: (0, (0, parcelRequire("fhG9v")).isCategoriesSupported)(state, 'all-articles'),
                page: page,
                sortBy: sortBy,
                error: error,
                articlesPage: articlesPage,
                ReadyForUser: (0, parcelRequire("z7Rc8")).default,
                activationId: activationId,
                SearchKnowledgeInline: (0, parcelRequire("kpAEt")).default,
                ArticlesTable: (0, (0, parcelRequire("l7HvK")).default),
                projectId: (0, (0, parcelRequire("gLt7z")).getProjectId)(state),
                projectKey: (0, (0, parcelRequire("gLt7z")).getProjectKey)(state),
                linkedSpaces: (0, (0, parcelRequire("k5cJw")).getLinkedSpaces)(state),
                cursor: cursor,
                searchQuery: searchQuery,
                spaceKeys: spaceKeys,
                prevCursor: (0, (0, parcelRequire("fhG9v")).getBrowsePrevCursor)(state, 'all-articles'),
                nextCursor: (0, (0, parcelRequire("fhG9v")).getBrowseNextCursor)(state, 'all-articles'),
                isAdmin: (0, (0, parcelRequire("gLt7z")).getIsAdmin)(state)
            };
        };
    };
    var $9aa860c7f19dc37d$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))([
        (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('knowledgeBrowseAllArticles', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)),
        (0, (0, parcelRequire("9tOEo")).default)({
            attributes: {
                context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }),
        (0, (0, parcelRequire("cb25w")).default)(),
        (0, (0, parcelRequire("iQv12")).default)({
            onCreateArticleHeaderClicked: 'createArticleHeaderLink',
            onCreateArticleEmptyStateClicked: 'createArticleEmptyStateLink'
        }),
        (0, (0, parcelRequire("bC2fB")).connect)($9aa860c7f19dc37d$var$mapStateToPropsFactory, {
            onBrowseArticles: (0, (0, parcelRequire("kHzxc")).browseKnowledge),
            getLinkedSpaces: (0, (0, parcelRequire("goH2j")).fetchLinkedSpaces),
            onFetchAppLink: (0, (0, parcelRequire("gMZw6")).fetchAppLink)
        })
    ])($9aa860c7f19dc37d$var$withRouterPush);
});
parcelRegister("9tOEo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d2220d181f8eca1$export$2e2bcd8739ae039);
    var $994MI;
    var $i4iBk;
    var $0d2220d181f8eca1$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)((0, (0, parcelRequire("i4iBk")).default)(payload))(WrappedComponent);
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("6z7Gx", function(module, exports) {
    $parcel$export(module.exports, "ANALYTIC_CONTEXTS", ()=>$c0766aa675d05766$export$ca021921d5c56515);
    $parcel$export(module.exports, "ttiRecommendedSlo", ()=>$c0766aa675d05766$export$dc391c7d81907d3a);
    $parcel$export(module.exports, "trackJsdFetchErrors", ()=>$c0766aa675d05766$export$ebdbd98df5a27905);
    var $jcw0u;
    var $a7EYT;
    const $c0766aa675d05766$export$ca021921d5c56515 = {
        AUTOMATION_SETTINGS: 'AutomationSettings',
        KNOWLEDGE: 'Knowledge',
        QUEUES: 'Queues',
        CSAT: 'Csat'
    };
    const $c0766aa675d05766$export$cca3c4e11cb0a5ce = 1000;
    const $c0766aa675d05766$export$dc391c7d81907d3a = 4000;
    const $c0766aa675d05766$export$ebdbd98df5a27905 = async (payload)=>{
        const { error: error, attributes: attributes } = payload;
        if (error instanceof (0, (0, parcelRequire("a7EYT")).JsdFetchError)) {
            const { reasonKey: reasonKey } = error;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                ...payload,
                attributes: {
                    ...attributes,
                    reasonKey: reasonKey
                }
            });
            return;
        }
        (0, (0, parcelRequire("jcw0u")).trackFetchErrors)(payload);
    };
});
parcelRegister("a7EYT", function(module, exports) {
    $parcel$export(module.exports, "JsdFetchError", ()=>$99def0fa5fc488a1$export$fee0012ae6cb3438);
    $parcel$export(module.exports, "performGetRequest", ()=>$99def0fa5fc488a1$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$99def0fa5fc488a1$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$99def0fa5fc488a1$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$99def0fa5fc488a1$export$8ef51cba9d28f819);
    var $gccSB = parcelRequire("gccSB");
    var $cjFoH = parcelRequire("cjFoH");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $eusud;
    const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
    class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, (0, parcelRequire("jJZqs")).default) {
        constructor(statusCode, message, reasonKey, response){
            super(statusCode, (0, ($parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
            this.name = 'JsdFetchError';
            if (!(0, ($parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
            if (!(0, ($parcel$interopDefault($cjFoH)))(response)) this.response = response;
        }
    }
    const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
            messages.push(errorMessage);
            return messages;
        }, []).join(' ');
    const $99def0fa5fc488a1$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $99def0fa5fc488a1$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $99def0fa5fc488a1$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $99def0fa5fc488a1$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $99def0fa5fc488a1$var$processResponse = async (response)=>{
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
            const jsonResponse = await response.json();
            const { errors: errors, reasonKey: reasonKey } = jsonResponse;
            if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, (0, parcelRequire("eusud")).transformValidationErrorFromServer)(jsonResponse);
            const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
            throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
        }
        if (!response.ok) {
            const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
        }
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$putOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$postOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$deleteOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$patchOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("akqdW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32e0f2e289decb82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5y0F0;
    var $jDDFr;
    const $32e0f2e289decb82$var$pushWithSpaCompatibleUrl = (push, projectKey)=>(path)=>{
            push(`/jira/servicedesk/projects/${projectKey}${path.charAt(0) === '/' ? `${path}` : `/${path}`}`);
        };
    const $32e0f2e289decb82$var$KnowledgeHubPushProvider = (props)=>{
        const { RouterActions: RouterActions, RouterSubscriber: RouterSubscriber, children: children } = props;
        return __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement(RouterActions, null, ({ push: push })=>(0, ($parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match?.params?.projectKey ? children({
                    push: $32e0f2e289decb82$var$pushWithSpaCompatibleUrl(push, match.params.projectKey)
                }) : children({
                    push: undefined
                }))) : children({
            push: undefined
        });
    };
    $32e0f2e289decb82$var$KnowledgeHubPushProvider.defaultProps = {
        RouterActions: (0, (0, parcelRequire("5y0F0")).RouterActions),
        RouterSubscriber: (0, (0, parcelRequire("jDDFr")).RouterSubscriber)
    };
    var $32e0f2e289decb82$export$2e2bcd8739ae039 = $32e0f2e289decb82$var$KnowledgeHubPushProvider;
});
parcelRegister("l1emQ", function(module, exports) {
    $parcel$export(module.exports, "withRouter", ()=>$a6b74978c4f20eda$export$369b6b2b30582e8e);
    var $EYDed;
    var $1bQGJ;
    const $a6b74978c4f20eda$export$369b6b2b30582e8e = (WrappedComponent)=>__SPA__ ? (0, (0, parcelRequire("1bQGJ")).withRouter)(WrappedComponent) : (0, (0, parcelRequire("EYDed")).default)(WrappedComponent);
});
parcelRegister("EYDed", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07b2c4bc94d9b7fd$export$2e2bcd8739ae039);
    var $flKR9;
    var $07b2c4bc94d9b7fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("flKR9")).default);
});
parcelRegister("flKR9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2cd29d7e6963c56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $bsYC3 = parcelRequire("bsYC3");
    var $e0XoQ;
    var $b2cd29d7e6963c56$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $b2cd29d7e6963c56$var$_objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    var $b2cd29d7e6963c56$var$withRouter = function withRouter(Component) {
        var C = function C(props) {
            var wrappedComponentRef = props.wrappedComponentRef, remainingProps = $b2cd29d7e6963c56$var$_objectWithoutProperties(props, [
                "wrappedComponentRef"
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0XoQ")).default), {
                children: function children(routeComponentProps) {
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, $b2cd29d7e6963c56$var$_extends({}, remainingProps, routeComponentProps, {
                        ref: wrappedComponentRef
                    }));
                }
            });
        };
        C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
        C.WrappedComponent = Component;
        C.propTypes = {
            wrappedComponentRef: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func
        };
        return (0, ($parcel$interopDefault($bsYC3)))(C, Component);
    };
    var $b2cd29d7e6963c56$export$2e2bcd8739ae039 = $b2cd29d7e6963c56$var$withRouter;
});
parcelRegister("bsYC3", function(module, exports) {
    'use strict';
    var $859153a97cf95ca0$var$REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    var $859153a97cf95ca0$var$KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    var $859153a97cf95ca0$var$defineProperty = Object.defineProperty;
    var $859153a97cf95ca0$var$getOwnPropertyNames = Object.getOwnPropertyNames;
    var $859153a97cf95ca0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var $859153a97cf95ca0$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var $859153a97cf95ca0$var$getPrototypeOf = Object.getPrototypeOf;
    var $859153a97cf95ca0$var$objectPrototype = $859153a97cf95ca0$var$getPrototypeOf && $859153a97cf95ca0$var$getPrototypeOf(Object);
    function $859153a97cf95ca0$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
            if ($859153a97cf95ca0$var$objectPrototype) {
                var inheritedComponent = $859153a97cf95ca0$var$getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== $859153a97cf95ca0$var$objectPrototype) $859153a97cf95ca0$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
            var keys = $859153a97cf95ca0$var$getOwnPropertyNames(sourceComponent);
            if ($859153a97cf95ca0$var$getOwnPropertySymbols) keys = keys.concat($859153a97cf95ca0$var$getOwnPropertySymbols(sourceComponent));
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                if (!$859153a97cf95ca0$var$REACT_STATICS[key] && !$859153a97cf95ca0$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = $859153a97cf95ca0$var$getOwnPropertyDescriptor(sourceComponent, key);
                    try {
                        $859153a97cf95ca0$var$defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            return targetComponent;
        }
        return targetComponent;
    }
    module.exports = $859153a97cf95ca0$var$hoistNonReactStatics;
});
parcelRegister("e0XoQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a33f2454f0f795a6$export$2e2bcd8739ae039);
    var $hBYjV = parcelRequire("hBYjV");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $70VoX;
    var $a33f2454f0f795a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $a33f2454f0f795a6$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $a33f2454f0f795a6$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $a33f2454f0f795a6$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $a33f2454f0f795a6$var$isEmptyChildren = function isEmptyChildren(children) {
        return (0, ($parcel$interopDefault($5uXOq))).Children.count(children) === 0;
    };
    var $a33f2454f0f795a6$var$Route = function(_React$Component) {
        $a33f2454f0f795a6$var$_inherits(Route, _React$Component);
        function Route() {
            var _temp, _this, _ret;
            $a33f2454f0f795a6$var$_classCallCheck(this, Route);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a33f2454f0f795a6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = {
                match: _this.computeMatch(_this.props, _this.context.router)
            }, _temp), $a33f2454f0f795a6$var$_possibleConstructorReturn(_this, _ret);
        }
        Route.prototype.getChildContext = function getChildContext() {
            return {
                router: $a33f2454f0f795a6$var$_extends({}, this.context.router, {
                    route: {
                        location: this.props.location || this.context.router.route.location,
                        match: this.state.match
                    }
                })
            };
        };
        Route.prototype.computeMatch = function computeMatch(_ref, router) {
            var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
            if (computedMatch) return computedMatch;
            (0, ($parcel$interopDefault($aE1Lc)))(router, "You should not use <Route> or withRouter() outside a <Router>");
            var route = router.route;
            var pathname = (location || route.location).pathname;
            return (0, (0, parcelRequire("70VoX")).default)(pathname, {
                path: path,
                strict: strict,
                exact: exact,
                sensitive: sensitive
            }, route.match);
        };
        Route.prototype.componentWillMount = function componentWillMount() {
            (0, ($parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
            (0, ($parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
            (0, ($parcel$interopDefault($hBYjV)))(!(this.props.render && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
        };
        Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
            (0, ($parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
            (0, ($parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
            this.setState({
                match: this.computeMatch(nextProps, nextContext.router)
            });
        };
        Route.prototype.render = function render() {
            var match = this.state.match;
            var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
            var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
            var location = this.props.location || route.location;
            var props = {
                match: match,
                location: location,
                history: history,
                staticContext: staticContext
            };
            if (component) return match ? (0, ($parcel$interopDefault($5uXOq))).createElement(component, props) : null;
            if (render) return match ? render(props) : null;
            if (typeof children === "function") return children(props);
            if (children && !$a33f2454f0f795a6$var$isEmptyChildren(children)) return (0, ($parcel$interopDefault($5uXOq))).Children.only(children);
            return null;
        };
        return Route;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $a33f2454f0f795a6$var$Route.propTypes = {
        computedMatch: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object,
        path: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        exact: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        strict: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        sensitive: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        component: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        render: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        children: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).node
        ]),
        location: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
    };
    $a33f2454f0f795a6$var$Route.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            history: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired,
            route: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired,
            staticContext: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
        })
    };
    $a33f2454f0f795a6$var$Route.childContextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object.isRequired
    };
    var $a33f2454f0f795a6$export$2e2bcd8739ae039 = $a33f2454f0f795a6$var$Route;
});
parcelRegister("kHzxc", function(module, exports) {
    $parcel$export(module.exports, "BROWSE_KNOWLEDGE", ()=>$e17bf0108bb950f1$export$8b6d2338550bad51);
    $parcel$export(module.exports, "browseKnowledge", ()=>$e17bf0108bb950f1$export$66132e21cee3da17);
    const $e17bf0108bb950f1$export$8b6d2338550bad51 = 'state.actions.browse-knowledge.BROWSE_KNOWLEDGE';
    const $e17bf0108bb950f1$export$66132e21cee3da17 = (payload)=>({
            type: $e17bf0108bb950f1$export$8b6d2338550bad51,
            payload: payload
        });
});
parcelRegister("gMZw6", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINK", ()=>$ed5b7c76bdf86da2$export$da6ab0fd0c34565f);
    $parcel$export(module.exports, "fetchAppLink", ()=>$ed5b7c76bdf86da2$export$6bb78bb661cf0859);
    const $ed5b7c76bdf86da2$export$da6ab0fd0c34565f = 'state.actions.fetch-applink.FETCH_APPLINK';
    const $ed5b7c76bdf86da2$export$6bb78bb661cf0859 = ()=>({
            type: $ed5b7c76bdf86da2$export$da6ab0fd0c34565f
        });
});
parcelRegister("goH2j", function(module, exports) {
    $parcel$export(module.exports, "FETCH_LINKED_SPACES", ()=>$c793be7dffec599b$export$3d78263a729bb91);
    $parcel$export(module.exports, "fetchLinkedSpaces", ()=>$c793be7dffec599b$export$1999596e4ea30c16);
    const $c793be7dffec599b$export$3d78263a729bb91 = 'state.actions.fetch-linked-spaces.FETCH_LINKED_SPACES';
    const $c793be7dffec599b$export$1999596e4ea30c16 = (payload)=>({
            type: $c793be7dffec599b$export$3d78263a729bb91,
            payload: payload
        });
});
parcelRegister("fCYod", function(module, exports) {
    $parcel$export(module.exports, "getAppLinkState", ()=>$681898a3e978aa85$export$5017a5295f2c0e75);
    $parcel$export(module.exports, "getAppLinkOrError", ()=>$681898a3e978aa85$export$f313f4d9202e0f4e);
    const $681898a3e978aa85$export$5017a5295f2c0e75 = (state)=>state.entities.appLink;
    const $681898a3e978aa85$export$7d919ca1f3c09dd = (state)=>state.entities.appLink?.appLink;
    const $681898a3e978aa85$export$56510b4953c6542b = (state)=>state.entities.appLink?.isLoaded || false;
    const $681898a3e978aa85$export$f313f4d9202e0f4e = (state)=>{
        const { isLoaded: isLoaded, error: error, appLink: appLink } = state.entities.appLink || {};
        if (isLoaded && appLink) return appLink;
        if (error) return {
            error: error
        };
        return undefined;
    };
});
parcelRegister("gXg4u", function(module, exports) {
    $parcel$export(module.exports, "getFeaturedInCategoryIds", ()=>$daacc015e0475ec6$export$413b305383a0e001);
    $parcel$export(module.exports, "getArticle", ()=>$daacc015e0475ec6$export$f8c0d0a39b0d7d4e);
    $parcel$export(module.exports, "getCategoriesForArticle", ()=>$daacc015e0475ec6$export$458f158173f65de8);
    $parcel$export(module.exports, "getCategoriesForArticleBulkUpdate", ()=>$daacc015e0475ec6$export$360e12e07ffc1cb0);
    $parcel$export(module.exports, "getArticlesByIds", ()=>$daacc015e0475ec6$export$ba941551d0dc160c);
    $parcel$export(module.exports, "getIsShowingBulkCategoryAdder", ()=>$daacc015e0475ec6$export$483e222b9f194c8a);
    $parcel$export(module.exports, "getCategoriesInBulkCategoryAdder", ()=>$daacc015e0475ec6$export$d1f02a9ddd87bcc6);
    $parcel$export(module.exports, "getSpaceKeyForArticle", ()=>$daacc015e0475ec6$export$ccf898e36d51a9bc);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $7qDUb = parcelRequire("7qDUb");
    var $5fBrW;
    const $daacc015e0475ec6$export$413b305383a0e001 = (state, articleId)=>state.entities.articles[articleId] && state.entities.articles[articleId].featuredInCategories && state.entities.articles[articleId].featuredInCategories;
    const $daacc015e0475ec6$var$getArticleCategories = (allCategories, article)=>{
        if (article.categories) {
            const categories = article.categories.map((categoryId)=>allCategories.categories.find((category)=>category.id === categoryId)).filter(Boolean);
            const featuredInCategoryIds = article.featuredInCategories || [];
            if (featuredInCategoryIds.length === 0) return categories;
            return (0, ($parcel$interopDefault($7qDUb)))(categories, (cat)=>!featuredInCategoryIds.includes(cat.id));
        }
        return undefined;
    };
    const $daacc015e0475ec6$export$f8c0d0a39b0d7d4e = (0, $dGvGJ.createSelector)((state, articleId)=>state.entities.articles[articleId], (state)=>state.entities.categories, (articleOrError, allCategories)=>{
        if (!articleOrError) return undefined;
        if ('error' in articleOrError) return articleOrError;
        const article = articleOrError;
        const categories = $daacc015e0475ec6$var$getArticleCategories(allCategories, article);
        const { categories: _, ...articleWithoutCategory } = article;
        return {
            ...articleWithoutCategory,
            categories: categories
        };
    });
    const $daacc015e0475ec6$var$getUpdatingCategoriesForArticle = (state, articleId)=>state.ui.articles[articleId] && state.ui.articles[articleId].categoryIds && state.ui.articles[articleId].categoryIds.map((id)=>(0, (0, parcelRequire("5fBrW")).getCategory)(state, id)).filter(Boolean);
    const $daacc015e0475ec6$export$458f158173f65de8 = (state, articleId)=>{
        const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
        if (!article) return [];
        if (article.error) return [];
        return article.categories || [];
    };
    const $daacc015e0475ec6$export$360e12e07ffc1cb0 = (state, articleId)=>{
        const updatingCategories = $daacc015e0475ec6$var$getUpdatingCategoriesForArticle(state, articleId);
        if (updatingCategories) return updatingCategories;
        return $daacc015e0475ec6$export$458f158173f65de8(state, articleId);
    };
    const $daacc015e0475ec6$export$ba941551d0dc160c = (state, articleIds)=>articleIds.map((articleId)=>$daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId)).filter(Boolean);
    const $daacc015e0475ec6$export$483e222b9f194c8a = (state, articleId)=>state.ui.articles[articleId] && !!state.ui.articles[articleId].isShowingBulkCategoryAdder;
    const $daacc015e0475ec6$export$d1f02a9ddd87bcc6 = (state, articleId)=>{
        if (!state.ui.articles[articleId]) return [];
        return state.ui.articles[articleId].categoriesInBulkCategoryAdder || [];
    };
    const $daacc015e0475ec6$export$ccf898e36d51a9bc = (state, articleId)=>{
        const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
        if (!article) return '';
        if (article.spaceKey) return article.spaceKey;
        return '';
    };
});
parcelRegister("5fBrW", function(module, exports) {
    $parcel$export(module.exports, "getCategory", ()=>$45a4a0df582a0d3a$export$410364bbb673ddbc);
    $parcel$export(module.exports, "getCategoryName", ()=>$45a4a0df582a0d3a$export$67267455149572c9);
    $parcel$export(module.exports, "getAllCategories", ()=>$45a4a0df582a0d3a$export$36bfd9279b3a24b7);
    const $45a4a0df582a0d3a$export$410364bbb673ddbc = (state, id)=>state.entities.categories.categories.find((category)=>category.id === id);
    const $45a4a0df582a0d3a$export$67267455149572c9 = (state, id)=>{
        const category = $45a4a0df582a0d3a$export$410364bbb673ddbc(state, id);
        if (category) return category.name;
        return undefined;
    };
    const $45a4a0df582a0d3a$export$36bfd9279b3a24b7 = (state)=>state.entities.categories.categories;
});
parcelRegister("fhG9v", function(module, exports) {
    $parcel$export(module.exports, "getArticleIdsForCategory", ()=>$da36dd250036e782$export$bb874ade4016b878);
    $parcel$export(module.exports, "getCategoryTotalSize", ()=>$da36dd250036e782$export$165fede49970bd0c);
    $parcel$export(module.exports, "getBrowseLimit", ()=>$da36dd250036e782$export$adc0ce73adb3dc4a);
    $parcel$export(module.exports, "getBrowseNextCursor", ()=>$da36dd250036e782$export$4b2e4efe9c0df2cd);
    $parcel$export(module.exports, "getBrowsePrevCursor", ()=>$da36dd250036e782$export$f7e999777526d95e);
    $parcel$export(module.exports, "isCategoriesSupported", ()=>$da36dd250036e782$export$cfb809beeaa82062);
    $parcel$export(module.exports, "isBrowseLoading", ()=>$da36dd250036e782$export$aecf0fb6e785d5e0);
    $parcel$export(module.exports, "getArticlesLoading", ()=>$da36dd250036e782$export$327a4e3439ce6c6a);
    const $da36dd250036e782$export$bb874ade4016b878 = (state, categoryId, page = 1)=>state.entities.browse[categoryId] ? state.entities.browse[categoryId].pages[`${page}`] : undefined;
    const $da36dd250036e782$export$165fede49970bd0c = (state, categoryId)=>state.entities.browse[categoryId].totalSize;
    const $da36dd250036e782$export$adc0ce73adb3dc4a = (state)=>state.entities.browse.limit;
    const $da36dd250036e782$export$4b2e4efe9c0df2cd = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].nextCursor ?? '' : '';
    const $da36dd250036e782$export$f7e999777526d95e = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].prevCursor ?? '' : '';
    const $da36dd250036e782$export$cfb809beeaa82062 = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].categoriesSupported ?? true : true;
    const $da36dd250036e782$export$aecf0fb6e785d5e0 = (state, categoryId)=>state.entities.browse[categoryId] === undefined;
    const $da36dd250036e782$export$327a4e3439ce6c6a = (state)=>!!state.entities.browse.loading;
});
parcelRegister("knU3A", function(module, exports) {
    $parcel$export(module.exports, "getHubLinkedState", ()=>$13b0808aee851dca$export$9b336974117966dd);
    $parcel$export(module.exports, "getLinkedConfluenceUrl", ()=>$13b0808aee851dca$export$fea8defd3093e8e3);
    $parcel$export(module.exports, "getLinkedConfluenceSpace", ()=>$13b0808aee851dca$export$6c88aaaf8fc8b7f1);
    const $13b0808aee851dca$export$9b336974117966dd = (state)=>state.entities.hub.linkedState;
    const $13b0808aee851dca$export$fea8defd3093e8e3 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.confluenceUrl : undefined;
    const $13b0808aee851dca$export$6c88aaaf8fc8b7f1 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.spaceKey : undefined;
});
parcelRegister("k5cJw", function(module, exports) {
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$3fcb02b524b089b3$export$b764c9ef97480a8e);
    const $3fcb02b524b089b3$export$b764c9ef97480a8e = (state)=>state.entities.spaces?.linkedSpaces.data ?? [];
});
parcelRegister("z7Rc8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59fded4bd8c6152b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gLt7z;
    var $l0ai2;
    const $59fded4bd8c6152b$var$mapStateToProps = (state)=>({
            baseUrl: (0, (0, parcelRequire("gLt7z")).getBaseUrl)(state)
        });
    const $59fded4bd8c6152b$var$ConnectedReadyForUser = (0, (0, parcelRequire("bC2fB")).connect)($59fded4bd8c6152b$var$mapStateToProps, {})((0, (0, parcelRequire("l0ai2")).default));
    var $59fded4bd8c6152b$export$2e2bcd8739ae039 = $59fded4bd8c6152b$var$ConnectedReadyForUser;
});
parcelRegister("l0ai2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0aadd6b14b3dca3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8PRuf;
    var $3TpKp;
    const $0aadd6b14b3dca3c$var$ConnectedReadyForUser = ({ metricKey: metricKey, metric: metric })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3TpKp")).JsmPageInteractiveEvent), {
            metricKey: metricKey,
            withMarks: [
                (0, (0, parcelRequire("8PRuf")).appBundleReadyMark)
            ],
            appName: "servicedesk.knowledge.hub",
            metric: metric
        });
    var $0aadd6b14b3dca3c$export$2e2bcd8739ae039 = $0aadd6b14b3dca3c$var$ConnectedReadyForUser;
});
parcelRegister("3TpKp", function(module, exports) {
    $parcel$export(module.exports, "JsmPageInteractiveEvent", ()=>$bbb7386cf97044f2$export$c4ba40c380ee9a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), args);
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
        isExpectedToHaveSsr: false,
        withMarks: [],
        extra: {}
    };
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("kpAEt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e382948a1087984$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $9tOEo;
    var $jzjy1;
    var $bC2fB;
    var $6z7Gx;
    var $gLt7z;
    var $6XOVk;
    var $2e382948a1087984$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("jzjy1")).AnalyticsSource)('knowledgeInlineSearch', (0, $4d5e0871c06cee03$export$cae2783c9279926)), (0, (0, parcelRequire("9tOEo")).default)({
        attributes: {
            context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    }), (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            projectId: (0, (0, parcelRequire("gLt7z")).getProjectId)(state),
            activationId: (0, (0, parcelRequire("gLt7z")).getActivationId)(state)
        }), {}))((0, (0, parcelRequire("6XOVk")).default));
});
parcelRegister("6XOVk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$beb028f0fac9a044$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hZHze;
    var $h5R5L;
    var $8eHQf;
    class $beb028f0fac9a044$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                searchScreenPath: ''
            };
        }
        render() {
            const { transitionToSearchPage: transitionToSearchPage, ...state } = this.state;
            const { searchScreenPath: searchScreenPath, projectId: projectId, SearchKnowledge: SearchKnowledge, SearchResultComponent: SearchResultComponent, placeholder: placeholder, activationId: activationId } = this.props;
            const searchScreenRedirectUrl = searchScreenPath ? `${searchScreenPath}?q=${state.value}` : undefined;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, transitionToSearchPage && searchScreenRedirectUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h5R5L")).default), {
                to: searchScreenRedirectUrl,
                push: true
            }), state.isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8eHQf")).default), {
                ...state,
                projectId: projectId,
                onChange: this.onChange,
                onFieldSearchFocus: this.onOpen,
                onClose: this.onClose,
                onSubmit: this.onSubmit,
                searchScreenRedirectUrl: searchScreenRedirectUrl,
                SearchResultComponent: SearchResultComponent,
                SearchKnowledge: SearchKnowledge,
                placeholder: placeholder,
                activationId: activationId
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                value: '',
                isOpen: false,
                transitionToSearchPage: false
            };
            this.onChange = (value)=>this.setState({
                    value: value
                });
            this.onOpen = ()=>this.setState({
                    isOpen: true
                });
            this.onClose = ()=>this.setState({
                    isOpen: false
                });
            this.onSubmit = ()=>this.setState({
                    transitionToSearchPage: true
                });
        }
    }
});
parcelRegister("hZHze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dc4a27be9f367e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $994MI;
    var $cb25w;
    var $gvRPW;
    class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onMount();
        }
        render() {
            return null;
        }
    }
    const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'view-tracker'
    })((0, (0, parcelRequire("cb25w")).default)({
        onMount: (createEvent)=>createEvent({
                action: (0, (0, parcelRequire("gvRPW")).PAGE_EVENT_ACTION)
            }).fire()
    })($69dc4a27be9f367e$var$ViewTracker));
    var $69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
            onMount: (0, ($parcel$interopDefault($8Rkzz)))
        });
});
parcelRegister("h5R5L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1afb69c0012e46a4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eWMrk;
    var $7tQej;
    var $jDDFr;
    const $1afb69c0012e46a4$var$ServicedeskSpaRedirect = (props)=>{
        const { RouterSubscriber: RouterSubscriber, to: to, push: push } = props;
        const path = to.charAt(0) === '/' ? to : `/${to}`;
        return __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match && match.params && match.params.projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                push: push,
                to: `/jira/servicedesk/projects/${match.params.projectKey}${path}`
            }) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eWMrk")).default), {
            to: to,
            push: push
        });
    };
    $1afb69c0012e46a4$var$ServicedeskSpaRedirect.defaultProps = {
        push: false,
        RouterSubscriber: (0, (0, parcelRequire("jDDFr")).RouterSubscriber)
    };
    var $1afb69c0012e46a4$export$2e2bcd8739ae039 = $1afb69c0012e46a4$var$ServicedeskSpaRedirect;
});
parcelRegister("eWMrk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae1c0e9472109838$export$2e2bcd8739ae039);
    var $7vfpQ;
    var $ae1c0e9472109838$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7vfpQ")).default);
});
parcelRegister("7vfpQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$576762e7df8b2249$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $hBYjV = parcelRequire("hBYjV");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $7bpAK = parcelRequire("7bpAK");
    var $8RxWw;
    var $576762e7df8b2249$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $576762e7df8b2249$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $576762e7df8b2249$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $576762e7df8b2249$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $576762e7df8b2249$var$Redirect = function(_React$Component) {
        $576762e7df8b2249$var$_inherits(Redirect, _React$Component);
        function Redirect() {
            $576762e7df8b2249$var$_classCallCheck(this, Redirect);
            return $576762e7df8b2249$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        Redirect.prototype.isStatic = function isStatic() {
            return this.context.router && this.context.router.staticContext;
        };
        Redirect.prototype.componentWillMount = function componentWillMount() {
            (0, ($parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Redirect> outside a <Router>");
            if (this.isStatic()) this.perform();
        };
        Redirect.prototype.componentDidMount = function componentDidMount() {
            if (!this.isStatic()) this.perform();
        };
        Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
            var prevTo = (0, $7bpAK.createLocation)(prevProps.to);
            var nextTo = (0, $7bpAK.createLocation)(this.props.to);
            if ((0, $7bpAK.locationsAreEqual)(prevTo, nextTo)) {
                (0, ($parcel$interopDefault($hBYjV)))(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
                return;
            }
            this.perform();
        };
        Redirect.prototype.computeTo = function computeTo(_ref) {
            var computedMatch = _ref.computedMatch, to = _ref.to;
            if (computedMatch) {
                if (typeof to === "string") return (0, (0, parcelRequire("8RxWw")).default)(to, computedMatch.params);
                else return $576762e7df8b2249$var$_extends({}, to, {
                    pathname: (0, (0, parcelRequire("8RxWw")).default)(to.pathname, computedMatch.params)
                });
            }
            return to;
        };
        Redirect.prototype.perform = function perform() {
            var history = this.context.router.history;
            var push = this.props.push;
            var to = this.computeTo(this.props);
            if (push) history.push(to);
            else history.replace(to);
        };
        Redirect.prototype.render = function render() {
            return null;
        };
        return Redirect;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $576762e7df8b2249$var$Redirect.propTypes = {
        computedMatch: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object,
        push: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        from: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        to: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
        ]).isRequired
    };
    $576762e7df8b2249$var$Redirect.defaultProps = {
        push: false
    };
    $576762e7df8b2249$var$Redirect.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            history: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
                push: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired,
                replace: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired
            }).isRequired,
            staticContext: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
        }).isRequired
    };
    var $576762e7df8b2249$export$2e2bcd8739ae039 = $576762e7df8b2249$var$Redirect;
});
parcelRegister("8RxWw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$673d9a4f97fe136d$export$2e2bcd8739ae039);
    var $d4Ora = parcelRequire("d4Ora");
    var $673d9a4f97fe136d$var$patternCache = {};
    var $673d9a4f97fe136d$var$cacheLimit = 10000;
    var $673d9a4f97fe136d$var$cacheCount = 0;
    var $673d9a4f97fe136d$var$compileGenerator = function compileGenerator(pattern) {
        var cacheKey = pattern;
        var cache = $673d9a4f97fe136d$var$patternCache[cacheKey] || ($673d9a4f97fe136d$var$patternCache[cacheKey] = {});
        if (cache[pattern]) return cache[pattern];
        var compiledGenerator = (0, ($parcel$interopDefault($d4Ora))).compile(pattern);
        if ($673d9a4f97fe136d$var$cacheCount < $673d9a4f97fe136d$var$cacheLimit) {
            cache[pattern] = compiledGenerator;
            $673d9a4f97fe136d$var$cacheCount++;
        }
        return compiledGenerator;
    };
    var $673d9a4f97fe136d$var$generatePath = function generatePath() {
        var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (pattern === "/") return pattern;
        var generator = $673d9a4f97fe136d$var$compileGenerator(pattern);
        return generator(params, {
            pretty: true
        });
    };
    var $673d9a4f97fe136d$export$2e2bcd8739ae039 = $673d9a4f97fe136d$var$generatePath;
});
parcelRegister("8eHQf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a229f676f8882ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $tvuR8;
    var $ctg8C;
    var $cgL5K;
    var $ousew;
    var $8RXs9;
    var $2xSAL;
    var $iDMMZ;
    var $5QGsG;
    class $4a229f676f8882ed$export$cd3c7d9047f30827 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                value: ''
            };
        }
        render() {
            const { value: value, SearchKnowledge: SearchKnowledge, onChange: onChange, placeholder: placeholder, onSubmit: onSubmit, intl: intl, isOpen: isOpen, onFieldSearchFocus: onFieldSearchFocus, onClose: onClose, searchScreenRedirectUrl: searchScreenRedirectUrl, SearchResultComponent: _, activationId: activationId, ...props } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$InlineDialogContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
                isOpen: !!value && isOpen,
                onClose: onClose,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$ContentContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SearchKnowledge, {
                    ...props,
                    limit: 3,
                    value: value,
                    renderResult: this.renderResult,
                    activationId: activationId ?? '',
                    successCtaComponent: searchScreenRedirectUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$LinkToSearchPage, {
                        to: searchScreenRedirectUrl
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        ...(0, (0, parcelRequire("5QGsG")).default).searchAllArticlesCta,
                        values: {
                            term: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                                as: "strong"
                            }, value)
                        }
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("tvuR8"))))), {
                        label: intl.formatMessage((0, (0, parcelRequire("5QGsG")).default).searchIconLabel)
                    })) : null
                }))
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($4a229f676f8882ed$var$FieldContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
                isAlwaysExpanded: true,
                onEnter: onSubmit,
                onFocus: onFieldSearchFocus,
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                shouldFitContainerWidth: true,
                isAutocompleteDisabled: true
            }))));
        }
        constructor(...args){
            super(...args);
            this.renderResult = (article)=>{
                const { SearchResultComponent: SearchResultComponent } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(SearchResultComponent, {
                    id: article.id,
                    title: article.titleExcerpt || '',
                    description: article.summaryExcerpt || '',
                    categories: article.categories,
                    lineClamp: 2
                });
            };
        }
    }
    var $4a229f676f8882ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($4a229f676f8882ed$export$cd3c7d9047f30827);
    const $4a229f676f8882ed$var$ContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbnklw _o5724jg8",
                __cmplp.className
            ])
        });
    });
    const $4a229f676f8882ed$var$FieldContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbp3fh",
                __cmplp.className
            ])
        });
    });
    const $4a229f676f8882ed$var$InlineDialogContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $4a229f676f8882ed$var$LinkToSearchPage = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("iDMMZ")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1e0c1txw _1bah1yb4 _4cvr1h6o _18s8z283 _1yt44ar7 _syaz1fxt _bfhk1gi7 _2rko1fff",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2NMNM;
    var $kY99m;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("iDMMZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8906b3331e8371f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cS0Qm;
    var $hDzhb;
    var $jDDFr;
    const $8906b3331e8371f5$var$KnowledgeHubSpaLink = (props)=>{
        const { RouterSubscriber: RouterSubscriber, to: to, children: children, innerRef: innerRef, style: style, replace: replace } = props;
        const path = to.charAt(0) === '/' ? to : `/${to}`;
        return __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match && match.params && match.params.projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                href: `/jira/servicedesk/projects/${match.params.projectKey}${path}`,
                replace: replace
            }, children || null) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS0Qm")).default), {
            to: to,
            innerRef: innerRef,
            style: style,
            replace: replace
        }, children);
    };
    $8906b3331e8371f5$var$KnowledgeHubSpaLink.defaultProps = {
        RouterSubscriber: (0, (0, parcelRequire("jDDFr")).RouterSubscriber)
    };
    var $8906b3331e8371f5$export$2e2bcd8739ae039 = $8906b3331e8371f5$var$KnowledgeHubSpaLink;
});
parcelRegister("cS0Qm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95eb2eaf9d2a8414$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $aE1Lc = parcelRequire("aE1Lc");
    var $7bpAK = parcelRequire("7bpAK");
    var $95eb2eaf9d2a8414$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $95eb2eaf9d2a8414$var$_objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function $95eb2eaf9d2a8414$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $95eb2eaf9d2a8414$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $95eb2eaf9d2a8414$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $95eb2eaf9d2a8414$var$isModifiedEvent = function isModifiedEvent(event) {
        return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    };
    var $95eb2eaf9d2a8414$var$Link = function(_React$Component) {
        $95eb2eaf9d2a8414$var$_inherits(Link, _React$Component);
        function Link() {
            var _temp, _this, _ret;
            $95eb2eaf9d2a8414$var$_classCallCheck(this, Link);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $95eb2eaf9d2a8414$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.handleClick = function(event) {
                if (_this.props.onClick) _this.props.onClick(event);
                if (!event.defaultPrevented && event.button === 0 && !_this.props.target && !$95eb2eaf9d2a8414$var$isModifiedEvent(event)) {
                    event.preventDefault();
                    var history = _this.context.router.history;
                    var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                    if (replace) history.replace(to);
                    else history.push(to);
                }
            }, _temp), $95eb2eaf9d2a8414$var$_possibleConstructorReturn(_this, _ret);
        }
        Link.prototype.render = function render() {
            var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $95eb2eaf9d2a8414$var$_objectWithoutProperties(_props, [
                "replace",
                "to",
                "innerRef"
            ]);
            (0, ($parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Link> outside a <Router>");
            (0, ($parcel$interopDefault($aE1Lc)))(to !== undefined, 'You must specify the "to" property');
            var history = this.context.router.history;
            var location = typeof to === "string" ? (0, $7bpAK.createLocation)(to, null, null, history.location) : to;
            var href = history.createHref(location);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("a", $95eb2eaf9d2a8414$var$_extends({}, props, {
                onClick: this.handleClick,
                href: href,
                ref: innerRef
            }));
        };
        return Link;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $95eb2eaf9d2a8414$var$Link.propTypes = {
        onClick: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        target: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        replace: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        to: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
        ]).isRequired,
        innerRef: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func
        ])
    };
    $95eb2eaf9d2a8414$var$Link.defaultProps = {
        replace: false
    };
    $95eb2eaf9d2a8414$var$Link.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            history: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
                push: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired,
                replace: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired,
                createHref: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired
            }).isRequired
        }).isRequired
    };
    var $95eb2eaf9d2a8414$export$2e2bcd8739ae039 = $95eb2eaf9d2a8414$var$Link;
});
parcelRegister("5QGsG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81a65d1ad7406dbd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81a65d1ad7406dbd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchAllArticlesCta: {
            "id": "servicedesk.knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.search-all-articles-cta",
            "defaultMessage": "Search all articles for {term}"
        },
        searchIconLabel: {
            "id": "servicedesk.knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.search-icon-label",
            "defaultMessage": "search icon"
        }
    });
});
parcelRegister("l7HvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5657e58bfe8f146f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $fhG9v;
    var $hJo0o;
    var $2ypeR;
    const $5657e58bfe8f146f$var$AllArticlesTableWithRouteDetails = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ypeR")).default), props);
    var $5657e58bfe8f146f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state)=>({
            isInitiallyLoading: (0, (0, parcelRequire("fhG9v")).isBrowseLoading)(state, 'all-articles'),
            KnowledgeHubBulkUpdateCategories: (0, (0, parcelRequire("hJo0o")).AsyncBulkUpdateCategories),
            isSearchLoading: (0, (0, parcelRequire("fhG9v")).getArticlesLoading)(state)
        }), {})($5657e58bfe8f146f$var$AllArticlesTableWithRouteDetails);
});
parcelRegister("hJo0o", function(module, exports) {
    $parcel$export(module.exports, "AsyncBulkUpdateCategories", ()=>$4fb0a570d2ccdf36$export$a43ca58093f3e92a);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    const $4fb0a570d2ccdf36$var$LazyBulkUpdateCategories = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("gSThv")), {
        moduleId: "./src/packages/servicedesk/knowledge-hub/src/view/knowledge-hub-bulk-update-categories/index.tsx"
    });
    const $4fb0a570d2ccdf36$export$a43ca58093f3e92a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bulk-update-categories",
            packageName: "@atlassian/jira-servicedesk-knowledge-hub"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "knowledge-hub-bulk-update-categories",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4fb0a570d2ccdf36$var$LazyBulkUpdateCategories, props)));
});
parcelRegister("gSThv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("43lw7")
    ]).then(()=>parcelRequire('e1yg0'));
});
parcelRegister("2ypeR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0255550789c12d68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gccSB = parcelRequire("gccSB");
    var $ebyGx = parcelRequire("ebyGx");
    var $kkuz9;
    var $cgL5K;
    var $eZJjh;
    var $3bDjY;
    var $gwIPs;
    var $5I3bw;
    var $a9Z5f;
    var $6OZOz;
    const $0255550789c12d68$var$SPACES_COLUMN_WIDTH = (0, (0, parcelRequire("gwIPs")).gridSize) * 33;
    const $0255550789c12d68$var$CATEGORIES_COLUMN_WIDTH = (0, (0, parcelRequire("gwIPs")).gridSize) * 20;
    class $0255550789c12d68$export$97a31ecee7db1e5e extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                categoriesSupported: true,
                onSetPage: undefined
            };
        }
        getTableColumns() {
            const { showSpaceColumn: showSpaceColumn } = this.props;
            return [
                (0, (0, parcelRequire("a9Z5f")).createTitleColumn)((knowledge)=>{
                    const { spaceKey: spaceKey, id: id } = knowledge;
                    return spaceKey !== undefined ? `/knowledge/articles/${id}?spaceKey=${spaceKey}` : `/knowledge/articles/${id}`;
                }),
                ...showSpaceColumn ? [
                    this.getLinkedSpacesColumn()
                ] : [],
                this.getCategoriesColumn(),
                (0, (0, parcelRequire("a9Z5f")).viewCountColumn),
                (0, (0, parcelRequire("a9Z5f")).lastModifiedColumn)
            ];
        }
        getCategoriesColumn() {
            const { KnowledgeHubBulkUpdateCategories: KnowledgeHubBulkUpdateCategories, categoriesSupported: categoriesSupported } = this.props;
            return {
                key: 'article-categories',
                header: (intl)=>({
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement($0255550789c12d68$var$FlexLeftAlignedText, null, intl.formatMessage((0, (0, parcelRequire("6OZOz")).default).categoriesHeader), !categoriesSupported && (0, ($parcel$interopDefault($5uXOq))).createElement($0255550789c12d68$var$NoCategoriesWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                            content: intl.formatMessage((0, (0, parcelRequire("6OZOz")).default).noCategoriesTooltip)
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kkuz9"))))), {
                            label: "",
                            size: "medium"
                        })))),
                        isSortable: false,
                        width: `${$0255550789c12d68$var$CATEGORIES_COLUMN_WIDTH}px`
                    }),
                row: (intl, index, knowledge)=>!categoriesSupported ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "em"
                    }, intl.formatMessage((0, (0, parcelRequire("6OZOz")).default).noCategoriesRow)) : (0, ($parcel$interopDefault($5uXOq))).createElement(KnowledgeHubBulkUpdateCategories, {
                        key: `article-bulk-categories-${knowledge.id}`,
                        articleId: knowledge.id,
                        categoryEditorWidth: $0255550789c12d68$var$CATEGORIES_COLUMN_WIDTH
                    })
            };
        }
        getLinkedSpacesColumn() {
            return {
                key: 'article-linked-spaces',
                header: (intl)=>({
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a9Z5f")).LeftAlignedText), null, intl.formatMessage((0, (0, parcelRequire("6OZOz")).default).linkedSpacesHeader)),
                        isSortable: false,
                        width: `${$0255550789c12d68$var$SPACES_COLUMN_WIDTH}px`
                    }),
                row: (intl, index, knowledge)=>{
                    const spaceName = knowledge.spaceName || '';
                    const spaceUrl = knowledge.spaceUrl || '';
                    const { canViewSpaceUrl: canViewSpaceUrl } = this.props;
                    return canViewSpaceUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a9Z5f")).LeftAlignedText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                        content: intl.formatMessage((0, (0, parcelRequire("6OZOz")).default).tooltipText)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: spaceUrl,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow"
                    }, spaceName))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a9Z5f")).LeftAlignedText), null, spaceName);
                }
            };
        }
        render() {
            const { knowledgePieces: knowledgePieces } = this.props;
            return knowledgePieces ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5I3bw")).default), {
                ...this.props,
                categoryId: "all-articles",
                actions: [],
                columns: this.getTableColumns(),
                onSetPage: this.onSetPage
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($0255550789c12d68$var$SpinnerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: 70
            }));
        }
        constructor(...args){
            super(...args);
            this.onSetPage = (pageNum, sortBy, push, history, analyticsEvent, cursor, searchQuery, spaceKeys)=>{
                const { onSetPage: onSetPage } = this.props;
                onSetPage && onSetPage(pageNum, sortBy, push, history, analyticsEvent, cursor);
                const spacekeyNames = (0, ($parcel$interopDefault($gccSB)))(spaceKeys) ? null : JSON.stringify(spaceKeys);
                push ? push(`/knowledge/browse/page/${pageNum}?${(0, ($parcel$interopDefault($ebyGx))).stringify({
                    cursor: cursor,
                    sortBy: sortBy,
                    searchQuery: searchQuery,
                    spaceKey: spacekeyNames
                }, {
                    skipNull: true,
                    skipEmptyString: true
                })}`) : history.push(`/knowledge/browse/page/${pageNum}?${(0, ($parcel$interopDefault($ebyGx))).stringify({
                    cursor: cursor,
                    sortBy: sortBy,
                    searchQuery: searchQuery,
                    spaceKey: spacekeyNames
                }, {
                    skipNull: true,
                    skipEmptyString: true
                })}`);
            };
        }
    }
    var $0255550789c12d68$export$2e2bcd8739ae039 = $0255550789c12d68$export$97a31ecee7db1e5e;
    const $0255550789c12d68$var$NoCategoriesWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81cx1",
                __cmplp.className
            ])
        });
    });
    const $0255550789c12d68$var$FlexLeftAlignedText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $0255550789c12d68$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _4t3i1osq _19pk1qv8",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5I3bw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33d45f11aa875c2d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $akqdW;
    var $l1emQ;
    var $kHzxc;
    var $gXg4u;
    var $fhG9v;
    var $4VdM6;
    const $33d45f11aa875c2d$var$KnowledgeTableWithPush = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("akqdW")).default), null, ({ push: push })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4VdM6")).default), {
                ...props,
                push: push
            }));
    const $33d45f11aa875c2d$export$2c0e26252fc4f28d = (0, (0, parcelRequire("bC2fB")).connect)((state, props)=>{
        const articleIds = (0, (0, parcelRequire("fhG9v")).getArticleIdsForCategory)(state, props.categoryId, props.page);
        let totalSize;
        let knowledgePieces;
        let error;
        if (articleIds) {
            if (articleIds.error && !Array.isArray(articleIds)) error = articleIds;
            else {
                totalSize = (0, (0, parcelRequire("fhG9v")).getCategoryTotalSize)(state, props.categoryId);
                knowledgePieces = (0, (0, parcelRequire("gXg4u")).getArticlesByIds)(state, articleIds).reduce((acc, curr)=>curr.error ? acc : [
                        ...acc,
                        curr
                    ], []);
            }
        }
        return {
            totalSize: totalSize,
            knowledgePieces: knowledgePieces,
            error: error,
            isInitiallyLoading: (0, (0, parcelRequire("fhG9v")).isBrowseLoading)(state, props.categoryId),
            limit: (0, (0, parcelRequire("fhG9v")).getBrowseLimit)(state),
            isSearchLoading: (0, (0, parcelRequire("fhG9v")).getArticlesLoading)(state)
        };
    }, {
        onBrowseKnowledge: (0, (0, parcelRequire("kHzxc")).browseKnowledge)
    })($33d45f11aa875c2d$var$KnowledgeTableWithPush);
    var $33d45f11aa875c2d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("l1emQ")).withRouter)($33d45f11aa875c2d$var$KnowledgeTableWithPush);
});
parcelRegister("4VdM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4acb9099462d9019$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1sXeC = parcelRequire("1sXeC");
    var $dHbUn;
    var $xBgAj;
    var $eZJjh;
    var $koVbs;
    var $75gFv = parcelRequire("75gFv");
    var $iDMMZ;
    var $6yXtV;
    var $13x0I;
    var $a9Z5f;
    var $9S8wn;
    var $jZgzD;
    const $4acb9099462d9019$export$ac0a9805cce1a48c = ({ isInitiallyLoading: isInitiallyLoading, isSearchLoading: isSearchLoading, error: error, sortBy: sortBy, expansions: expansions, page: page, emptyStateComponent: emptyStateComponent, noSearchResultsComponent: noSearchResultsComponent, columns: columns, onSetPage: onSetPage, history: history, push: push, totalSize: totalSize = -1, knowledgePieces: knowledgePieces, limit: rowsPerPage, onBrowseKnowledge: onBrowseKnowledge, categoryId: categoryId, prevCursor: prevCursor, nextCursor: nextCursor, searchQuery: searchQuery, spaceKeys: spaceKeys })=>{
        const pageNumber = (0, ($parcel$interopDefault($1sXeC)))(page);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const expansionDeps = (expansions || []).join(';');
        (0, $5uXOq.useEffect)(()=>{
            onBrowseKnowledge && onBrowseKnowledge({
                page: pageNumber,
                limit: rowsPerPage,
                id: categoryId,
                orderBy: sortBy,
                expand: expansions
            });
        }, [
            categoryId,
            sortBy,
            expansionDeps,
            onBrowseKnowledge,
            pageNumber,
            rowsPerPage
        ]);
        const columnKeys = columns.map((c)=>c.key).join(';');
        const header = (0, $5uXOq.useMemo)(()=>{
            const headerCells = columns.map((column)=>({
                    key: column.key,
                    ...column.header(intl)
                }));
            return {
                cells: headerCells
            };
        }, [
            columnKeys,
            intl
        ]);
        let rows = [];
        if (totalSize > 0 && Array.isArray(knowledgePieces)) rows = knowledgePieces.map((knowledge, index)=>{
            const indexKey = ((0, (0, parcelRequire("a9Z5f")).getSortOrder)(sortBy) === 'DESC' ? knowledgePieces.length - 1 - index : index).toString().padStart((knowledgePieces.length - 1).toString().length, '0');
            const cells = columns.map((column)=>({
                    key: `${indexKey}-${column.key}-${knowledge.id}`,
                    content: column.row(intl, index, knowledge, {
                        page: page
                    })
                }));
            return {
                key: `knowledge-${knowledge.id}`,
                cells: cells
            };
        });
        const paginationi18n = (0, $5uXOq.useMemo)(()=>({
                prev: intl.formatMessage((0, (0, parcelRequire("9S8wn")).default).paginationPrev),
                next: intl.formatMessage((0, (0, parcelRequire("9S8wn")).default).paginationNext)
            }), [
            intl
        ]);
        if (error) {
            const errorContent = error.error;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
                imageUrl: (0, ($parcel$interopDefault($75gFv))),
                header: intl.formatMessage(errorContent.header),
                description: intl.formatMessage(errorContent.message),
                primaryAction: errorContent.ctaLink && errorContent.ctaText ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDMMZ")).default), {
                    to: errorContent.ctaLink || ''
                }, intl.formatMessage(errorContent.ctaText)) : undefined
            });
        }
        if (isInitiallyLoading || isSearchLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($4acb9099462d9019$var$LoadingContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            delay: 300
        }));
        if (totalSize === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($4acb9099462d9019$var$TableContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
            head: header,
            sortKey: (0, (0, parcelRequire("a9Z5f")).getSortKey)(columns, sortBy),
            sortOrder: (0, (0, parcelRequire("a9Z5f")).getSortOrder)(sortBy),
            paginationi18n: paginationi18n
        }), searchQuery === '' ? emptyStateComponent : noSearchResultsComponent);
        const selectedIndex = (0, (0, parcelRequire("jZgzD")).getPageSelectedIndex)(nextCursor, prevCursor);
        const maxPages = Math.ceil(totalSize / rowsPerPage);
        const pagesArray = (0, (0, parcelRequire("jZgzD")).getPagesArray)(pageNumber, maxPages, prevCursor, nextCursor);
        const currentPageNumber = pagesArray[selectedIndex];
        const onPageChange = (event, newPageNumber, analyticsEvent)=>{
            if (newPageNumber !== currentPageNumber && onSetPage) {
                const cursor = (0, (0, parcelRequire("jZgzD")).getCursor)(currentPageNumber, newPageNumber, prevCursor, nextCursor);
                if (cursor) onSetPage(newPageNumber, sortBy, push, history, analyticsEvent, cursor, searchQuery, spaceKeys);
            }
        };
        const onPageSort = (sort)=>{
            if (typeof sort === 'object' && sort !== null && typeof sort.key === 'string' && typeof sort.sortOrder === 'string' && onSetPage) onSetPage(1, (0, (0, parcelRequire("a9Z5f")).getSortBy)(columns, sort.key, sort.sortOrder), push, history, undefined, '', searchQuery, spaceKeys);
        };
        const articlePagination = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                pages: pagesArray,
                onChange: onPageChange,
                style: {
                    display: 'flex',
                    justifyContent: 'center'
                },
                selectedIndex: selectedIndex
            });
        const isPaginated = (nextCursor || prevCursor) && totalSize > 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4acb9099462d9019$var$TableContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
            head: header,
            rows: rows,
            sortKey: (0, (0, parcelRequire("a9Z5f")).getSortKey)(columns, sortBy),
            sortOrder: (0, (0, parcelRequire("a9Z5f")).getSortOrder)(sortBy),
            onSort: onPageSort,
            isLoading: totalSize < 0 || isSearchLoading,
            paginationi18n: paginationi18n
        }), totalSize >= 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6yXtV")).SpaStatePageReadyOnUpdate), {
            comparer: [
                categoryId
            ]
        })), isPaginated && articlePagination());
    };
    $4acb9099462d9019$export$ac0a9805cce1a48c.defaultProps = {
        totalSize: -1,
        knowledgePieces: [],
        expansions: undefined,
        onActionsOpenChange: undefined,
        error: undefined,
        prevCursor: '',
        nextCursor: '',
        searchQuery: '',
        spaceKeys: {}
    };
    var $4acb9099462d9019$export$2e2bcd8739ae039 = $4acb9099462d9019$export$ac0a9805cce1a48c;
    const $4acb9099462d9019$var$TableContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkv47k _1ik01on0 _c9d71on0 _1bfw1on0 _i7sf1hna _1lkk1hna _p4liidpf _owipidpf _6autidpf _1pqwidpf _opvx1bpf _1he61ejb _hlwa1ejb",
                __cmplp.className
            ])
        });
    });
    const $4acb9099462d9019$var$LoadingContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _19pkxy5q",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args);
            this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            };
            this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            };
            this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            };
            this.componentWillUnmount = ()=>{
                this.detachListeners();
            };
            this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            };
            this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
            this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            };
            this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            };
            this.handleResize = ()=>{
                this.updateSpinnerPosition();
            };
            this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            };
            this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            };
            this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args);
            this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    refWidth: 0,
                    refHeight: 0
                };
                this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                };
                this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("75gFv", function(module, exports) {
    module.exports = new URL("error.5b530682.svg", import.meta.url).toString();
});
parcelRegister("13x0I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13dd6aa4f4b38a0c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hTEpF;
    var $gwIPs;
    function $13dd6aa4f4b38a0c$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            maxImageWidth: $13dd6aa4f4b38a0c$export$7e3df82ee760448c,
            maxImageHeight: $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a,
            ...props
        }));
    }
    $13dd6aa4f4b38a0c$export$2e2bcd8739ae039.defaultProps = {
        isLoading: false,
        primaryAction: undefined,
        secondaryAction: undefined,
        tertiaryAction: undefined
    };
    const $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a = (0, (0, parcelRequire("gwIPs")).gridSize) * 20.5;
    const $13dd6aa4f4b38a0c$export$7e3df82ee760448c = (0, (0, parcelRequire("gwIPs")).gridSize) * 48;
    const $13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ik51pl1 _bhl91wug _qci81jje",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("a9Z5f", function(module, exports) {
    $parcel$export(module.exports, "getSortKey", ()=>$905440847d148168$export$5df81d5bd5f33f5b);
    $parcel$export(module.exports, "getSortOrder", ()=>$905440847d148168$export$c11dbba94a24125);
    $parcel$export(module.exports, "getSortBy", ()=>$905440847d148168$export$c7052c2989e7b681);
    $parcel$export(module.exports, "createTitleColumn", ()=>$905440847d148168$export$9cb3346da99da773);
    $parcel$export(module.exports, "viewCountColumn", ()=>$905440847d148168$export$7e5a90571c828007);
    $parcel$export(module.exports, "LeftAlignedText", ()=>$905440847d148168$export$ec83636695a9ceda);
    $parcel$export(module.exports, "lastModifiedColumn", ()=>$905440847d148168$export$120b13130c77685f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3bDjY;
    var $gwIPs;
    var $15rEL;
    var $iDMMZ;
    var $9S8wn;
    const $905440847d148168$export$5df81d5bd5f33f5b = (columns, orderBy)=>columns.find((column)=>column.sortKey === orderBy.slice(1))?.key;
    const $905440847d148168$export$c11dbba94a24125 = (orderBy)=>orderBy[0] === '-' ? 'DESC' : 'ASC';
    const $905440847d148168$export$c7052c2989e7b681 = (columns, key, sortOrder)=>{
        const sortKey = columns.find((column)=>column.key === key)?.sortKey;
        switch(sortKey){
            case 'featured':
                return sortOrder === 'DESC' ? '-featured' : '+featured';
            case 'lastModified':
                return sortOrder === 'DESC' ? '-lastModified' : '+lastModified';
            case 'title':
                return sortOrder === 'DESC' ? '-title' : '+title';
            default:
                sortKey;
                return '-lastModified';
        }
    };
    const $905440847d148168$export$9cb3346da99da773 = (getLink)=>({
            key: 'knowledge-title',
            sortKey: 'title',
            header: (intl)=>({
                    content: intl.formatMessage((0, (0, parcelRequire("9S8wn")).default).titleHeader),
                    isSortable: true,
                    shouldTruncate: true,
                    width: `${$905440847d148168$export$a34a62dd85803a75}px`
                }),
            row: (intl, index, knowledge, context)=>(0, ($parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$82fa245df990fa4, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDMMZ")).default), {
                    to: getLink(knowledge, context)
                }, knowledge.title))
        });
    const $905440847d148168$export$7e5a90571c828007 = {
        key: 'knowledge-view-count',
        header: (intl)=>({
                content: (0, ($parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, intl.formatMessage((0, (0, parcelRequire("9S8wn")).default).viewCountHeader)),
                isSortable: false,
                width: `${$905440847d148168$export$5b3cf88de666fd48}px`
            }),
        row: (intl, index, knowledge)=>(0, ($parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, knowledge.viewCount || 0)
    };
    const $905440847d148168$export$120b13130c77685f = {
        key: 'knowledge-last-modified',
        sortKey: 'lastModified',
        header: (intl)=>({
                content: intl.formatMessage((0, (0, parcelRequire("9S8wn")).default).lastModifiedHeader),
                isSortable: true,
                width: `${$905440847d148168$export$ed5a9a7a6e830e46}px`
            }),
        row: (intl, index, knowledge)=>(0, ($parcel$interopDefault($5uXOq))).createElement($905440847d148168$export$ec83636695a9ceda, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                tag: "span",
                content: knowledge.lastModified
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15rEL")).FormattedRelativeV2), {
                value: knowledge.lastModified
            })))
    };
    const $905440847d148168$export$ec83636695a9ceda = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
    const $905440847d148168$export$82fa245df990fa4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41bpf",
                __cmplp.className
            ])
        });
    });
    const $905440847d148168$export$a34a62dd85803a75 = (0, (0, parcelRequire("gwIPs")).gridSize) * 44;
    const $905440847d148168$export$5b3cf88de666fd48 = (0, (0, parcelRequire("gwIPs")).gridSize) * 8;
    const $905440847d148168$export$ed5a9a7a6e830e46 = (0, (0, parcelRequire("gwIPs")).gridSize) * 16;
    const $905440847d148168$export$e8e23fb6af23977 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gnusic",
                __cmplp.className
            ])
        });
    });
    const $905440847d148168$export$f7cbd6b7c165c8fb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("15rEL", function(module, exports) {
    $parcel$export(module.exports, "getRelativeTimeAndUnit", ()=>$dff2faa5ae8b6f27$export$307c4b8ee56b97bb);
    $parcel$export(module.exports, "FormattedRelativeV2", ()=>$dff2faa5ae8b6f27$export$7317ee2f88fd1276);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7anB;
    var $2tElP;
    const $dff2faa5ae8b6f27$var$getTimeInUnits = (unitValue)=>{
        const seconds = unitValue / 1000;
        const minutes = seconds / 60;
        const hours = minutes / 60;
        const days = hours / 24;
        const weeks = days / 7;
        const months = weeks / 4;
        const years = months / 12;
        return {
            seconds: seconds,
            minutes: minutes,
            hours: hours,
            days: days,
            weeks: weeks,
            months: months,
            years: years
        };
    };
    const $dff2faa5ae8b6f27$export$307c4b8ee56b97bb = (value, units)=>{
        const timeInMilliseconds = new Date(value);
        const delta = timeInMilliseconds - Date.now();
        let valueInUnit;
        if (!units) {
            const { value: time, unit: unit } = (0, (0, parcelRequire("j7anB")).selectUnit)(timeInMilliseconds, new Date());
            return {
                time: time,
                unit: unit
            };
        }
        const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $dff2faa5ae8b6f27$var$getTimeInUnits(delta);
        switch(units){
            case 'second':
                valueInUnit = seconds;
                break;
            case 'minute':
                valueInUnit = minutes;
                break;
            case 'hour':
                valueInUnit = hours;
                break;
            case 'day':
                valueInUnit = days;
                break;
            case 'week':
                valueInUnit = weeks;
                break;
            case 'month':
                valueInUnit = months;
                break;
            case 'year':
                valueInUnit = years;
                break;
            default:
                valueInUnit = 0;
                break;
        }
        return {
            time: Math.ceil(valueInUnit),
            unit: units
        };
    };
    const $dff2faa5ae8b6f27$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
        const { time: time, unit: unit } = $dff2faa5ae8b6f27$export$307c4b8ee56b97bb(value, units);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: time,
            unit: unit,
            numeric: style === 'numeric' ? 'always' : 'auto',
            format: format,
            updateIntervalInSeconds: updateInterval
        }, children);
    };
    $dff2faa5ae8b6f27$export$7317ee2f88fd1276.displayName = 'FormattedRelative';
});
parcelRegister("9S8wn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de45fdf4efe7e0b3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $de45fdf4efe7e0b3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleHeader: {
            "id": "servicedesk.knowledge-hub.common.knowledge-table.title-header",
            "defaultMessage": "Article"
        },
        viewCountHeader: {
            "id": "servicedesk.knowledge-hub.common.knowledge-table.view-count-header",
            "defaultMessage": "Views"
        },
        lastModifiedHeader: {
            "id": "servicedesk.knowledge-hub.common.knowledge-table.last-modified-header",
            "defaultMessage": "Last updated"
        },
        actionsHeader: {
            "id": "servicedesk.knowledge-hub.common.knowledge-table.actions-header",
            "defaultMessage": "Actions"
        },
        paginationPrev: {
            "id": "servicedesk.knowledge-hub.common.knowledge-table.pagination-prev",
            "defaultMessage": "Prev"
        },
        paginationNext: {
            "id": "servicedesk.knowledge-hub.common.knowledge-table.pagination-next",
            "defaultMessage": "Next"
        }
    });
});
parcelRegister("jZgzD", function(module, exports) {
    $parcel$export(module.exports, "getCursor", ()=>$b4a72f934a466112$export$da3f040fb23d21f);
    $parcel$export(module.exports, "getPageSelectedIndex", ()=>$b4a72f934a466112$export$21dd36eb814eaa19);
    $parcel$export(module.exports, "getPagesArray", ()=>$b4a72f934a466112$export$bde02ecd78b458e3);
    const $b4a72f934a466112$export$da3f040fb23d21f = (currentpageNumber, newPageNumber, prevCursor, nextCursor)=>{
        let cursor;
        if (newPageNumber === currentpageNumber + 1 && nextCursor) cursor = nextCursor;
        else if (newPageNumber === currentpageNumber - 1 && prevCursor) cursor = prevCursor;
        else cursor = '';
        return cursor;
    };
    const $b4a72f934a466112$export$21dd36eb814eaa19 = (nextCursor, prevCursor)=>nextCursor && !prevCursor ? 0 : 1;
    const $b4a72f934a466112$export$bde02ecd78b458e3 = (pageNumber, maxPages, prevCursor, nextCursor)=>{
        let pagesArray = [
            pageNumber
        ];
        if (prevCursor && pageNumber !== 1) pagesArray = [
            pageNumber - 1,
            ...pagesArray
        ];
        if (nextCursor && pageNumber < maxPages) pagesArray = [
            ...pagesArray,
            pageNumber + 1
        ];
        return pagesArray;
    };
});
parcelRegister("6OZOz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1f1c5eb6647072e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a1f1c5eb6647072e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        categoriesHeader: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.categories-header",
            "defaultMessage": "Categories"
        },
        noCategoriesTooltip: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.no-categories-tooltip",
            "defaultMessage": "Categories are not available for spaces linked from Confluence Data Center sites."
        },
        noCategoriesRow: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.no-categories-row",
            "defaultMessage": "Not available."
        },
        updateCategoriesHeader: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.update-categories-header",
            "defaultMessage": "Categories"
        },
        linkedSpacesHeader: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.linked-spaces-header",
            "defaultMessage": "Space"
        },
        tooltipText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.all-articles-table.tooltip-text",
            "defaultMessage": "Opens in new tab"
        }
    });
});
parcelRegister("6oq8N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6011c25cb54478d1$export$2e2bcd8739ae039);
    var $6011c25cb54478d1$export$2e2bcd8739ae039 = (s, defaultValue)=>{
        if (s === undefined || s === null) return undefined;
        const num = parseInt(s, 10);
        if (Number.isNaN(num)) return defaultValue;
        return num;
    };
});
parcelRegister("eyGOx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a31afb52b11d9ee2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $gccSB = parcelRequire("gccSB");
    var $ajpes = parcelRequire("ajpes");
    var $ebyGx = parcelRequire("ebyGx");
    var $daJ0i;
    var $fVnbM;
    var $BLPHT;
    var $jFrow;
    var $2RlqF;
    var $1dJ6S;
    var $6Ingq;
    var $2C7j9;
    var $77ZoC;
    var $dC5iT;
    var $8CUq3;
    var $kY99m;
    var $hZHze;
    var $1u3Jv;
    var $7XYc4;
    var $ousew;
    var $8RXs9;
    var $3HwlS;
    var $8n9Eh;
    var $7Mned = parcelRequire("7Mned");
    var $2bFEE;
    var $5RVjC;
    var $lw2HC;
    var $lnrq2;
    var $bPEAu;
    var $h5R5L;
    var $fa2qL;
    var $01ehM;
    var $hAcT9 = parcelRequire("hAcT9");
    var $c9JME;
    var $8WALy;
    var $jbwMx;
    var $6geWD;
    var $crHrE;
    var $1ydSB;
    var $500iy;
    const $a31afb52b11d9ee2$var$renderLinkedButton = ({ articleUrl: articleUrl, onCreateArticleHeaderClicked: onCreateArticleHeaderClicked, intl: intl, appLinkOrError: appLinkOrError })=>{
        const isConfluenceServerAppLink = Boolean(!appLinkOrError?.error && appLinkOrError?.isServer);
        if (!isConfluenceServerAppLink) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lw2HC")).UserCapabilitiesSubscriber), null, ({ data: data })=>{
            const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { editableSpaces: editableSpaces } } = data;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bPEAu")).CreateArticleButton), {
                spaces: editableSpaces,
                hasConfluenceLicense: hasConfluenceLicense
            });
        });
        if (articleUrl) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8n9Eh")).default), {
            href: articleUrl,
            onClick: onCreateArticleHeaderClicked,
            appearance: "primary",
            spacing: "default"
        }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).createArticleCta));
        return null;
    };
    class $a31afb52b11d9ee2$export$cdc9d8ce4adcf011 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                page: 1,
                error: undefined,
                categoriesSupported: true,
                onCreateArticleHeaderClicked: undefined,
                onCreateArticleEmptyStateClicked: undefined
            };
        }
        static getDerivedStateFromProps(props, state) {
            if (!props.isLoading && !state.hasLoaded) return {
                hasLoaded: true
            };
            return null;
        }
        componentDidMount() {
            const { onFetchAppLink: onFetchAppLink, getLinkedSpaces: getLinkedSpaces, projectKey: projectKey } = this.props;
            onFetchAppLink();
            getLinkedSpaces({
                projectKey: projectKey
            });
        }
        componentDidUpdate(prevProps) {
            const { searchQuery: searchQuery, spaceKeys: spaceKeys, page: page, sortBy: sortBy, appLinkOrError: appLinkOrError } = this.props;
            if (page !== prevProps.page || sortBy !== prevProps.sortBy || searchQuery !== prevProps.searchQuery || !(0, ($parcel$interopDefault($ajpes)))(Object.keys(spaceKeys), Object.keys(prevProps.spaceKeys)) || !prevProps.appLinkOrError?.error && appLinkOrError?.requireCredentials === false && appLinkOrError?.requireCredentials !== prevProps.appLinkOrError?.requireCredentials) this.refreshArticles();
        }
        refreshArticles() {
            const { cursor: cursor, searchQuery: searchQuery, spaceKeys: spaceKeys, page: page, sortBy: sortBy, onBrowseArticles: onBrowseArticles, limit: limit, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            let browseObj = {
                id: 'all-articles',
                page: page,
                limit: limit,
                expand: [
                    'viewCount',
                    'category'
                ],
                orderBy: sortBy,
                createAnalyticsEvent: createAnalyticsEvent
            };
            if (cursor) browseObj = {
                ...browseObj,
                cursor: cursor
            };
            if (searchQuery) browseObj = {
                ...browseObj,
                query: searchQuery
            };
            const spaces = Object.keys(spaceKeys);
            if (spaces.length) browseObj = {
                ...browseObj,
                spaceKey: spaces
            };
            onBrowseArticles(browseObj);
        }
        triggerText(spaces) {
            const { intl: intl } = this.props;
            const { length: length } = Object.keys(spaces);
            let spaceName = '';
            if (length === 1) {
                const key = Object.keys(spaces)[0];
                spaceName = spaces[key].length > 15 ? `${spaces[key].substr(0, 15)}...` : spaces[key];
            }
            return intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).spacesDropdownText, {
                count: length,
                spaceName: spaceName
            });
        }
        getDropdownItemsV2(linkedSpaces) {
            const { spacesSelected: spacesSelected } = this.state;
            const dropdownItems = linkedSpaces.map((space, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jFrow")).default), {
                    key: index,
                    id: space.spaceKey,
                    onClick: this.onSpacesToggled,
                    isSelected: space.spaceKey in spacesSelected
                }, space.spaceName));
            return dropdownItems;
        }
        content(articleUrl, showSpaceColumn, canViewSpaceUrl) {
            const { articlesPage: articlesPage, page: page, sortBy: sortBy, intl: intl, limit: limit, ArticlesTable: ArticlesTable, nextCursor: nextCursor, prevCursor: prevCursor, searchQuery: searchQuery, spaceKeys: spaceKeys, categoriesSupported: categoriesSupported, appLinkOrError: appLinkOrError } = this.props;
            let creatingLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: articleUrl,
                target: "_blank",
                rel: "noreferrer noopener"
            }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).creatingArticleDescription));
            const isConfluenceServerAppLink = Boolean(!appLinkOrError?.error && appLinkOrError?.isServer);
            if (!isConfluenceServerAppLink) creatingLink = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lw2HC")).UserCapabilitiesSubscriber), null, ({ data: data })=>{
                const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { editableSpaces: editableSpaces } } = data;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bPEAu")).CreateArticleButton), {
                    spaces: editableSpaces,
                    appearance: "link",
                    hasConfluenceLicense: hasConfluenceLicense
                }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).creatingArticleDescription));
            });
            const emptyStateComponentMultipleSpaces = (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$ImgContainer, {
                src: (0, ($parcel$interopDefault($hAcT9))),
                alt: "no article present"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateMiddleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "medium"
            }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).noArticlesTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$CreateArticleLinkButton, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("1ydSB")).default).noArticlesDescriptionMultipleSpaces,
                values: {
                    creating: creatingLink
                }
            })));
            const noSearchResultsComponent = (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$ImgContainer, {
                src: (0, ($parcel$interopDefault($7Mned))),
                alt: "no article found"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$EmptyStateMiddleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "medium"
            }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).noArticlesTitleMultipleSpaces))), (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$CreateArticleLinkButton, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("1ydSB")).default).noArticlesDescriptionMultipleSpaces,
                values: {
                    creating: creatingLink
                }
            })));
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ArticlesTable, {
                limit: limit,
                page: page,
                sortBy: sortBy,
                categoriesSupported: categoriesSupported,
                totalSize: articlesPage?.totalSize,
                knowledgePieces: articlesPage?.articles,
                emptyStateComponent: emptyStateComponentMultipleSpaces,
                noSearchResultsComponent: noSearchResultsComponent,
                nextCursor: nextCursor,
                prevCursor: prevCursor,
                searchQuery: searchQuery,
                spaceKeys: spaceKeys,
                showSpaceColumn: showSpaceColumn,
                canViewSpaceUrl: canViewSpaceUrl,
                appLinkOrError: appLinkOrError
            });
        }
        renderBottomBar() {
            const { intl: intl, categoriesSupported: categoriesSupported, isAdmin: isAdmin, projectKey: projectKey } = this.props;
            const settingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`;
            if (!categoriesSupported) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).welcomeDescriptionNoCategories));
            const CustomDescription = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $a31afb52b11d9ee2$var$DescriptionV2 : $a31afb52b11d9ee2$var$Description;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(CustomDescription, null, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).welcomeDescriptionNew), " ") : (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).welcomeDescriptionNew)), isAdmin ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("1ydSB")).default).welcomeDescriptionAdmins,
                values: {
                    linkText: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: settingsUrl,
                        className: (0, (0, parcelRequire("bwpsq")).default)([
                            "_4bfu18uv _1hms8stv _ajmmnqa1"
                        ])
                    }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).welcomeDescriptionAdminsLink))
                }
            }) : null);
        }
        renderAllArticlesView() {
            const { intl: intl, confluenceUrl: confluenceUrl, spaceKey: spaceKey, onCreateArticleHeaderClicked: onCreateArticleHeaderClicked, ReadyForUser: ReadyForUser, appLinkOrError: appLinkOrError, articlesPage: articlesPage } = this.props;
            const { hasLoaded: hasLoaded } = this.state;
            const articleUrl = confluenceUrl && spaceKey && `${confluenceUrl}/display/${spaceKey}?createDialog=true`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2bFEE")).KbContentContainer), null, hasLoaded && articlesPage && articlesPage.totalSize >= 0 && (0, ($parcel$interopDefault($5uXOq))).createElement(ReadyForUser, {
                metricKey: "servicedesk.knowledge.articles",
                metric: (0, (0, parcelRequire("500iy")).articlesPageLoad)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), hasLoaded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $a31afb52b11d9ee2$var$confluenceUpsellContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnrq2")).ConfluenceUpsellMessage), null)), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderBottomBar()) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6geWD")).default), {
                truncateTitle: true,
                bottomBar: this.renderBottomBar(),
                actions: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fa2qL")).ActionsGroup), {
                    spacing: "wide"
                }, $a31afb52b11d9ee2$var$renderLinkedButton({
                    articleUrl: articleUrl,
                    onCreateArticleHeaderClicked: onCreateArticleHeaderClicked,
                    intl: intl,
                    appLinkOrError: appLinkOrError
                }))
            }, intl.formatMessage((0, (0, parcelRequire("jbwMx")).default).articlesPageHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("01ehM")).default), {
                onAuthComplete: this.onAuthComplete
            }, this.renderAllArticleSearchAndTable(articleUrl)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9JME")).DraftArticleSuccessFlags), null));
        }
        renderSearchContainer(readableSpaces, hasMultipleLinkedSpaces) {
            const { intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$SearchContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$TextFieldContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                elemAfterInput: this.state.query.length ? (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$IconWrapper, {
                    onClick: this.onRemoveText
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))), {
                    size: "medium",
                    label: "close"
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("77ZoC"))))), {
                    size: "medium",
                    label: "",
                    "aria-hidden": "true"
                })),
                onChange: this.onTextEntered,
                placeholder: intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).searchPlaceholder),
                value: this.state.query,
                isCompact: true,
                "aria-label": intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).searchLabelText),
                "aria-describedby": "hintText"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                id: "hintText",
                hidden: true
            }, intl.formatMessage((0, (0, parcelRequire("1ydSB")).default).searchArticlesHintText))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, hasMultipleLinkedSpaces && (0, ($parcel$interopDefault($5uXOq))).createElement($a31afb52b11d9ee2$var$DropdownContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
                trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        ...props,
                        ref: triggerRef,
                        iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                            label: ""
                        })
                    }, this.state.dropdownText)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2RlqF")).default), {
                id: "spaces-dropdown"
            }, this.getDropdownItemsV2(readableSpaces))))));
        }
        renderAllArticleSearchAndTable(articleUrl) {
            const { intl: intl, onCreateArticleHeaderClicked: onCreateArticleHeaderClicked, appLinkOrError: appLinkOrError } = this.props;
            const { projectKey: projectKey, articlesPage: articlesPage } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lw2HC")).UserCapabilitiesSubscriber), null, ({ data: data })=>{
                const { hasConfluenceLicense: hasConfluenceLicense, spaceUserCapabilities: { readableSpaces: readableSpaces } } = data;
                const totalSize = readableSpaces.length;
                const hasMultipleLinkedSpaces = totalSize > 1;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5RVjC")).KnowledgeBaseActionsGroup), null, this.renderSearchContainer(readableSpaces, hasMultipleLinkedSpaces), $a31afb52b11d9ee2$var$renderLinkedButton({
                    articleUrl: articleUrl,
                    onCreateArticleHeaderClicked: onCreateArticleHeaderClicked,
                    intl: intl,
                    appLinkOrError: appLinkOrError
                })) : this.renderSearchContainer(readableSpaces, hasMultipleLinkedSpaces), this.content(articleUrl, hasMultipleLinkedSpaces, hasConfluenceLicense), articlesPage && articlesPage.articles.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("crHrE")).default), {
                    projectKey: projectKey
                }));
            });
        }
        renderAllArticlesViewWithAnalytics() {
            const { articlesPage: articlesPage, appLinkOrError: appLinkOrError } = this.props;
            if (articlesPage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
                data: {
                    source: `knowledgeBrowseAllArticleSuccess${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
                    attributes: {
                        isConfluenceServer: Boolean(!appLinkOrError?.error && appLinkOrError?.isServer)
                    }
                }
            }, this.renderAllArticlesView());
            return this.renderAllArticlesView();
        }
        render() {
            const { error: error, linkedState: linkedState, appLinkOrError: appLinkOrError, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId } = this.props;
            if (error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8WALy")).default), {
                error: error.error,
                screenName: "knowledgeBrowseAllArticleError",
                attributes: {
                    isConfluenceServer: Boolean(!appLinkOrError?.error && appLinkOrError?.isServer)
                }
            });
            if (linkedState === 'unlinked') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h5R5L")).default), {
                to: "/knowledge/setup"
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lw2HC")).UserCapabilitiesSubscriber), null, (_, { fetchUserCapabilities: fetchUserCapabilities })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
                    op: fetchUserCapabilities,
                    args: [
                        projectId,
                        activationId,
                        createAnalyticsEvent({})
                    ]
                }), this.renderAllArticlesViewWithAnalytics()));
        }
        constructor(...args){
            super(...args);
            this.state = {
                hasLoaded: false,
                spacesSelected: this.props.spaceKeys || {},
                query: this.props.searchQuery || '',
                dropdownText: this.triggerText(this.props.spaceKeys)
            };
            this.onSetPage = (removeText)=>{
                const { push: push, history: history, sortBy: sortBy } = this.props;
                const { spacesSelected: spacesSelected, query: query } = this.state;
                const spacesLength = Object.keys(spacesSelected).length;
                const spacekeyNames = (0, ($parcel$interopDefault($gccSB)))(spacesSelected) ? null : JSON.stringify(spacesSelected);
                let queryParams = {
                    sortBy: sortBy
                };
                if (removeText && spacesLength > 0) queryParams = {
                    ...queryParams,
                    spaceKey: spacekeyNames
                };
                else if (!removeText) queryParams = {
                    ...queryParams,
                    searchQuery: query,
                    spaceKey: spacekeyNames
                };
                push ? push(`/knowledge/browse/page/1?${(0, ($parcel$interopDefault($ebyGx))).stringify(queryParams, {
                    skipNull: true,
                    skipEmptyString: true
                })}`) : history.push(`/knowledge/browse/page/1?${(0, ($parcel$interopDefault($ebyGx))).stringify(queryParams, {
                    skipNull: true,
                    skipEmptyString: true
                })}`);
            };
            this.debouncedSearch = (0, ($parcel$interopDefault($lFKmC)))(this.onSetPage, 300);
            this.onTextEntered = (e)=>{
                const newText = e.currentTarget.value;
                this.setState({
                    query: newText != null ? newText : ''
                });
                this.debouncedSearch(false);
            };
            this.onRemoveText = ()=>{
                this.setState({
                    query: ''
                });
                this.debouncedSearch(true);
            };
            this.onSpacesToggled = (e)=>{
                const spaceKey = e.currentTarget.id;
                const spaceName = e.currentTarget.textContent;
                this.setState((state)=>{
                    let spacesSelected = {};
                    if (spaceKey in state.spacesSelected) {
                        spacesSelected = Object.keys(state.spacesSelected).reduce((acc, key)=>{
                            if (key !== spaceKey) acc[key] = state.spacesSelected[key];
                            return acc;
                        }, {});
                        return {
                            spacesSelected: spacesSelected,
                            dropdownText: this.triggerText(spacesSelected)
                        };
                    }
                    spacesSelected = {
                        ...state.spacesSelected,
                        [spaceKey]: spaceName
                    };
                    return {
                        spacesSelected: spacesSelected,
                        dropdownText: this.triggerText(spacesSelected)
                    };
                }, ()=>{
                    const removeText = (0, ($parcel$interopDefault($gccSB)))(this.state.spacesSelected);
                    this.onSetPage(removeText);
                });
            };
            this.onAuthComplete = (error)=>{
                if (!error) {
                    this.refreshArticles();
                    this.props.onFetchAppLink();
                }
            };
        }
    }
    var $a31afb52b11d9ee2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a31afb52b11d9ee2$export$cdc9d8ce4adcf011);
    const $a31afb52b11d9ee2$var$DropdownContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4otz2 _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$TextFieldContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbp3fh _4t3izwfg _prm018iy",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _80omtlke _syaz1thw _2hwx1b66",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12fbxu3",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$DescriptionV2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$EmptyStateContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _4t3i1952",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$EmptyStateMiddleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _18s81hz4",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$ImgContainer = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1lit _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$confluenceUpsellContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.300'
    });
    const $a31afb52b11d9ee2$var$CreateArticleLinkButton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xdi1txw _18vq1h6o _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$SearchContainerOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18s814vf",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$SearchContainerNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $a31afb52b11d9ee2$var$SearchContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $a31afb52b11d9ee2$var$SearchContainerNew, $a31afb52b11d9ee2$var$SearchContainerOld);
});
parcelRegister("jFrow", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d90ebe7a2adf26d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $j7LBE;
    var $kJpBP;
    var $VSDnB;
    var $hEtee;
    var $6PlGW;
    var $l7Q0F;
    var $6cAn5 = parcelRequire("6cAn5");
    const $9d90ebe7a2adf26d$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, (0, parcelRequire("eGmKJ")).default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, ...rest })=>{
        typeof $6cAn5;
        const [selected, setSelected] = (0, (0, parcelRequire("6PlGW")).default)({
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        });
        const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
            setSelected((selected)=>!selected);
            providedOnClick(event);
        }, [
            providedOnClick,
            setSelected
        ]);
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "aria-checked": selected,
            description: description,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEtee")).default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children));
    };
    var $9d90ebe7a2adf26d$export$2e2bcd8739ae039 = $9d90ebe7a2adf26d$var$DropdownItemCheckbox;
});
parcelRegister("hEtee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$181f17e87025e1b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $181f17e87025e1b2$var$CheckboxIcon = ({ checked: checked })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            size: "medium",
            primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
            secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2",
            stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
            strokeWidth: 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        })));
    };
    var $181f17e87025e1b2$export$2e2bcd8739ae039 = $181f17e87025e1b2$var$CheckboxIcon;
});
parcelRegister("6PlGW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e2d30248a719600$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5MgQz;
    var $iY6id;
    const $3e2d30248a719600$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
        const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iY6id")).SelectionStoreContext));
        const groupId = (0, $5uXOq.useContext)((0, (0, parcelRequire("5MgQz")).CheckboxGroupContext));
        const persistedIsSelected = getItemState(groupId, id);
        const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
        const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        }, [
            setItemState,
            persistedIsSelected,
            groupId,
            id
        ]);
        if (typeof isSelected === 'boolean') return [
            isSelected,
            ()=>false
        ];
        if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
        return [
            localIsSelected,
            setLocalState
        ];
    };
    var $3e2d30248a719600$export$2e2bcd8739ae039 = $3e2d30248a719600$var$useCheckboxState;
});
parcelRegister("5MgQz", function(module, exports) {
    $parcel$export(module.exports, "CheckboxGroupContext", ()=>$155fc86a3d14dca7$export$baf37c4be89255b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $155fc86a3d14dca7$export$baf37c4be89255b8 = (0, $5uXOq.createContext)('');
});
parcelRegister("2RlqF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af961a681c518d6f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    var $5MgQz;
    const $af961a681c518d6f$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, ...rest })=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MgQz")).CheckboxGroupContext).Provider, {
            value: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children));
    };
    var $af961a681c518d6f$export$2e2bcd8739ae039 = $af961a681c518d6f$var$DropdownItemCheckboxGroup;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("8n9Eh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ef60ceb7a2a29db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $17Ngn;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $az4zD;
    var $jsotm;
    const $0ef60ceb7a2a29db$export$2c7b2957f409c48f = ({ href: href, children: children, intl: intl, onClick: onClick, appearance: appearance, spacing: spacing, showShortcutIcon: showShortcutIcon })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            tag: "span",
            content: intl.formatMessage((0, (0, parcelRequire("jsotm")).default).opensInNewWindow),
            position: "mouse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            href: href,
            appearance: appearance,
            target: "_blank",
            spacing: spacing,
            onClick: onClick,
            iconAfter: showShortcutIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $0ef60ceb7a2a29db$var$iconContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))), {
                size: "small",
                label: intl.formatMessage((0, (0, parcelRequire("jsotm")).default).opensInNewWindow)
            })) : undefined
        }, children));
    $0ef60ceb7a2a29db$export$2c7b2957f409c48f.defaultProps = {
        onClick: undefined,
        showShortcutIcon: true,
        appearance: 'link',
        spacing: 'none'
    };
    var $0ef60ceb7a2a29db$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0ef60ceb7a2a29db$export$2c7b2957f409c48f);
    const $0ef60ceb7a2a29db$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("jsotm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15876084b060a35f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $15876084b060a35f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        opensInNewWindow: {
            "id": "packages-components-external-link-button.opens-in-new-window",
            "defaultMessage": "Opens in a new window"
        }
    });
});
parcelRegister("7Mned", function(module, exports) {
    module.exports = new URL("no-search-results.6374065e.svg", import.meta.url).toString();
});
parcelRegister("2bFEE", function(module, exports) {
    $parcel$export(module.exports, "KbContentContainer", ()=>$50c210293a065a94$export$e934deb0c7d071e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $76Pt6;
    var $7XYc4;
    var $3HwlS;
    const $50c210293a065a94$var$ContentContainer = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("76Pt6")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f31ylp _n3tdidpf _19bv1ylp _c71ln9zg _1tkevzbd _18m91wug",
                __cmplp.className
            ])
        });
    });
    const $50c210293a065a94$export$e934deb0c7d071e3 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $50c210293a065a94$var$ContentContainer, (0, (0, parcelRequire("76Pt6")).default));
});
parcelRegister("76Pt6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e8f5c76234b0565$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $3e8f5c76234b0565$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1kx0 _n3tdxy5q _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5RVjC", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeBaseActionsGroup", ()=>$7a0c98ae5ac88dec$export$dfa8c27f632e3d83);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $7a0c98ae5ac88dec$export$dfa8c27f632e3d83 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2lx2vrvc _1bah1yb4 _19pkpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lnrq2", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceUpsellMessage", ()=>$088998d382619c87$export$ca7f6480275ab29d);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $088998d382619c87$export$e1d31e559621e077 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("5at10")).then((module)=>module.ConfluenceUpsellMessage), {
        ssr: false,
        moduleId: "./src/packages/servicedesk/knowledge-common/src/ui/confluence-upsell-message/main.tsx"
    });
    const $088998d382619c87$export$ca7f6480275ab29d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-jsm-kb-confluence-upsell-message",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($088998d382619c87$export$e1d31e559621e077, props));
});
parcelRegister("5at10", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8DfwA")
    ]).then(()=>parcelRequire('lxp3d'));
});
parcelRegister("bPEAu", function(module, exports) {
    $parcel$export(module.exports, "CreateArticleButton", ()=>$4f6e7c1b7c412477$export$f5c14624fc49c9fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $koVbs;
    var $8zOmE;
    var $5eEzC;
    var $lw2HC;
    var $k1uJZ;
    var $byhrn;
    const $4f6e7c1b7c412477$export$f5c14624fc49c9fb = ({ spaces: spaces, appearance: appearance = 'primary', children: children, hasConfluenceLicense: hasConfluenceLicense })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [showModal, toggleModal] = (0, $5uXOq.useState)(false);
        const [isFetchingDraftDetails] = (0, (0, parcelRequire("lw2HC")).useIsFetchingDraftDetails)();
        const { navigateToEditor: navigateToEditor } = (0, (0, parcelRequire("5eEzC")).useNavigateToEditor)({
            spaces: spaces
        });
        const showCreateArticleModal = (e, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'createArticleBtn clicked', {
                hasConfluenceLicense: Boolean(hasConfluenceLicense)
            });
            if (spaces.length === 1) navigateToEditor();
            else toggleModal(true);
        };
        const hideCreateArticleModal = ()=>{
            toggleModal(false);
        };
        const isSSR = false;
        const text = children !== undefined ? children : intl.formatMessage((0, (0, parcelRequire("k1uJZ")).default).text);
        return !isSSR && spaces.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, spaces.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: appearance,
            onClick: showCreateArticleModal,
            isLoading: isFetchingDraftDetails
        }, text) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: appearance,
            onClick: showCreateArticleModal
        }, text), showModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("byhrn")).CreateArticleModal), {
            onCancel: hideCreateArticleModal
        })) : null;
    };
});
parcelRegister("5eEzC", function(module, exports) {
    $parcel$export(module.exports, "useNavigateToEditor", ()=>$d35a8ee373bc035a$export$bd39fc26850ad4a0);
    var $2NMNM;
    var $gq0sA;
    var $doZTA;
    var $lw2HC;
    const $d35a8ee373bc035a$export$bd39fc26850ad4a0 = ({ spaces: spaces, topicId: topicId, topicName: topicName })=>{
        const [, { fetchDraftAndNavigateToEditor: fetchDraftAndNavigateToEditor }] = (0, (0, parcelRequire("lw2HC")).useIsPermittedSpaces)();
        const [{ data: pageContextData }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const [routerState, routerActions] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const navigateToEditor = ()=>{
            const { projectContext: projectContext } = pageContextData || {};
            const { projectKey: projectKey, projectId: projectId } = projectContext || {};
            const [{ spaceKey: spaceKey }] = spaces;
            projectKey && projectId && fetchDraftAndNavigateToEditor({
                spaceKey: spaceKey,
                routerActions: routerActions,
                projectKey: projectKey,
                projectId: projectId,
                onCloseRedirectUrl: routerState.location.pathname,
                analyticsEvent: createAnalyticsEvent({}),
                topicId: topicId,
                topicName: topicName
            });
        };
        return {
            navigateToEditor: navigateToEditor
        };
    };
});
parcelRegister("gq0sA", function(module, exports) {
    $parcel$export(module.exports, "usePageContext", ()=>$2299d7a4f1092420$export$9c25024bdfe755f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    var $9OXo1;
    var $dFOAR;
    const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache);
    const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
        const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
        const pageContextData = (0, $5uXOq.useMemo)(()=>({
                data: projectContext && serviceDeskContext ? {
                    serviceDeskContext: {
                        portalId: serviceDeskContext.portalId,
                        portalUrl: serviceDeskContext.portalUrl,
                        canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                        userRole: serviceDeskContext.userRole,
                        serviceDeskId: serviceDeskContext.serviceDeskId
                    },
                    projectContext: {
                        projectId: projectContext.projectId,
                        projectKey: projectContext.projectKey,
                        projectName: projectContext.projectName,
                        projectType: projectContext.projectType,
                        isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                        isProjectSimplified: projectContext.simplified
                    },
                    tenantContext: {
                        baseUrl: tenantContext.baseUrl,
                        locale: tenantContext.locale,
                        userFullname: tenantContext.userFullname,
                        cloudId: tenantContext.cloudId,
                        fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                        atlassianAccountId: tenantContext.atlassianAccountId,
                        isJiraAdmin: tenantContext.isAdmin,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        activationId: tenantContext.activationId
                    }
                } : null,
                loading: projectContextLoading || serviceDeskLoading,
                error: serviceDeskError || projectContextError || null
            }), [
            tenantContext,
            projectContext,
            serviceDeskContext,
            projectContextLoading,
            serviceDeskLoading,
            serviceDeskError,
            projectContextError
        ]);
        return [
            pageContextData
        ];
    };
});
parcelRegister("dFOAR", function(module, exports) {
    $parcel$export(module.exports, "useServiceDeskContext", ()=>$6c09349e97fba749$export$712ead87353ac687);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $cAofY;
    const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, (0, parcelRequire("cAofY")).serviceDeskContextResource);
    const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
});
parcelRegister("k1uJZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b2097b861ad43d4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1b2097b861ad43d4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        text: {
            "id": "servicedesk-knowledge-common.create-article-button.text",
            "defaultMessage": "Create article"
        }
    });
});
parcelRegister("byhrn", function(module, exports) {
    $parcel$export(module.exports, "CreateArticleModal", ()=>$2684c4d3c9ab97e5$export$d133e5d0f26fab46);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $1dJ6S;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $7K5PP;
    var $9fuVs;
    var $gwIPs;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $2NMNM;
    var $gq0sA;
    var $doZTA;
    var $lw2HC;
    var $bl4L1;
    const $2684c4d3c9ab97e5$export$3d931b64f46140b3 = `${(0, (0, parcelRequire("gwIPs")).gridSize) * 51}px`;
    const $2684c4d3c9ab97e5$export$d133e5d0f26fab46 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onCancel: onCancel, topicId: topicId, topicName: topicName } = props;
        const [routerState, routerActions] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [selectedSpaceKey, updateSelectedSpaceKey] = (0, $5uXOq.useState)('');
        const [{ data: pageContextData }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext } = pageContextData || {};
        const { projectKey: projectKey, projectId: projectId } = projectContext || {};
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFetchingDraftDetails, { fetchDraftAndNavigateToEditor: fetchDraftAndNavigateToEditor }] = (0, (0, parcelRequire("lw2HC")).useIsFetchingDraftDetails)();
        const [{ data: userPermissionData }] = (0, (0, parcelRequire("lw2HC")).useUserCapabilities)();
        const { spaceUserCapabilities: { editableSpaces: editableSpaces } } = userPermissionData;
        const fetchDraftAndNavigateToRoute = async ()=>{
            fetchDraftAndNavigateToEditor({
                spaceKey: selectedSpaceKey,
                routerActions: routerActions,
                projectKey: projectKey,
                projectId: projectId,
                onCloseRedirectUrl: routerState.location.pathname,
                analyticsEvent: createAnalyticsEvent({}),
                topicId: topicId,
                topicName: topicName
            });
        };
        const onSpaceChanged = (newValue, actionMeta)=>{
            if (actionMeta.action === 'select-option' && newValue) {
                const selectedValue = newValue.value;
                updateSelectedSpaceKey(selectedValue);
            }
        };
        const options = editableSpaces.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                label: spaceName,
                value: spaceKey
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "createArticle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            onClose: onCancel,
            shouldCloseOnOverlayClick: !isFetchingDraftDetails,
            shouldCloseOnEscapePress: !isFetchingDraftDetails,
            width: $2684c4d3c9ab97e5$export$3d931b64f46140b3
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("bl4L1")).default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($2684c4d3c9ab97e5$var$DropdownText, {
            htmlFor: "space-name-dropdown-field"
        }, formatMessage((0, (0, parcelRequire("bl4L1")).default).selectLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            placeholder: formatMessage((0, (0, parcelRequire("bl4L1")).default).selectPlaceholder),
            options: options,
            onChange: onSpaceChanged,
            menuPortalTarget: document.body,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            autoFocus: true,
            isDisabled: isFetchingDraftDetails,
            inputId: "space-name-dropdown-field"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onCancel,
            isDisabled: isFetchingDraftDetails
        }, formatMessage((0, (0, parcelRequire("bl4L1")).default).cancelBtnText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: fetchDraftAndNavigateToRoute,
            isLoading: isFetchingDraftDetails,
            isDisabled: !selectedSpaceKey.length
        }, formatMessage((0, (0, parcelRequire("bl4L1")).default).nextBtnText))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $2684c4d3c9ab97e5$var$dropdownTextStyles = null;
    const $2684c4d3c9ab97e5$var$DropdownText = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: props.htmlFor,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _19pkidpf _syaz1a45 _1p1dglyw _otyru2gc"
            ])
        }, props.children));
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("bl4L1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd29a61777741ba6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fd29a61777741ba6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "servicedesk-knowledge-common.create-article-button.modal.heading",
            "defaultMessage": "Create article"
        },
        selectLabel: {
            "id": "servicedesk-knowledge-common.create-article-button.modal.select-label",
            "defaultMessage": "Select a knowledge base space"
        },
        selectPlaceholder: {
            "id": "servicedesk-knowledge-common.create-article-button.modal.select-placeholder",
            "defaultMessage": "Enter a space name"
        },
        cancelBtnText: {
            "id": "servicedesk-knowledge-common.create-article-button.modal.cancel-btn-text",
            "defaultMessage": "Cancel"
        },
        nextBtnText: {
            "id": "servicedesk-knowledge-common.create-article-button.modal.next-btn-text",
            "defaultMessage": "Next"
        }
    });
});
parcelRegister("fa2qL", function(module, exports) {
    $parcel$export(module.exports, "ActionsGroup", ()=>$460476f4e164920a$export$eb2f32c5b862d0df);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $460476f4e164920a$export$eb2f32c5b862d0df = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_9eb86w": (0, (0, parcelRequire("lD23V")).default)(__cmplp.spacing === 'wide' ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1ko9chmj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("01ehM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa13ece35ec61c84$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fCYod;
    var $8NcsG;
    const $fa13ece35ec61c84$var$mapStateToProps = (state)=>({
            appLinkOrError: (0, (0, parcelRequire("fCYod")).getAppLinkOrError)(state)
        });
    const $fa13ece35ec61c84$var$Connected = (0, (0, parcelRequire("bC2fB")).connect)($fa13ece35ec61c84$var$mapStateToProps, {})((0, (0, parcelRequire("8NcsG")).default));
    var $fa13ece35ec61c84$export$2e2bcd8739ae039 = $fa13ece35ec61c84$var$Connected;
});
parcelRegister("8NcsG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$108df07c81877786$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $h6QPt;
    var $fxVD7;
    var $OuhAr;
    var $8gk33;
    const $108df07c81877786$export$42e634e63dba5325 = ({ appLinkOrError: appLinkOrError, children: children, onAuthComplete: onAuthComplete })=>{
        if (!appLinkOrError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8gk33")).SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            delay: 300
        }));
        if (appLinkOrError.error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fxVD7")).default), null);
        if (appLinkOrError.requireCredentials) {
            const onAuthenticate = async ()=>{
                try {
                    await (0, (0, parcelRequire("h6QPt")).default)(appLinkOrError.authUrl);
                    onAuthComplete();
                } catch (error) {
                    onAuthComplete(error);
                }
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OuhAr")).default), {
                onAuthenticate: onAuthenticate
            });
        }
        return children;
    };
    var $108df07c81877786$export$2e2bcd8739ae039 = $108df07c81877786$export$42e634e63dba5325;
});
parcelRegister("h6QPt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c756de6db687f03$export$2e2bcd8739ae039);
    const $0c756de6db687f03$var$authenticateUsingAppLinks = (url)=>{
        if (window.oauthCallback) return null;
        const result = new Promise((resolve, reject)=>{
            let oauthWindow;
            let timer;
            let isPending = true;
            const oauthCallback = {
                success: ()=>{
                    clearInterval(timer);
                    resolve();
                    isPending = false;
                    delete window.oauthCallback;
                    oauthWindow && oauthWindow.close();
                },
                failure: ()=>{
                    clearInterval(timer);
                    reject(Error('Failed to authenticate with applinks'));
                    isPending = false;
                    delete window.oauthCallback;
                    oauthWindow && oauthWindow.close();
                }
            };
            window.oauthCallback = oauthCallback;
            oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
            timer = setInterval(()=>{
                if (oauthWindow && oauthWindow.closed && isPending) {
                    delete window.oauthCallback;
                    reject(Error('Failed to authenticate with applinks'));
                    clearInterval(timer);
                }
            }, 500);
        });
        return result;
    };
    var $0c756de6db687f03$export$2e2bcd8739ae039 = $0c756de6db687f03$var$authenticateUsingAppLinks;
});
parcelRegister("fxVD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$112a70946b83e16d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $6z7Gx;
    var $cIhXH;
    const $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: {
                    context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIhXH")).default), props));
    var $112a70946b83e16d$export$2e2bcd8739ae039 = $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics;
});
parcelRegister("cIhXH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$889aaaaf1f3263e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $75gFv = parcelRequire("75gFv");
    var $13x0I;
    var $hW1Vu;
    const $889aaaaf1f3263e7$export$e0621c26812fcde2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
            imageUrl: (0, ($parcel$interopDefault($75gFv))),
            header: formatMessage((0, (0, parcelRequire("hW1Vu")).default).applinkErrorHeader),
            description: formatMessage((0, (0, parcelRequire("hW1Vu")).default).applinkErrorMessage)
        });
    };
    var $889aaaaf1f3263e7$export$2e2bcd8739ae039 = $889aaaaf1f3263e7$export$e0621c26812fcde2;
});
parcelRegister("hW1Vu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbfeba0604b7d141$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fbfeba0604b7d141$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        applinkErrorHeader: {
            "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-header",
            "defaultMessage": "We couldn\u2019t load this article"
        },
        applinkErrorMessage: {
            "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-message",
            "defaultMessage": "Refresh and try again"
        }
    });
});
parcelRegister("OuhAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19f2d1dc625a92a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $6z7Gx;
    var $8xabp;
    const $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xabp")).default), props));
    var $19f2d1dc625a92a7$export$2e2bcd8739ae039 = $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics;
});
parcelRegister("8xabp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4394b6b9f879006e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $gs7PQ;
    var $koVbs;
    var $i9Ubb = parcelRequire("i9Ubb");
    var $13x0I;
    var $jam2I;
    const $4394b6b9f879006e$export$9277c11b36960dfe = ({ onAuthenticate: onAuthenticate })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onActionClick = ()=>{
            onAuthenticate();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
            imageUrl: (0, ($parcel$interopDefault($i9Ubb))),
            header: "",
            description: formatMessage((0, (0, parcelRequire("jam2I")).default).pageDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gs7PQ"))))), {
                    label: "authenticate"
                }),
                appearance: "primary",
                onClick: onActionClick
            }, formatMessage((0, (0, parcelRequire("jam2I")).default).primaryAction))
        });
    };
    var $4394b6b9f879006e$export$2e2bcd8739ae039 = $4394b6b9f879006e$export$9277c11b36960dfe;
});
parcelRegister("gs7PQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
    function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>$bfa556ca72f8a34c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
        }, props, {
            newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
        }));
    $bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
    var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;
});
parcelRegister("bwyQI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $863db7350f859785$var$_UNSAFE_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $863db7350f859785$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $863db7350f859785$var$LockLockedIcon = (props)=>$863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
        }, props));
    $863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
    var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;
});
parcelRegister("i9Ubb", function(module, exports) {
    module.exports = new URL("authenticate-confluence.4d07da41.svg", import.meta.url).toString();
});
parcelRegister("jam2I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a812dd379bbb5f8f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a812dd379bbb5f8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pageDescription: {
            "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.page-description",
            "defaultMessage": "Authenticate with Confluence to access articles from your linked spaces."
        },
        primaryAction: {
            "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.primary-action",
            "defaultMessage": "Authenticate"
        }
    });
});
parcelRegister("8gk33", function(module, exports) {
    $parcel$export(module.exports, "SpinnerContainer", ()=>$e3e7bff9a8ffbf21$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $e3e7bff9a8ffbf21$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _4t3i1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hAcT9", function(module, exports) {
    module.exports = new URL("create-articles.766910dd.svg", import.meta.url).toString();
});
parcelRegister("c9JME", function(module, exports) {
    $parcel$export(module.exports, "DraftArticleSuccessFlags", ()=>$e2abc86780787baa$export$a396c03fd23667ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $9UIxp;
    var $rzE3E;
    var $6hrB4;
    const $e2abc86780787baa$export$a396c03fd23667ef = ()=>{
        const [kbCommonflags, resetDraftArticleData] = (0, (0, parcelRequire("9UIxp")).useKnowledgeCommonFlagHook)((0, (0, parcelRequire("6hrB4")).default));
        const onDismissed = ()=>{
            resetDraftArticleData(true);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("rzE3E")).KbFlags), {
            flags: kbCommonflags,
            onDismissed: onDismissed
        });
    };
});
parcelRegister("9UIxp", function(module, exports) {
    $parcel$export(module.exports, "useKnowledgeCommonFlagHook", ()=>$68535e79aa4458dd$export$71a682bd55aae872);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $lw2HC;
    const $68535e79aa4458dd$export$71a682bd55aae872 = (messages)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ id: id, type: type, title: title, description: description }, { resetDraftArticleData: resetDraftArticleData }] = (0, (0, parcelRequire("lw2HC")).useFlagData)(messages);
        const knowledgeCommonflags = id ? [
            {
                description: typeof description === 'string' ? '' : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), description),
                flagType: type,
                id: id,
                title: formatMessage(title)
            }
        ] : [];
        return [
            knowledgeCommonflags,
            resetDraftArticleData
        ];
    };
});
parcelRegister("rzE3E", function(module, exports) {
    $parcel$export(module.exports, "KbFlags", ()=>$a0b6ad285d45eb5a$export$3934d8be12f752d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dp5jO;
    var $dD7Zc;
    var $7R4eB;
    var $f2BYd;
    const $a0b6ad285d45eb5a$export$3934d8be12f752d2 = ({ flags: flags, onDismissed: onDismissed })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f2BYd")).default), {
            onDismissed: (id)=>{
                onDismissed(id);
            }
        }, flags.map(({ flagType: flagType, title: title, description: description, id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7R4eB")).default), {
                id: id,
                icon: flagType && flagType === (0, $3026c2757a468eb7$export$516433e8a6db7503) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dp5jO"))))), {
                    label: "Success",
                    color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
                    label: "Error",
                    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                }),
                key: id,
                title: title,
                description: description
            })));
    var $a0b6ad285d45eb5a$export$2e2bcd8739ae039 = $a0b6ad285d45eb5a$export$3934d8be12f752d2;
});
parcelRegister("dp5jO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9c21bc4d0ace2e1e$var$_react = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9c21bc4d0ace2e1e$var$_checkCircle = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("34OIV")));
    var $9c21bc4d0ace2e1e$var$_checkCircle2 = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("btivG")));
    function $9c21bc4d0ace2e1e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9c21bc4d0ace2e1e$var$CheckCircleIcon = (props)=>$9c21bc4d0ace2e1e$var$_react.default.createElement($9c21bc4d0ace2e1e$var$_checkCircle.default, Object.assign({
            LEGACY_fallbackIcon: $9c21bc4d0ace2e1e$var$_checkCircle2.default
        }, props));
    $9c21bc4d0ace2e1e$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
    var $9c21bc4d0ace2e1e$var$_default = module.exports.default = $9c21bc4d0ace2e1e$var$CheckCircleIcon;
});
parcelRegister("34OIV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $23d917767cf5e6f4$var$_UNSAFE_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>$23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
        }, props));
    $23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;
});
parcelRegister("7R4eB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$435170f9f2349b2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            isAutoDismiss: true,
            ...props,
            flagType: "info"
        }));
    var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("f2BYd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3780c7e328dbb70e$export$2e2bcd8739ae039);
    var $3KRpp;
    var $3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).FlagGroup);
});
parcelRegister("6hrB4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$218f2273ae394fb2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $218f2273ae394fb2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        draftSuccessFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-title",
            "defaultMessage": "Article published"
        },
        draftSuccessFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-description",
            "defaultMessage": "This article has been added to your knowledge base. Your articles list will update soon."
        },
        draftSuccessSavedFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-title",
            "defaultMessage": "Draft saved"
        },
        draftSuccessSavedFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-description",
            "defaultMessage": "Find it in Drafts in your knowledge base."
        },
        articleSuccessSavedFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-title",
            "defaultMessage": "We\u2019ve saved your unpublished changes"
        },
        articleSuccessSavedFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-description",
            "defaultMessage": "You can edit the article and publish these changes later."
        },
        confluenceCreatePageFailureTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-title",
            "defaultMessage": "We're having trouble creating the article"
        },
        confluenceCreatePageFailureDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-description",
            "defaultMessage": "Wait for a few minutes and try creating the article again."
        },
        articleDeletedFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-title",
            "defaultMessage": "Article deleted"
        },
        articleDeletedFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-description",
            "defaultMessage": "This article has been deleted from your knowledge base. Your articles list will update soon."
        }
    });
});
parcelRegister("8WALy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4715523505b99e61$export$2e2bcd8739ae039);
    var $9tOEo;
    var $6z7Gx;
    var $axsl2;
    const $4715523505b99e61$var$ErrorPageWithAnalytics = (0, (0, parcelRequire("9tOEo")).default)({
        attributes: {
            context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    })((0, (0, parcelRequire("axsl2")).default));
    var $4715523505b99e61$export$2e2bcd8739ae039 = $4715523505b99e61$var$ErrorPageWithAnalytics;
});
parcelRegister("axsl2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c66f766909105fb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $bJcWY;
    var $aZdfU;
    var $hZHze;
    var $jS4lj;
    var $6Ndma;
    var $8RXs9;
    var $75gFv = parcelRequire("75gFv");
    var $iDMMZ;
    var $13x0I;
    var $6geWD;
    function $c66f766909105fb1$export$c120a0e80fd44ca6(props) {
        const { intl: intl, error: error, screenName: screenName, attributes: attributes } = props;
        const isKBRouteWithHorizontalNav = (0, (0, parcelRequire("6Ndma")).useIsKBRouteWithHorizontalNav)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: `${screenName}${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
                attributes: attributes ? {
                    ...attributes
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), null, !isKBRouteWithHorizontalNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6geWD")).default), {
            truncateTitle: true,
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
            imageUrl: (0, ($parcel$interopDefault($75gFv))),
            header: intl.formatMessage(error.header),
            description: intl.formatMessage(error.message),
            primaryAction: error.ctaLink && error.ctaText ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDMMZ")).default), {
                to: error.ctaLink || ''
            }, intl.formatMessage(error.ctaText)) : undefined
        }))));
    }
    var $c66f766909105fb1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($c66f766909105fb1$export$c120a0e80fd44ca6);
});
parcelRegister("bJcWY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08fe944bdcd177c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    var $itnZ9;
    var $aZdfU;
    var $ephoW;
    const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("aZdfU")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("f1WIN")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("f1WIN")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ephoW")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itnZ9")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;
});
parcelRegister("f1WIN", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$196a11a7b8c2fbef$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$196a11a7b8c2fbef$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$196a11a7b8c2fbef$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$196a11a7b8c2fbef$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$196a11a7b8c2fbef$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$196a11a7b8c2fbef$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$196a11a7b8c2fbef$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$196a11a7b8c2fbef$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$196a11a7b8c2fbef$export$936829b4511db3e4);
    const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
    const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
    const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
    const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
        comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
        cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
        compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
    };
    const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
    const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
    const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
    const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
    const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
    const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("itnZ9", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$92e4fcbfc398e3a4$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $92e4fcbfc398e3a4$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}) * ${(0, (0, parcelRequire("f1WIN")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $92e4fcbfc398e3a4$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`
    });
    const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("f1WIN")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $92e4fcbfc398e3a4$var$gridStyles,
                $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
                isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("f1WIN")).varGridSpacing)]: `${(0, (0, parcelRequire("f1WIN")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("ephoW", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$529bf77650fbff0f$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    const $529bf77650fbff0f$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("f1WIN")).defaultSpacing),
        columns: (0, (0, parcelRequire("f1WIN")).defaultGridColumns)
    });
});
parcelRegister("aZdfU", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$11b791725219e059$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$11b791725219e059$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    var $11b791725219e059$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($11b791725219e059$var$ColumnVariant || ($11b791725219e059$var$ColumnVariant = {}));
    const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("f1WIN")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $11b791725219e059$var$availableWidth = '99.9999%';
    const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}))`;
    const $11b791725219e059$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $11b791725219e059$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("f1WIN")).varColumnSpan)}) - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $11b791725219e059$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("f1WIN")).defaultMedium)
    });
    const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("f1WIN")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $11b791725219e059$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $11b791725219e059$var$gridColumnStyles,
                $11b791725219e059$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;
});
parcelRegister("6Ndma", function(module, exports) {
    $parcel$export(module.exports, "useIsKBRouteWithHorizontalNav", ()=>$76f1b69b9a6db003$export$49e43abdbfaa6622);
    var $65Ltd;
    var $jIAHH;
    var $cPiXk;
    var $3HwlS;
    var $6jY6G;
    const $76f1b69b9a6db003$export$49e43abdbfaa6622 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK) && HorizontalNavComponent === (0, (0, parcelRequire("jIAHH")).AsyncKbNav);
    };
});
parcelRegister("6geWD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$805b9f255efa1904$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jS4lj;
    var $cS37j;
    var $koVbs;
    var $jbwMx;
    function $805b9f255efa1904$export$fea23bd0b48d9710(props) {
        const { children: children, description: description, showDefaultTitle: showDefaultTitle, bottomBar: bottomBar, ...restProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            bottomBar: description ? (0, ($parcel$interopDefault($5uXOq))).createElement($805b9f255efa1904$var$Description, null, description) : bottomBar,
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null),
            ...restProps
        }, children || (showDefaultTitle ? formatMessage((0, (0, parcelRequire("jbwMx")).default).knowledgeBase) : null));
    }
    $805b9f255efa1904$export$fea23bd0b48d9710.defaultProps = {
        actions: undefined,
        bottomBar: undefined,
        children: null,
        showDefaultTitle: true,
        description: undefined,
        onBreadcrumbClicked: undefined
    };
    var $805b9f255efa1904$export$2e2bcd8739ae039 = $805b9f255efa1904$export$fea23bd0b48d9710;
    const $805b9f255efa1904$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkmgjw _1i4q1hna",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("crHrE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04db017c01080a38$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGLgs;
    var $ousew;
    var $8RXs9;
    var $lkvEj;
    var $itmJb;
    var $5Ya00;
    const $04db017c01080a38$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
    $04db017c01080a38$export$83d026e3dd5706d.defaultProps = {
        stop: ()=>{}
    };
    const $04db017c01080a38$export$22819d9d15429568 = 'jsd-kb-hub-multi-linked-spaces-tour';
    const $04db017c01080a38$var$KnowledgeHubMultiSpacesChangeboarding = ({ intl: intl, projectKey: projectKey })=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const [showChangeboardingMessage, toggleChangeboardingMessage] = (0, $5uXOq.useState)(true);
        const settingsUrl = `/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`;
        const stopTour = (stopFn, changeRoute)=>{
            toggleChangeboardingMessage(false);
            stopFn && stopFn();
            if (changeRoute) setTimeout(()=>window.open(settingsUrl, '_self'), 1000);
        };
        const description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...isAdmin ? (0, (0, parcelRequire("5Ya00")).default).dialogTitleAdmin : (0, (0, parcelRequire("5Ya00")).default).dialogTitleAgent,
            values: {
                bold_space_name: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, intl.formatMessage((0, (0, parcelRequire("5Ya00")).default).linkedSpacesText))
            }
        });
        const learnMoreLinkText = isAdmin ? intl.formatMessage((0, (0, parcelRequire("5Ya00")).default).settingsUrlText) : '';
        const gotItButtonText = intl.formatMessage((0, (0, parcelRequire("5Ya00")).default).buttonText);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eGLgs")).default), {
            messageId: $04db017c01080a38$export$22819d9d15429568
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04db017c01080a38$export$83d026e3dd5706d, null, (stop)=>showChangeboardingMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkvEj")).SpotlightDialogDeprecated), {
                learnMoreLinkText: learnMoreLinkText,
                onConfirm: ()=>stopTour(stop, false),
                gotItButtonText: gotItButtonText,
                description: description,
                buttonOverrideProps: {
                    target: '_self',
                    onClick: ()=>stopTour(stop, true)
                }
            })));
    };
    var $04db017c01080a38$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($04db017c01080a38$var$KnowledgeHubMultiSpacesChangeboarding);
});
parcelRegister("eGLgs", function(module, exports) {
    $parcel$export(module.exports, "CoordinationClient", ()=>$754c27d37ccd1133$export$580a2294c917898c);
    $parcel$export(module.exports, "default", ()=>$754c27d37ccd1133$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZhen;
    var $jcYbC;
    var $8Mq6c;
    var $TTRxY;
    var $ioD1B;
    var $fG5AJ;
    var $10xFf;
    var $4Pf62;
    var $4R6GH;
    var $j8DrX;
    var $14XJw;
    var $7qPn9;
    const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    class $754c27d37ccd1133$export$580a2294c917898c extends (0, (0, parcelRequire("8Mq6c")).default) {
        constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
            const environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment'));
            const getEnvironmentType = (env)=>{
                if (env === 'prod') return (0, (0, parcelRequire("iZhen")).envType).PROD;
                if (env === 'staging') return (0, (0, parcelRequire("iZhen")).envType).STAGING;
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            };
            const enableChoreographer = (0, (0, parcelRequire("10xFf")).shouldBeChoreographed)({
                messageType: messageType
            }) && !isAlreadyChoreographedAtAncestor;
            const coordinationOptions = {
                enableChoreographer: enableChoreographer,
                envType: getEnvironmentType(environment),
                additionalData: {
                    sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
                }
            };
            super({
                cloudId: cloudId,
                stargateUrl: stargateUrl,
                orgId: orgId,
                isFedRAMPEnvironment: false,
                coordinationOptions: coordinationOptions
            });
            this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
            this.enableChoreographer = enableChoreographer;
            this.onMessageDisposition = onMessageDisposition;
            this.isDebugModeEnabled = (0, (0, parcelRequire("4R6GH")).fg)('ep-external-message-debug-mode');
        }
        async start(messageId) {
            if (this.isDebugModeEnabled) {
                const serverResponse = await super.start(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
                if (!shouldShowMessage) {
                    const didStop = await super.stop(messageId);
                    if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                }
                return shouldShowMessage;
            }
            return this.shouldUseMockClient ? false : super.start(messageId).then((didStart)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStart;
            });
        }
        async stop(messageId) {
            return this.shouldUseMockClient ? true : super.stop(messageId).then((didStop)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStop;
            });
        }
    }
    function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const stargateUrl = '/gateway/api';
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
        const { fallback: fallback, messageId: messageId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: client.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcYbC")).default), {
            client: client,
            fallback: fallback,
            messageId: messageId
        }, props.children));
    }
});
parcelRegister("ioD1B", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerContextProvider", ()=>$c141e5ba3428702a$export$c3226151caaf2fbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    const $c141e5ba3428702a$var$choreographedStatusContextValue = {
        isAlreadyChoreographedAtAncestor: true
    };
    const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
        return shouldUseChoreographerContextProvider ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fG5AJ")).ChoreographedStatusContext).Provider, {
            value: $c141e5ba3428702a$var$choreographedStatusContextValue
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("lkvEj", function(module, exports) {
    $parcel$export(module.exports, "SpotlightDialogDeprecated", ()=>$3aba97d511711a30$export$9781de07da69101e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5ujeO;
    var $k6T4f;
    var $k8nZq;
    var $gwIPs;
    const $3aba97d511711a30$export$9781de07da69101e = ({ title: title, onConfirm: onConfirm, description: description, learnMoreLink: learnMoreLink, learnMoreLinkText: learnMoreLinkText, gotItButtonText: gotItButtonText, buttonOverrideProps: buttonOverrideProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).dialog
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3aba97d511711a30$var$SpotlightDialogWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
            actions: [
                {
                    text: gotItButtonText,
                    onClick: onConfirm
                },
                {
                    text: learnMoreLinkText,
                    ...learnMoreLink && {
                        href: learnMoreLink,
                        target: '_blank'
                    },
                    ...buttonOverrideProps,
                    appearance: 'subtle-link'
                }
            ],
            width: 300,
            heading: title
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3aba97d511711a30$var$Body, null, description))));
    const $3aba97d511711a30$var$Body = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz41tcg _otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $3aba97d511711a30$var$SpotlightDialogWrapper = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("k6T4f")).Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _kqsw1n9t _1xi21ejb _94n51ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5Ya00", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05fb5857a8f11f30$export$2e2bcd8739ae039);
    var $7VHMR;
    var $05fb5857a8f11f30$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dialogTitleAdmin: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.dialog-title-admin",
            "defaultMessage": "We've added a {bold_space_name} filter to help you find and manage your articles. Head to your settings page to link more spaces to your knowledge base."
        },
        dialogTitleAgent: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.dialog-title-agent",
            "defaultMessage": "We've added a {bold_space_name} filter to help you manage your knowledge base articles across multiple Confluence spaces."
        },
        linkedSpacesText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.linked-spaces-text",
            "defaultMessage": "linked spaces"
        },
        buttonText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.button-text",
            "defaultMessage": "Ok"
        },
        settingsUrlText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-multi-spaces-changeboarding.settings-url-text",
            "defaultMessage": "Go to settings"
        }
    });
});
parcelRegister("1ydSB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d11ba66aa3b5efd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9d11ba66aa3b5efd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createArticleCta: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.create-article-cta",
            "defaultMessage": "Create article"
        },
        noArticlesTitleMultipleSpaces: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-title-multiple-spaces",
            "defaultMessage": "We couldn't find an article matching your search"
        },
        noArticlesTitle: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-title",
            "defaultMessage": "There are no articles in your knowledge base"
        },
        noArticlesDescription: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-description",
            "defaultMessage": "Articles can help your help seekers find the solutions they're looking for."
        },
        noArticlesDescriptionMultipleSpaces: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-description-multiple-spaces",
            "defaultMessage": "Consider {creating} a new one"
        },
        creatingArticleDescription: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.creating-article-description",
            "defaultMessage": "creating"
        },
        noArticlesCta: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-cta",
            "defaultMessage": "Create article"
        },
        welcomeDescription: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description",
            "defaultMessage": "Create articles in knowledge base spaces to share information with your team and to let customers self-serve."
        },
        welcomeDescriptionNew: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-new",
            "defaultMessage": "Create articles in knowledge base spaces to share information with your team and to let customers self-serve."
        },
        welcomeDescriptionAdmins: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-admins",
            "defaultMessage": "Manage your spaces and permissions in {linkText}"
        },
        welcomeDescriptionAdminsLink: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-admins-link",
            "defaultMessage": "knowledge base settings"
        },
        welcomeDescriptionNoCategories: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-no-categories",
            "defaultMessage": "Share solutions to problems with your customers and team by adding articles to your knowledge base."
        },
        inlineSearchPlaceholder: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.inline-search-placeholder",
            "defaultMessage": "Search all articles"
        },
        searchPlaceholder: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-placeholder",
            "defaultMessage": "Search"
        },
        spacesDropdownText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.spaces-dropdown-text",
            "defaultMessage": "{count, plural, =0 {Spaces} one {{spaceName}} other {Multiple (# spaces)}}"
        },
        searchLabelText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-label-text",
            "defaultMessage": "Search for articles"
        },
        searchArticlesHintText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-articles-hint-text",
            "defaultMessage": "The table below will get updated as you type characters in the field."
        }
    });
});
parcelRegister("500iy", function(module, exports) {
    $parcel$export(module.exports, "articlesPageLoad", ()=>$9f4158c988d9e1fa$export$6f468438b9b40e19);
    var $dGrdR;
    const $9f4158c988d9e1fa$export$6f468438b9b40e19 = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'service-management.knowledge.articles'
    });
});
parcelRegister("2riGj", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeHubAppBase", ()=>$cda69d9cd68a5197$export$f848f52481042e56);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $e0Brz;
    var $gEFwt;
    var $kb4zh;
    var $9sGI6;
    var $97Kan;
    var $3HwlS;
    var $2NMNM;
    var $5MiFc;
    var $cf7yQ;
    var $lw2HC;
    var $cbMay;
    var $h4S6Q;
    var $hYd1f;
    var $1eweq;
    var $1xzCS;
    var $7FkcY;
    var $6GLlD;
    var $e33py;
    var $6FTcZ;
    var $gq0sA;
    var $4S0uJ;
    var $doZTA;
    const $cda69d9cd68a5197$var$KnowledgeHubAppBaseView = (props)=>{
        const { initialActions: initialActions, KnowledgeHubContainer: KnowledgeHubContainer, appName: appName, shouldRemoveMargin: shouldRemoveMargin = false } = props;
        const [{ match: match, query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ data: pageContextData, error: pageContextError }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
        const { projectKey: projectKey, projectName: projectName, projectId: projectId } = projectContext || {};
        const [{ data: confluenceLink, error: confluenceLinkError }] = (0, (0, parcelRequire("6FTcZ")).useKbConfluenceContext)(projectKey);
        const [{ categories: categories, isCategoriesSupported: isCategoriesSupported }, { fetchCategories: fetchCategories }] = (0, (0, parcelRequire("lw2HC")).useCategoriesData)();
        const { activationId: activationId } = tenantContext || {};
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return;
            projectId && activationId && fetchCategories(projectId, createAnalyticsEvent({}), activationId);
        }, [
            projectId,
            fetchCategories,
            createAnalyticsEvent,
            activationId
        ]);
        if (!confluenceLink && !confluenceLinkError || !pageContextData && !pageContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        const stateAppProps = {
            app: {
                ...tenantContext,
                ...projectContext,
                ...serviceDeskContext
            }
        };
        const CustomizedPageStyle = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && shouldRemoveMargin ? (0, (0, parcelRequire("dC5iT")).default) : (0, (0, parcelRequire("4S0uJ")).PageStyle);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6GLlD")).default), {
            appName: appName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(KnowledgeHubContainer, {
            scope: projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eweq")).KnowledgeHubActionsSubscriber), null, (_, scopedKnowledgeActions)=>{
            const initialState = {
                ...scopedKnowledgeActions.getStoreState(),
                ...stateAppProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MiFc")).ReduxConnector), {
                storeName: "servicedesk-knowledge-hub",
                initialState: initialState,
                rootReducer: (0, (0, parcelRequire("1xzCS")).default)(scopedKnowledgeActions.updateStore),
                rootEpic: (0, (0, parcelRequire("hYd1f")).default),
                initialActions: initialActions
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7FkcY")).default), {
                ...confluenceLink,
                categories: categories,
                isCategoriesSupported: isCategoriesSupported
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).ServiceDeskDocumentTitle), {
                projectName: projectName,
                section: "knowledge"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbMay")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
                baseUrl: "",
                projectKey: projectKey,
                projectName: projectName
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(CustomizedPageStyle, null, props.children({
                match: match,
                query: query,
                pageContext: {
                    ...stateAppProps.app
                }
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("97Kan")).FlagsDispatcher), {
                mapper: (0, (0, parcelRequire("h4S6Q")).default)
            })));
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null));
    };
    const $cda69d9cd68a5197$export$f848f52481042e56 = (0, (0, parcelRequire("9sGI6")).default)($cda69d9cd68a5197$var$KnowledgeHubAppBaseView, {
        initialActions: [],
        KnowledgeHubContainer: (0, (0, parcelRequire("1eweq")).KnowledgeHubContainer)
    });
    var $cda69d9cd68a5197$export$2e2bcd8739ae039 = $cda69d9cd68a5197$export$f848f52481042e56;
});
parcelRegister("97Kan", function(module, exports) {
    $parcel$export(module.exports, "FlagsDispatcher", ()=>$4ddeb9f500a62e17$export$9e60e3d40b6e758f);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $fpHHI;
    const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fpHHI")).Dispatcher), {
            store: store,
            mapper: mapper,
            showFlag: (0, (0, parcelRequire("pa9q9")).showFlag),
            dismissFlag: (0, (0, parcelRequire("pa9q9")).dismissFlag)
        });
});
parcelRegister("fpHHI", function(module, exports) {
    $parcel$export(module.exports, "Dispatcher", ()=>$eef6139685bfb64e$export$ab054a1ef92eeb01);
    var $5uXOq = parcelRequire("5uXOq");
    var $1kijq;
    const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
        const { store: store, ...dispatcherProps } = props;
        const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
        if (store !== lastStore) setLastStore(store);
        const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1kijq")).createDispatcher)(store), [
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
    };
});
parcelRegister("1kijq", function(module, exports) {
    $parcel$export(module.exports, "createDispatcher", ()=>$c324e875f8c6fe8f$export$7b259d28468da15b);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVVL1 = parcelRequire("kVVL1");
    var $pa9q9;
    const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
        if (!store) throw new Error('Store not available through direct injection or Provider context');
        if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
        return store;
    };
    const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
        if (!result) return;
        if ((0, (0, parcelRequire("pa9q9")).isDismissFlag)(result)) dismissFlag(result);
        else if ((0, (0, parcelRequire("pa9q9")).isFlagComponent)(result)) {
            const FlagComponent = result;
            const FlagComponentWithProvider = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                    store: store
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
            showFlag(FlagComponentWithProvider);
        } else showFlag(result);
    };
    const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
        if ((0, (0, parcelRequire("pa9q9")).isBatchAction)(action)) action.payload.forEach((childAction)=>{
            if (childAction.type && typeof childAction.type === 'string') {
                const childResult = mapper(childAction, state);
                $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
            }
        });
        else {
            const result = mapper(action, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
        }
    };
    const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
        const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
        const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
            storeUnchecked
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleAction = (action, state)=>{
                $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
            };
            store.addActionListener(handleAction);
            return ()=>store.removeActionListener(handleAction);
        }, [
            store,
            mapper,
            showFlag,
            dismissFlag
        ]);
        return null;
    };
    const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
        const store = (0, $kVVL1.useStore)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: store
        });
    };
    const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
        const Dispatcher8CustomStore = (props)=>customStore ? (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
                ...props,
                store: customStore
            }) : null;
        return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
    };
});
parcelRegister("5MiFc", function(module, exports) {
    $parcel$export(module.exports, "ReduxConnector", ()=>$d6d887f51629efb1$export$c0c26a673bd1981c);
    var $5uXOq = parcelRequire("5uXOq");
    var $F2Mxm;
    var $bC2fB;
    const $d6d887f51629efb1$export$c0c26a673bd1981c = ({ storeName: storeName, initialState: initialState, initialActions: initialActions, rootReducer: rootReducer, rootEpic: rootEpic, children: children })=>{
        const createStoreRef = (0, $5uXOq.useRef)(()=>(0, (0, parcelRequire("F2Mxm")).default)({
                appName: storeName,
                initialState: initialState,
                rootReducer: rootReducer,
                rootEpic: rootEpic
            }));
        const store = (0, $5uXOq.useMemo)(createStoreRef.current, []);
        const initialActionsRef = (0, $5uXOq.useRef)(initialActions);
        (0, $5uXOq.useEffect)(()=>{
            initialActionsRef.current?.forEach((action)=>{
                store.dispatch(action());
            });
        }, [
            store
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bC2fB")).Provider), {
            store: store
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)));
    };
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3kACf")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("CFRIm")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hnw8Z")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("7opQ6")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("3kACf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("chQyv")
    ]).then(()=>parcelRequire('hZyYK'));
});
parcelRegister("CFRIm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("hnw8Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("7opQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("cbMay", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342ca5599182c99e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $825UM;
    var $ks7Ah;
    var $342ca5599182c99e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ks7Ah")).default), null, ({ isOpen: isOpen, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("825UM")).default), {
                isOpen: isOpen,
                onClose: onClose
            }));
});
parcelRegister("825UM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6d18ceb0644bdde$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $i8Qvm;
    var $6z7Gx;
    var $gq0sA;
    var $lVJAU;
    var $261Bl;
    var $lw2HC;
    var $7U3kA;
    const $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory = (props)=>{
        const { isOpen: isOpen, onClose: onClose } = props;
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [{ data: pageContextData }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
        const { projectId: projectId, projectKey: projectKey } = projectContext || {};
        const [{ isSubmitting: isSubmitting, formValues: formValues, error: error, createdCategory: createdCategory }, { createCategory: createCategory, handleFormInputChange: handleFormInputChange, resetCreatedCategory: resetCreatedCategory }] = (0, (0, parcelRequire("lw2HC")).useCreateCategoryData)();
        const activationId = tenantContext?.activationId || '';
        const isValid = !!formValues.name && formValues.name.length !== 0;
        const onChange = (field, value)=>{
            handleFormInputChange(field, value);
        };
        (0, $5uXOq.useEffect)(()=>{
            if (!createdCategory) return;
            onClose();
            resetCreatedCategory();
            push(`/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, (0, parcelRequire("261Bl")).categoryGuidToString)(createdCategory.id)}`);
        }, [
            createdCategory,
            projectKey,
            push,
            onClose,
            resetCreatedCategory
        ]);
        const onSubmit = (e, analyticsEvent)=>{
            e.preventDefault();
            if (isSubmitting || !isValid) return;
            projectId && createCategory(projectId, analyticsEvent, activationId);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: `knowledgeCreateCategory${(0, $4d5e0871c06cee03$export$1171103ea9083ffa)}`,
                actionSubject: 'category',
                attributes: {
                    context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7U3kA")).default), {
            onChange: onChange,
            onClose: onClose,
            onSubmit: onSubmit,
            formValues: formValues,
            formError: error.formError,
            fieldErrors: error.fieldErrors,
            isSubmitting: isSubmitting,
            isDisabled: !isValid
        })));
    };
    var $a6d18ceb0644bdde$export$2e2bcd8739ae039 = $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory;
});
parcelRegister("7U3kA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2ae948e58435135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $hZHze;
    var $9fuVs;
    var $koVbs;
    var $9oIFN;
    var $5TOVG;
    const $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSubmitting: isSubmitting = false, isDisabled: isDisabled = false, onChange: onChange, onClose: onClose, onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("5TOVG")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9oIFN")).default), {
            onChange: onChange,
            onSubmit: onSubmit,
            formError: formError,
            fieldErrors: fieldErrors,
            isDisabled: isSubmitting
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: onSubmit,
            isLoading: isSubmitting,
            isDisabled: isDisabled
        }, formatMessage((0, (0, parcelRequire("5TOVG")).default).createAction)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClose
        }, formatMessage((0, (0, parcelRequire("5TOVG")).default).cancelAction)))));
    };
    var $c2ae948e58435135$export$2e2bcd8739ae039 = $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless;
});
parcelRegister("9oIFN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49788ff41cd45114$export$2e2bcd8739ae039);
    var $8oe80;
    var $3pn3a;
    var $49788ff41cd45114$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('form', {
        onSubmit: 'submitted'
    })((0, (0, parcelRequire("3pn3a")).default));
});
parcelRegister("3pn3a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da6b524a14a97bee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    var $92Z2l;
    var $6LCpJ;
    var $kY99m;
    var $koVbs;
    var $7cbM0;
    var $7VpFm;
    const $da6b524a14a97bee$var$CreateCategoryForm = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors, isDisabled: isDisabled = false, testId: testId } = props;
        const createOnChangeHandlerForField = (field)=>(e)=>{
                props.onChange(field, e.currentTarget.value);
            };
        const errorMessage = (field)=>fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            onSubmit: onSubmit,
            disabled: isDisabled
        }, formError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: testId && `${testId}--section-message`
        }, formatMessage(formError.message)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("7VpFm")).default).helpText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            error: errorMessage('name'),
            label: formatMessage((0, (0, parcelRequire("7VpFm")).default).nameFieldLabel),
            isRequired: true,
            name: "name"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cbM0")).default), {
                error: errorMessage('name')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...fieldProps,
                isRequired: true,
                autoComplete: "off",
                placeholder: formatMessage((0, (0, parcelRequire("7VpFm")).default).nameFieldPlaceholder),
                isInvalid: fieldErrors && !!fieldErrors.name,
                maxLength: 100,
                onChange: createOnChangeHandlerForField('name'),
                isDisabled: isDisabled,
                autoFocus: true
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            error: errorMessage('description'),
            label: formatMessage((0, (0, parcelRequire("7VpFm")).default).descriptionFieldLabel),
            name: "description"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cbM0")).default), {
                error: errorMessage('description')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6LCpJ")).default), {
                ...fieldProps,
                maxLength: 150,
                minimumRows: 3,
                autoComplete: "off",
                placeholder: formatMessage((0, (0, parcelRequire("7VpFm")).default).descriptionFieldPlaceholder),
                isInvalid: fieldErrors && !!fieldErrors.description,
                isDisabled: isDisabled,
                onChange: createOnChangeHandlerForField('description')
            })))));
    };
    var $da6b524a14a97bee$export$2e2bcd8739ae039 = $da6b524a14a97bee$var$CreateCategoryForm;
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("6LCpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934f91ac04cc5aeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $1qQmi;
    const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
    const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
    const $934f91ac04cc5aeb$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $934f91ac04cc5aeb$var$packageName,
        packageVersion: $934f91ac04cc5aeb$var$packageVersion
    };
    const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("1qQmi")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $934f91ac04cc5aeb$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1qQmi")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("1qQmi")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $934f91ac04cc5aeb$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
    var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;
});
parcelRegister("1qQmi", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$0f8aaecc0e682a20$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$0f8aaecc0e682a20$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$0f8aaecc0e682a20$export$98856a888ef36079);
    var $f8Sb3;
    var $iaE2J;
    function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0f8aaecc0e682a20$var$disabledRules = {
        backgroundColor: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("iaE2J")).disabledBackground,
        borderColor: (0, parcelRequire("iaE2J")).disabledBorder,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("iaE2J")).disabledTextColor
    };
    const $0f8aaecc0e682a20$var$invalidRules = {
        borderColor: (0, parcelRequire("iaE2J")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover
    };
    const $0f8aaecc0e682a20$var$backgroundColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).subtleBorderColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$lineHeightBase = 20;
    const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
    const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
    const $0f8aaecc0e682a20$var$verticalPadding = 6;
    const $0f8aaecc0e682a20$var$horizontalPadding = 8;
    const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
    const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
    const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
        return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
                }
            } : {}
        });
    const $0f8aaecc0e682a20$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("iaE2J")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });
    const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                    borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
                }
            }
        });
    var $0f8aaecc0e682a20$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $0f8aaecc0e682a20$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
        return $0f8aaecc0e682a20$var$_ref;
    };
    const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
        });
    const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
            }
        });
    };
    const $0f8aaecc0e682a20$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$staticStyles, $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), $0f8aaecc0e682a20$var$resizeStyle(resize), $0f8aaecc0e682a20$var$borderStyle(appearance), $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), $0f8aaecc0e682a20$var$placeholderStyles, {
            color: (0, parcelRequire("iaE2J")).textColor,
            '&:disabled': {
                color: $0f8aaecc0e682a20$var$disabledRules.textColor
            }
        });
});
parcelRegister("iaE2J", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$f788b902061573a8$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$f788b902061573a8$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$f788b902061573a8$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$f788b902061573a8$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$f788b902061573a8$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$f788b902061573a8$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$f788b902061573a8$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$f788b902061573a8$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$f788b902061573a8$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$f788b902061573a8$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$f788b902061573a8$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$f788b902061573a8$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$f788b902061573a8$export$f4d082c200a4b4b8);
    const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
    const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
    const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
    const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("7cbM0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c9409ad575aa5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    function $78c9409ad575aa5f$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, props.children, (0, ($parcel$interopDefault($5uXOq))).createElement($78c9409ad575aa5f$var$ErrorMessage, null, props.error));
    }
    $78c9409ad575aa5f$export$2e2bcd8739ae039.defaultProps = {
        error: undefined
    };
    const $78c9409ad575aa5f$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1l5o _1yt4swc3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7VpFm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$185a0480b7dde273$export$2e2bcd8739ae039);
    var $7VHMR;
    var $185a0480b7dde273$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        helpText: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text",
            "defaultMessage": "Group related articles in categories to help customers find what they need."
        },
        nameFieldLabel: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label",
            "defaultMessage": "Name"
        },
        nameFieldPlaceholder: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder",
            "defaultMessage": "Category name, e.g \"Printers\" or \"Wifi\""
        },
        descriptionFieldLabel: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label",
            "defaultMessage": "Description"
        },
        descriptionFieldPlaceholder: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder",
            "defaultMessage": "Tell customers more about this category"
        }
    });
});
parcelRegister("5TOVG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f748cc858c62ad0d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f748cc858c62ad0d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.title",
            "defaultMessage": "Create new category"
        },
        createAction: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-action",
            "defaultMessage": "Create"
        },
        cancelAction: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("ks7Ah", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30d72adc6eb603b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQS7;
    const $30d72adc6eb603b4$var$NavDriver = (props)=>{
        const { children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvQS7")).KbCreateCategorySubscriber), null, ({ isOpen: isOpen }, { setCreateCategoryDisplay: setCreateCategoryDisplay })=>{
            const onClose = ()=>setCreateCategoryDisplay(false);
            return children({
                isOpen: isOpen,
                onClose: onClose
            });
        });
    };
    var $30d72adc6eb603b4$export$2e2bcd8739ae039 = $30d72adc6eb603b4$var$NavDriver;
});
parcelRegister("kvQS7", function(module, exports) {
    $parcel$export(module.exports, "useKbCreateCategoryActions", ()=>$fefcd82701364dc4$export$719df9e736f08a9);
    $parcel$export(module.exports, "KbCreateCategorySubscriber", ()=>$fefcd82701364dc4$export$2b9cf8c256011b51);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $fefcd82701364dc4$export$d4c72bab9d6cc13a = {
        isOpen: false
    };
    const $fefcd82701364dc4$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        };
    const $fefcd82701364dc4$export$e324594224ef24da = {
        setCreateCategoryDisplay: $fefcd82701364dc4$var$setCreateCategoryDisplay
    };
    const $fefcd82701364dc4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'kb-create-category',
        initialState: $fefcd82701364dc4$export$d4c72bab9d6cc13a,
        actions: $fefcd82701364dc4$export$e324594224ef24da
    });
    const $fefcd82701364dc4$export$719df9e736f08a9 = (0, (0, parcelRequire("3sQ5x")).createHook)($fefcd82701364dc4$var$Store, {
        selector: null
    });
    const $fefcd82701364dc4$export$2b9cf8c256011b51 = (0, (0, parcelRequire("51nlc")).createSubscriber)($fefcd82701364dc4$var$Store);
});
parcelRegister("h4S6Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e91b5defeecf9279$export$2e2bcd8739ae039);
    var $5sKH1;
    var $iHUHp;
    var $6zk4x;
    var $1hzgw;
    var $6VTSZ;
    const $e91b5defeecf9279$var$flagsMapper = (action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("6zk4x")).UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
            case 0, (0, parcelRequire("5sKH1")).ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
                return (0, (0, parcelRequire("6VTSZ")).default)();
            case 0, (0, parcelRequire("iHUHp")).REMOVE_LABEL_FROM_ARTICLE_FAILURE:
                return (0, (0, parcelRequire("1hzgw")).default)();
            default:
                return undefined;
        }
    };
    var $e91b5defeecf9279$export$2e2bcd8739ae039 = $e91b5defeecf9279$var$flagsMapper;
});
parcelRegister("5sKH1", function(module, exports) {
    $parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_FAILURE", ()=>$a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d);
    $parcel$export(module.exports, "addCategoriesForArticleFailure", ()=>$a77e1c0ebfe8e6c5$export$98c16426b39dc19d);
    const $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d = 'state.actions.add-categories-for-article-failure.ADD_CATEGORIES_FOR_ARTICLE_FAILURE';
    const $a77e1c0ebfe8e6c5$export$98c16426b39dc19d = (payload)=>({
            payload: payload,
            type: $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d
        });
});
parcelRegister("iHUHp", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_FAILURE", ()=>$36bd602e9276dc31$export$78c874904ae250ac);
    $parcel$export(module.exports, "removeLabelFromArticleFailure", ()=>$36bd602e9276dc31$export$b7ca01a9c0fd6afb);
    const $36bd602e9276dc31$export$78c874904ae250ac = 'state.actions.remove-label-from-article-failure.REMOVE_LABEL_FROM_ARTICLE_FAILURE';
    const $36bd602e9276dc31$export$b7ca01a9c0fd6afb = (payload)=>({
            payload: payload,
            type: $36bd602e9276dc31$export$78c874904ae250ac
        });
});
parcelRegister("6zk4x", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE", ()=>$ad606a0cff7a573c$export$f5f174c6323905d3);
    $parcel$export(module.exports, "updateCategoriesForArticleFailure", ()=>$ad606a0cff7a573c$export$4578d03141d71619);
    const $ad606a0cff7a573c$export$f5f174c6323905d3 = 'state.actions.update-categories-for-article-failure.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE';
    const $ad606a0cff7a573c$export$4578d03141d71619 = (payload)=>({
            payload: payload,
            type: $ad606a0cff7a573c$export$f5f174c6323905d3
        });
});
parcelRegister("1hzgw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecb51d5c83a378fb$export$2e2bcd8739ae039);
    var $fmcGe;
    var $ecb51d5c83a378fb$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: (0, (0, parcelRequire("fmcGe")).default).title,
            description: (0, (0, parcelRequire("fmcGe")).default).description
        });
});
parcelRegister("fmcGe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372161f8a7552a21$export$2e2bcd8739ae039);
    var $7VHMR;
    var $372161f8a7552a21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.title",
            "defaultMessage": "We couldn\u2019t save the changes you made"
        },
        description: {
            "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
});
parcelRegister("6VTSZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53def11827375f52$export$2e2bcd8739ae039);
    var $kINlF;
    var $53def11827375f52$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: (0, (0, parcelRequire("kINlF")).default).title,
            description: (0, (0, parcelRequire("kINlF")).default).description
        });
});
parcelRegister("kINlF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59c7a9bfc032690$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f59c7a9bfc032690$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.title",
            "defaultMessage": "Article's categories not updated"
        },
        description: {
            "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.description",
            "defaultMessage": "We weren't able to update the article's categories. Try again in a minute."
        }
    });
});
parcelRegister("hYd1f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c850f2f9e57103ab$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $bdof7;
    var $eGP51;
    var $4DyVT;
    var $feRMu;
    var $kTAvA;
    var $bDRTj;
    var $cpM8i;
    var $a20m8;
    var $gTvcp;
    var $4JAV5;
    var $iYJ1l;
    var $92ShW;
    var $6OXm8;
    var $c850f2f9e57103ab$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("92ShW")).epic), (0, (0, parcelRequire("gTvcp")).epic), (0, (0, parcelRequire("cpM8i")).epic), (0, (0, parcelRequire("bDRTj")).epic), (0, (0, parcelRequire("a20m8")).epic), (0, (0, parcelRequire("4DyVT")).epic), (0, (0, parcelRequire("bdof7")).epic), (0, (0, parcelRequire("6OXm8")).epic), (0, (0, parcelRequire("4JAV5")).epic), (0, (0, parcelRequire("feRMu")).epic), (0, (0, parcelRequire("kTAvA")).epic), (0, (0, parcelRequire("eGP51")).epic), (0, (0, parcelRequire("iYJ1l")).epic));
});
parcelRegister("bdof7", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$8156adb89212081f$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $hhweD;
    var $cVUDi;
    var $fmmX1;
    var $5sKH1;
    var $5XgTr;
    var $6ovlC;
    var $gXg4u;
    var $gLt7z;
    const $8156adb89212081f$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("6ovlC")).ADD_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
            const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            const currentCategoryIds = (0, (0, parcelRequire("gXg4u")).getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
            return (0, (0, parcelRequire("fmmX1")).addCategoriesForArticle)({
                projectId: projectId,
                categoryIds: categoryIds,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map(()=>{
                (0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(analyticsEvent, {
                    action: 'update',
                    actionSubjectId: articleId
                });
                return (0, (0, parcelRequire("5XgTr")).addCategoriesForArticleSuccess)({
                    articleId: articleId,
                    categoryIds: categoryIds,
                    previousCategoryIds: currentCategoryIds
                });
            }).catch((error)=>{
                const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
                (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: analyticsEvent,
                    id: 'articleUpdate Failure',
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("5sKH1")).addCategoriesForArticleFailure)({
                    statusCode: statusCode,
                    errorKey: errorKey,
                    errorMessage: errorMessage,
                    failedCategoryIds: categories,
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("fmmX1", function(module, exports) {
    $parcel$export(module.exports, "list", ()=>$0f36cff0fb97de2b$export$8837f4fc672e936d);
    $parcel$export(module.exports, "listCategoryArticles", ()=>$0f36cff0fb97de2b$export$897d9115a17b4c24);
    $parcel$export(module.exports, "getArticleWithExpandParams", ()=>$0f36cff0fb97de2b$export$fb27d96404fd219d);
    $parcel$export(module.exports, "addCategoriesForArticle", ()=>$0f36cff0fb97de2b$export$d93a983139fde0cc);
    $parcel$export(module.exports, "updateCategoriesForArticle", ()=>$0f36cff0fb97de2b$export$2613b83c3141003a);
    $parcel$export(module.exports, "getAllLinkedSpaces", ()=>$0f36cff0fb97de2b$export$6f4beca8ff3702f3);
    $parcel$export(module.exports, "addLabelsToArticles", ()=>$0f36cff0fb97de2b$export$f40640db2a9b7e80);
    $parcel$export(module.exports, "removeLabelsFromArticles", ()=>$0f36cff0fb97de2b$export$cba6b78bbfb96381);
    $parcel$export(module.exports, "fetchLabelSuggestions", ()=>$0f36cff0fb97de2b$export$8502c8a97aecfbad);
    $parcel$export(module.exports, "fetchArticleEditPermission", ()=>$0f36cff0fb97de2b$export$65396ff44dade790);
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    var $ebyGx = parcelRequire("ebyGx");
    var $kVLXA = parcelRequire("kVLXA");
    var $7f4tk;
    var $5OrSA;
    var $2Lj35;
    const $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined = (article)=>{
        const parsedArticle = {
            ...article
        };
        if (parsedArticle.viewCount === null) parsedArticle.viewCount = undefined;
        if (parsedArticle.categories === null) parsedArticle.categories = undefined;
        if (parsedArticle.featuredInCategories === null) parsedArticle.featuredInCategories = undefined;
        return parsedArticle;
    };
    const $0f36cff0fb97de2b$var$transformArticleResponse = (articleResponse)=>{
        let bodyAdf;
        if (articleResponse.body) bodyAdf = JSON.parse(articleResponse.body);
        const transformedData = {
            ...articleResponse,
            body: bodyAdf
        };
        return $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined(transformedData);
    };
    const $0f36cff0fb97de2b$var$getQueryString = (opts)=>{
        const { expand: expand, ...otherOpts } = opts;
        if (expand) return (0, $ebyGx.stringify)({
            ...otherOpts,
            expand: expand.join(',')
        });
        return (0, $ebyGx.stringify)(otherOpts);
    };
    const $0f36cff0fb97de2b$export$8837f4fc672e936d = (projectId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
        const apiPath = `/api/project/${projectId}/article?${queryString}`;
        const url = `${apolloPath}/${activationId}${apiPath}`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url).map((response)=>({
                ...response,
                results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
            }));
    };
    const $0f36cff0fb97de2b$export$897d9115a17b4c24 = (projectId, categoryId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
        const apiPath = `/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article?${queryString}`;
        const url = `${apolloPath}/${activationId}${apiPath}`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url).map((response)=>({
                ...response,
                results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
            }));
    };
    const $0f36cff0fb97de2b$export$f8c0d0a39b0d7d4e = (projectId, articleId, withCategory, apolloPath = (0, $45c806b56a43da0e$export$8ce6d23ffa1a190a))=>{
        const url = `${apolloPath}/api/project/${projectId}/article/${articleId}`;
        const queryString = withCategory ? `?${(0, $ebyGx.stringify)({
            expand: 'category'
        })}` : '';
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
    };
    const $0f36cff0fb97de2b$export$fb27d96404fd219d = (projectId, articleId, activationId, expandParams, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}`;
        const queryString = expandParams.length ? `?${$0f36cff0fb97de2b$var$getQueryString({
            expand: expandParams
        })}` : '';
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
    };
    const $0f36cff0fb97de2b$export$d93a983139fde0cc = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'PATCH',
            body: JSON.stringify({
                categories: categoryIds
            })
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$2613b83c3141003a = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'PUT',
            body: JSON.stringify({
                spaceKey: spaceKey,
                categories: categoryIds
            })
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$6f4beca8ff3702f3 = (projectKey)=>{
        const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb`;
        const transformedResponse = (0, (0, parcelRequire("5OrSA")).fetchJson$)(url).map((response)=>({
                spaces: response.map((space)=>({
                        name: space.spaceName,
                        key: space.spaceKey,
                        appLinkId: space.appLinkId
                    }))
            }));
        return transformedResponse;
    };
    const $0f36cff0fb97de2b$export$f40640db2a9b7e80 = ({ projectId: projectId, labels: labels, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'POST',
            body: JSON.stringify(labels)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$cba6b78bbfb96381 = ({ projectId: projectId, label: label, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label/${encodeURIComponent(label)}`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'DELETE'
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$8502c8a97aecfbad = (projectKey, queryString, articleId)=>{
        const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb/labels?query=${queryString}&contentId=${articleId}`;
        return (0, (0, parcelRequire("7f4tk")).default)(url).then(({ contentNameMatches: contentNameMatches })=>{
            if (!contentNameMatches?.length) return [];
            const suggestions = contentNameMatches.reduce((labelList, contentNameMatch)=>{
                if (contentNameMatch.length) return [
                    ...labelList,
                    ...contentNameMatch
                ];
                return labelList;
            }, []);
            return suggestions.length ? suggestions.map(({ name: name })=>({
                    label: name,
                    value: name
                })) : [];
        }).catch(()=>[]);
    };
    const $0f36cff0fb97de2b$export$65396ff44dade790 = (cloudId, articleId, projectId, accountId, sendCustomHeaders, spaceKey)=>{
        const body = {
            subject: {
                type: 'user',
                identifier: accountId
            },
            operation: 'update'
        };
        const headers = sendCustomHeaders ? {
            'Content-Type': 'application/json',
            'X-ATL-EmbeddablePage-EntityIds': JSON.stringify({
                spaceKey: spaceKey || '',
                parentProduct: 'JSM',
                parentProductContentContainerId: projectId,
                contentId: articleId
            })
        } : {
            'Content-Type': 'application/json'
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/${articleId}/permission/check`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        }).catch((error)=>(0, $kVLXA.Observable).throw(error));
    };
});
parcelRegister("5XgTr", function(module, exports) {
    $parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_SUCCESS", ()=>$b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2);
    $parcel$export(module.exports, "addCategoriesForArticleSuccess", ()=>$b60bbe4f4c92ec4f$export$deab1340d30ad632);
    const $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2 = 'state.actions.add-categories-for-article-success.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS';
    const $b60bbe4f4c92ec4f$export$deab1340d30ad632 = (payload)=>({
            payload: payload,
            type: $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2
        });
});
parcelRegister("6ovlC", function(module, exports) {
    $parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE", ()=>$5b88d8b66d98e99f$export$c22494f1249599aa);
    $parcel$export(module.exports, "addCategoriesForArticle", ()=>$5b88d8b66d98e99f$export$d93a983139fde0cc);
    const $5b88d8b66d98e99f$export$c22494f1249599aa = 'state.actions.add-categories-for-article.ADD_CATEGORIES_FOR_ARTICLE';
    const $5b88d8b66d98e99f$export$d93a983139fde0cc = (payload)=>({
            payload: payload,
            type: $5b88d8b66d98e99f$export$c22494f1249599aa
        });
});
const $aaa081f4160162a5$export$b8b9d90f9e5bd72b = 'jiraServiceDeskKnowledgeHub';
parcelRegister("eGP51", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$b7199b09d6315b91$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $fmmX1;
    var $e8y9X;
    var $8j0bg;
    var $80A0Z;
    var $gLt7z;
    const $b7199b09d6315b91$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("80A0Z")).ADD_LABELS_TO_ARTICLE)).mergeMap((action)=>{
            const { labels: labels, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            return (0, (0, parcelRequire("fmmX1")).addLabelsToArticles)({
                projectId: projectId,
                labels: labels,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map((response)=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onAddLabels success', {
                    articleId: articleId
                });
                return (0, (0, parcelRequire("8j0bg")).addLabelsToArticleSuccess)(response);
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onAddLabelsFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("e8y9X")).addLabelsToArticleFailure)({
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("e8y9X", function(module, exports) {
    $parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_FAILURE", ()=>$68db2bd167d08867$export$836fc3274a0c8c08);
    $parcel$export(module.exports, "addLabelsToArticleFailure", ()=>$68db2bd167d08867$export$46974ef034e5e1ff);
    const $68db2bd167d08867$export$836fc3274a0c8c08 = 'state.actions.add-labels-to-article-failure.ADD_LABELS_TO_ARTICLE_FAILURE';
    const $68db2bd167d08867$export$46974ef034e5e1ff = (payload)=>({
            payload: payload,
            type: $68db2bd167d08867$export$836fc3274a0c8c08
        });
});
parcelRegister("8j0bg", function(module, exports) {
    $parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_SUCCESS", ()=>$7cdb79ea2b68767f$export$fb41ea70dd3d20e7);
    $parcel$export(module.exports, "addLabelsToArticleSuccess", ()=>$7cdb79ea2b68767f$export$1d48c14841a2dd90);
    const $7cdb79ea2b68767f$export$fb41ea70dd3d20e7 = 'state.actions.add-labels-to-article-success.ADD_LABELS_TO_ARTICLE_SUCCESS';
    const $7cdb79ea2b68767f$export$1d48c14841a2dd90 = (payload)=>({
            payload: payload,
            type: $7cdb79ea2b68767f$export$fb41ea70dd3d20e7
        });
});
parcelRegister("80A0Z", function(module, exports) {
    $parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE", ()=>$f87c53beb7b3ea22$export$2b91058f81222c91);
    $parcel$export(module.exports, "addLabelsToArticle", ()=>$f87c53beb7b3ea22$export$335c057b91702017);
    const $f87c53beb7b3ea22$export$2b91058f81222c91 = 'state.actions.add-labels-to-article.ADD_LABELS_TO_ARTICLE';
    const $f87c53beb7b3ea22$export$335c057b91702017 = (payload)=>({
            payload: payload,
            type: $f87c53beb7b3ea22$export$2b91058f81222c91
        });
});
parcelRegister("4DyVT", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$01135ff527d8b512$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $i4zGm;
    var $33YKl;
    var $4VDwv;
    var $kHzxc;
    var $gLt7z;
    var $fhG9v;
    const $01135ff527d8b512$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("kHzxc")).BROWSE_KNOWLEDGE)).mergeMap((action)=>{
            const page = action.payload.page || 1;
            const state = store.getState();
            const limit = action.payload.limit || (0, (0, parcelRequire("fhG9v")).getBrowseLimit)(state);
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(state);
            const spaceKey = action.payload.spaceKey ?? '';
            const cursor = action.payload.cursor ?? '';
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(state);
            let requestParams = {
                categoryId: action.payload.id,
                expand: action.payload.expand,
                orderby: action.payload.orderBy,
                limit: limit
            };
            const query = action.payload.query != null ? action.payload.query : '';
            if (query) requestParams = {
                ...requestParams,
                query: query
            };
            if (spaceKey) requestParams = {
                ...requestParams,
                spaceKey: spaceKey
            };
            if (cursor) requestParams = {
                ...requestParams,
                cursor: cursor
            };
            const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
            const EVENT_NAME = requestParams.categoryId !== 'all-articles' ? 'browseArticleInCategory' : 'browseArticles';
            return (0, (0, parcelRequire("i4zGm")).list)(projectId, activationId, requestParams).map((response)=>{
                if (createAnalyticsEvent) {
                    const analyticsEvent = createAnalyticsEvent({});
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${EVENT_NAME} success`, {
                        projectId: projectId
                    });
                }
                return (0, (0, parcelRequire("4VDwv")).browseKnowledgeSuccess)({
                    id: action.payload.id,
                    ...response,
                    page: page
                });
            }).catch((error)=>{
                const { statusCode: statusCode } = error;
                if (createAnalyticsEvent) (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: createAnalyticsEvent({}),
                    id: `${EVENT_NAME} failure`,
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("33YKl")).browseKnowledgeFailure)({
                    id: action.payload.id,
                    page: page,
                    statusCode: statusCode
                }));
            });
        });
});
parcelRegister("i4zGm", function(module, exports) {
    $parcel$export(module.exports, "list", ()=>$45a2c0bfdac04a79$export$8837f4fc672e936d);
    $parcel$export(module.exports, "linkedSpaces", ()=>$45a2c0bfdac04a79$export$d3636d9abefdd232);
    var $fmmX1;
    const $45a2c0bfdac04a79$export$8837f4fc672e936d = (projectId, activationId, { categoryId: categoryId, ...opts })=>{
        if (categoryId === 'all-articles') return (0, (0, parcelRequire("fmmX1")).list)(projectId, opts, activationId);
        return (0, (0, parcelRequire("fmmX1")).listCategoryArticles)(projectId, categoryId, opts, activationId);
    };
    const $45a2c0bfdac04a79$export$d3636d9abefdd232 = (projectKey)=>(0, (0, parcelRequire("fmmX1")).getAllLinkedSpaces)(projectKey);
});
parcelRegister("33YKl", function(module, exports) {
    $parcel$export(module.exports, "BROWSE_KNOWLEDGE_FAILURE", ()=>$da91aed3c1c538b9$export$be396dbd2f8b61b5);
    $parcel$export(module.exports, "browseKnowledgeFailure", ()=>$da91aed3c1c538b9$export$a84d455b463b93e5);
    var $dMhXw;
    const $da91aed3c1c538b9$export$be396dbd2f8b61b5 = 'state.actions.browse-knowledge-failure.BROWSE_KNOWLEDGE_FAILURE';
    const $da91aed3c1c538b9$export$a84d455b463b93e5 = (opts)=>({
            type: $da91aed3c1c538b9$export$be396dbd2f8b61b5,
            payload: {
                id: opts.id,
                page: opts.page,
                error: {
                    message: (0, (0, parcelRequire("dMhXw")).default).genericMessage,
                    header: (0, (0, parcelRequire("dMhXw")).default).genericHeader
                }
            }
        });
});
parcelRegister("dMhXw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060d0dd30f30d38c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $060d0dd30f30d38c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-header",
            "defaultMessage": "Something went wrong"
        },
        genericMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-message",
            "defaultMessage": "We couldn't load the articles. Please refresh and try again."
        }
    });
});
parcelRegister("4VDwv", function(module, exports) {
    $parcel$export(module.exports, "BROWSE_KNOWLEDGE_SUCCESS", ()=>$fdd461c5c2f5f7b7$export$b9ec4df681504dbb);
    $parcel$export(module.exports, "browseKnowledgeSuccess", ()=>$fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d);
    const $fdd461c5c2f5f7b7$export$b9ec4df681504dbb = 'state.actions.browse-knowledge-success.BROWSE_KNOWLEDGE_SUCCESS';
    const $fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d = (payload)=>({
            type: $fdd461c5c2f5f7b7$export$b9ec4df681504dbb,
            payload: payload
        });
});
parcelRegister("feRMu", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$40f3d7cc48e99b60$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jrkeZ;
    var $6FRaa;
    var $aZdbu;
    var $gMZw6;
    var $gLt7z;
    const $40f3d7cc48e99b60$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("gMZw6")).FETCH_APPLINK)).mergeMap(()=>{
            const projectKey = (0, (0, parcelRequire("gLt7z")).getProjectKey)(store.getState());
            return (0, (0, parcelRequire("jrkeZ")).fetchCurrentAppLink)(projectKey).mergeMap((appLink)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("aZdbu")).fetchAppLinkSuccess)(appLink))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("6FRaa")).fetchAppLinkFailure)({
                    statusCode: statusCode
                })));
        });
});
parcelRegister("jrkeZ", function(module, exports) {
    $parcel$export(module.exports, "fetchConfluenceAppLinks", ()=>$75401d703e62a5e6$export$411bec8e101d37ea);
    $parcel$export(module.exports, "fetchCurrentAppLink", ()=>$75401d703e62a5e6$export$f1e8c76efca169f3);
    $parcel$export(module.exports, "fetchCurrentAppLinkV2", ()=>$75401d703e62a5e6$export$a5d48ab772ff4e41);
    $parcel$export(module.exports, "fetchConfluenceLink", ()=>$75401d703e62a5e6$export$1eeb53c23f99ec16);
    $parcel$export(module.exports, "fetchConfluenceLinkRestful", ()=>$75401d703e62a5e6$export$c71d13c885efd437);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    var $7f4tk;
    var $kTM7r;
    var $5QK3R;
    const $75401d703e62a5e6$export$411bec8e101d37ea = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchAppLinkNoEyeball)(projectKey);
    const $75401d703e62a5e6$export$916391fe3383489b = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchAppLinkNoEyeball)(projectKey).map((data)=>data.appLinks.find((link)=>link.isSystem));
    const $75401d703e62a5e6$export$f1e8c76efca169f3 = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchCurrentAppLinkNoEyeball)(projectKey);
    const $75401d703e62a5e6$export$a5d48ab772ff4e41 = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchCurrentAppLinkNoEyeballV2)(projectKey);
    const $75401d703e62a5e6$export$1eeb53c23f99ec16 = (projectKey)=>{
        const kbLink = (0, (0, parcelRequire("kTM7r")).wrmClaimSafe)('sd-kb-link');
        if (kbLink) {
            if (kbLink && !kbLink.error) return (0, $kVLXA.Observable).of({
                projectKey: projectKey,
                id: kbLink.id,
                spaceKey: kbLink.spaceKey,
                baseUrl: kbLink.baseUrl
            });
            if (kbLink && kbLink.error) return (0, $kVLXA.Observable).throw(kbLink);
        }
        return (0, $kVLXA.Observable).throw({
            error: {
                key: 'sd.applinks.error.corrupt'
            }
        });
    };
    const $75401d703e62a5e6$var$ERROR_KEY_MAP = {
        '404': 'sd.kb.link.error.link.not.found',
        other: 'sd.applinks.error.corrupt'
    };
    const $75401d703e62a5e6$export$c71d13c885efd437 = (projectKey)=>{
        const url = `/rest/servicedesk/1/pages/agent/knowledge/${projectKey}`;
        return (0, (0, parcelRequire("7f4tk")).default)(url).catch((err)=>Promise.reject({
                error: {
                    key: $75401d703e62a5e6$var$ERROR_KEY_MAP[err.statusCode] || $75401d703e62a5e6$var$ERROR_KEY_MAP.other
                }
            }));
    };
});
parcelRegister("kTM7r", function(module, exports) {
    $parcel$export(module.exports, "wrmClaimSafe", ()=>$7a3f570973700129$export$6d04651d170462ec);
    const $7a3f570973700129$export$6d04651d170462ec = (key)=>{
        window.wrmDataCache = window.wrmDataCache || {};
        if (window.wrmDataCache[key]) return window.wrmDataCache[key];
        const data = window.WRM.data.claim(key);
        window.wrmDataCache[key] = data;
        return data;
    };
    const $7a3f570973700129$export$460d685a9ee326a8 = (key)=>{
        const claimedData = window.WRM.data.claim(key);
        if (claimedData === undefined) throw new Error(`Could not find WRM data for key: ${key}`);
        return claimedData;
    };
});
parcelRegister("5QK3R", function(module, exports) {
    $parcel$export(module.exports, "fetchAppLinkNoEyeball", ()=>$00051febdde61fec$export$d888e54a19706e84);
    $parcel$export(module.exports, "fetchCurrentAppLinkNoEyeball", ()=>$00051febdde61fec$export$91f2ef831add2534);
    $parcel$export(module.exports, "fetchCurrentAppLinkNoEyeballV2", ()=>$00051febdde61fec$export$2727b4e442c6787f);
    var $7f4tk;
    var $5OrSA;
    const $00051febdde61fec$export$d888e54a19706e84 = (projectKey)=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence`);
    const $00051febdde61fec$export$91f2ef831add2534 = (projectKey)=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);
    const $00051febdde61fec$export$2727b4e442c6787f = (projectKey)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);
});
parcelRegister("6FRaa", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINK_FAILURE", ()=>$5c0435e88e4a5ddc$export$1763acbd33c374e5);
    $parcel$export(module.exports, "fetchAppLinkFailure", ()=>$5c0435e88e4a5ddc$export$635f69357a47e715);
    const $5c0435e88e4a5ddc$export$1763acbd33c374e5 = 'state.actions.fetch-applink-failure.FETCH_APPLINK_FAILURE';
    const $5c0435e88e4a5ddc$export$635f69357a47e715 = (error)=>({
            type: $5c0435e88e4a5ddc$export$1763acbd33c374e5,
            payload: error
        });
});
parcelRegister("aZdbu", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINK_SUCCESS", ()=>$cada50d61c624db3$export$5a66f7b0b7a57504);
    $parcel$export(module.exports, "fetchAppLinkSuccess", ()=>$cada50d61c624db3$export$d64417727a56e7f1);
    const $cada50d61c624db3$export$5a66f7b0b7a57504 = 'state.actions.fetch-applink-success.FETCH_APPLINK_SUCCESS';
    const $cada50d61c624db3$export$d64417727a56e7f1 = (payload)=>({
            type: $cada50d61c624db3$export$5a66f7b0b7a57504,
            payload: payload
        });
});
parcelRegister("kTAvA", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$034fe31e006c1c0e$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jrkeZ;
    var $3XkGj;
    var $7GY3F;
    var $4dXi2;
    var $gLt7z;
    const $034fe31e006c1c0e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("4dXi2")).FETCH_APPLINKS)).mergeMap(()=>{
            const projectKey = (0, (0, parcelRequire("gLt7z")).getProjectKey)(store.getState());
            return (0, (0, parcelRequire("jrkeZ")).fetchConfluenceAppLinks)(projectKey).mergeMap((appLinks)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("7GY3F")).fetchAppLinksSuccess)(appLinks.appLinks))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3XkGj")).fetchAppLinksFailure)({
                    statusCode: statusCode
                })));
        });
});
parcelRegister("3XkGj", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINKS_FAILURE", ()=>$daac65f7a8dc65e2$export$51c9d05978c1783b);
    $parcel$export(module.exports, "fetchAppLinksFailure", ()=>$daac65f7a8dc65e2$export$c460ed087c66a41d);
    const $daac65f7a8dc65e2$export$51c9d05978c1783b = 'state.actions.fetch-applinks-failure.FETCH_APPLINKS_FAILURE';
    const $daac65f7a8dc65e2$export$c460ed087c66a41d = (error)=>({
            type: $daac65f7a8dc65e2$export$51c9d05978c1783b,
            payload: error
        });
});
parcelRegister("7GY3F", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINKS_SUCCESS", ()=>$81371e274ff768f8$export$de0056b0bbdd21c8);
    $parcel$export(module.exports, "fetchAppLinksSuccess", ()=>$81371e274ff768f8$export$56072929934471cd);
    const $81371e274ff768f8$export$de0056b0bbdd21c8 = 'state.actions.fetch-applinks-success.FETCH_APPLINKS_SUCCESS';
    const $81371e274ff768f8$export$56072929934471cd = (payload)=>({
            type: $81371e274ff768f8$export$de0056b0bbdd21c8,
            payload: payload
        });
});
parcelRegister("4dXi2", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINKS", ()=>$01bf9f555ca0b395$export$e7bce13a560ead5e);
    $parcel$export(module.exports, "fetchAppLinks", ()=>$01bf9f555ca0b395$export$ee72e8e00b4fb176);
    const $01bf9f555ca0b395$export$e7bce13a560ead5e = 'state.actions.fetch-applinks.FETCH_APPLINKS';
    const $01bf9f555ca0b395$export$ee72e8e00b4fb176 = ()=>({
            type: $01bf9f555ca0b395$export$e7bce13a560ead5e
        });
});
parcelRegister("bDRTj", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$90f2b96f2a0068c3$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $fmmX1;
    var $39oW5;
    var $fTBH5;
    var $gLt7z;
    const $90f2b96f2a0068c3$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("39oW5")).FETCH_ARTICLE_EDIT_PERMISSION)).mergeMap((action)=>{
            const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent, spaceKey: spaceKey } = action.payload;
            const cloudId = (0, (0, parcelRequire("gLt7z")).getCloudId)(store.getState());
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            return (0, (0, parcelRequire("fmmX1")).fetchArticleEditPermission)(cloudId, id, projectId, accountId, true, spaceKey).mergeMap(({ hasPermission: hasPermission })=>{
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchArticleEditPermission success', {
                    articleId: id
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("fTBH5")).setArticleEditPermission)(hasPermission, id));
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onFetchArticleEditPermission failure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("fTBH5")).setArticleEditPermission)(false, id));
            });
        });
});
parcelRegister("39oW5", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE_EDIT_PERMISSION", ()=>$21d9f874c3cb8395$export$2f278bb19228e406);
    $parcel$export(module.exports, "fetchArticleEditPermission", ()=>$21d9f874c3cb8395$export$65396ff44dade790);
    const $21d9f874c3cb8395$export$2f278bb19228e406 = 'state.actions.fetch-article-edit-permission.FETCH_ARTICLE_EDIT_PERMISSION';
    const $21d9f874c3cb8395$export$65396ff44dade790 = (id, accountId, createAnalyticsEvent, spaceKey)=>({
            type: $21d9f874c3cb8395$export$2f278bb19228e406,
            payload: {
                id: id,
                spaceKey: spaceKey,
                accountId: accountId,
                createAnalyticsEvent: createAnalyticsEvent
            }
        });
});
parcelRegister("fTBH5", function(module, exports) {
    $parcel$export(module.exports, "SET_ARTICLE_EDIT_PERMISSION", ()=>$9fa31b3f751a812f$export$b3431c0d5e84092c);
    $parcel$export(module.exports, "setArticleEditPermission", ()=>$9fa31b3f751a812f$export$bb3e34eb2358e906);
    const $9fa31b3f751a812f$export$b3431c0d5e84092c = 'state.actions.set-article-edit-permission.SET_ARTICLE_EDIT_PERMISSION';
    const $9fa31b3f751a812f$export$bb3e34eb2358e906 = (isEditable, articleId)=>({
            type: $9fa31b3f751a812f$export$b3431c0d5e84092c,
            payload: {
                isEditable: isEditable,
                articleId: articleId
            }
        });
});
parcelRegister("cpM8i", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$f95e339a734ecb5c$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("jFVZ1");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $cVUDi;
    var $fmmX1;
    var $39oW5;
    var $4C8gV;
    var $agxSw;
    var $la4EY;
    var $gLt7z;
    const $f95e339a734ecb5c$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("la4EY")).FETCH_ARTICLE)).mergeMap((action)=>{
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = action.payload;
            const getArticleObservable = (0, (0, parcelRequire("fmmX1")).getArticleWithExpandParams)(projectId, id, activationId, [
                'category',
                'labels'
            ]);
            return getArticleObservable.mergeMap((article)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("agxSw")).fetchArticleSuccess)(article)), (0, $kVLXA.Observable).of((0, (0, parcelRequire("39oW5")).fetchArticleEditPermission)(id, accountId, createAnalyticsEvent, article.spaceKey || '')))).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: createAnalyticsEvent({}),
                    id: 'fetchArticle failure',
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("4C8gV")).fetchArticleFailure)({
                    id: id,
                    statusCode: error.statusCode
                }));
            });
        });
});
parcelRegister("4C8gV", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", ()=>$e3473a94e4383912$export$862d1fc538bf047c);
    $parcel$export(module.exports, "fetchArticleFailure", ()=>$e3473a94e4383912$export$b135c19fc249d3ab);
    var $4zIHa;
    const $e3473a94e4383912$export$862d1fc538bf047c = 'state.actions.fetch-article-failure.FETCH_ARTICLE_FAILURE';
    const $e3473a94e4383912$export$b135c19fc249d3ab = (opts)=>({
            type: $e3473a94e4383912$export$862d1fc538bf047c,
            payload: {
                id: opts.id,
                error: opts.statusCode === 404 ? {
                    message: (0, (0, parcelRequire("4zIHa")).default).notFoundMessage,
                    header: (0, (0, parcelRequire("4zIHa")).default).notFoundHeader,
                    ctaText: (0, (0, parcelRequire("4zIHa")).default).genericSearchCta,
                    ctaLink: '/knowledge'
                } : {
                    message: (0, (0, parcelRequire("4zIHa")).default).genericMessage,
                    header: (0, (0, parcelRequire("4zIHa")).default).genericHeader,
                    ctaText: (0, (0, parcelRequire("4zIHa")).default).genericSearchCta,
                    ctaLink: '/knowledge'
                }
            }
        });
});
parcelRegister("4zIHa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1714dd9e0ac9ecf4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1714dd9e0ac9ecf4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-header",
            "defaultMessage": "Can't find this article"
        },
        notFoundMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-message",
            "defaultMessage": "You may not have permission to view this article, you may not have permission to access Confluence, or this article may not exist."
        },
        genericHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-header",
            "defaultMessage": "Something went wrong"
        },
        genericMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-message",
            "defaultMessage": "We couldn't load this article. Please refresh after a few minutes."
        },
        genericSearchCta: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-search-cta",
            "defaultMessage": "Browse all articles"
        }
    });
});
parcelRegister("agxSw", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", ()=>$345896be0e3d6472$export$2d213dcac7fc3339);
    $parcel$export(module.exports, "fetchArticleSuccess", ()=>$345896be0e3d6472$export$6910c63a4b3017af);
    const $345896be0e3d6472$export$2d213dcac7fc3339 = 'state.actions.fetch-article-success.FETCH_ARTICLE_SUCCESS';
    const $345896be0e3d6472$export$6910c63a4b3017af = (payload)=>({
            type: $345896be0e3d6472$export$2d213dcac7fc3339,
            payload: payload
        });
});
parcelRegister("la4EY", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE", ()=>$fdce37e75ad78af2$export$a55f0530be417648);
    $parcel$export(module.exports, "fetchArticle", ()=>$fdce37e75ad78af2$export$b455945318d7989e);
    const $fdce37e75ad78af2$export$a55f0530be417648 = 'state.actions.fetch-article.FETCH_ARTICLE';
    const $fdce37e75ad78af2$export$b455945318d7989e = (id, articleType, accountId, createAnalyticsEvent)=>({
            type: $fdce37e75ad78af2$export$a55f0530be417648,
            payload: {
                id: id,
                articleType: articleType,
                accountId: accountId,
                createAnalyticsEvent: createAnalyticsEvent
            }
        });
});
parcelRegister("a20m8", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$e17a2d6c79b83d30$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $guSo6;
    var $4COnH;
    var $7gdJb;
    var $jpaaK;
    var $gLt7z;
    const $e17a2d6c79b83d30$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jpaaK")).FETCH_CATEGORIES)).mergeMap((action)=>{
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const { analyticsEvent: analyticsEvent } = action.payload;
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            return (0, (0, parcelRequire("guSo6")).listCategories)(projectId, activationId).mergeMap((categories)=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                    projectId: projectId
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("7gdJb")).fetchCategoriesSuccess)(categories));
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onFetchCategoriesFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("4COnH")).fetchCategoriesFailure)(error));
            });
        });
});
parcelRegister("4COnH", function(module, exports) {
    $parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", ()=>$ab63acaf2733bdc5$export$4425a101b60fad1);
    $parcel$export(module.exports, "fetchCategoriesFailure", ()=>$ab63acaf2733bdc5$export$10b1ac5b71f5513e);
    const $ab63acaf2733bdc5$export$4425a101b60fad1 = 'state.actions.fetch-categories-failure.FETCH_CATEGORIES_FAILURE';
    const $ab63acaf2733bdc5$export$10b1ac5b71f5513e = (error)=>({
            type: $ab63acaf2733bdc5$export$4425a101b60fad1,
            payload: error
        });
});
parcelRegister("7gdJb", function(module, exports) {
    $parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", ()=>$abc28ada0f8a3d9a$export$8fe15054f89178e3);
    $parcel$export(module.exports, "fetchCategoriesSuccess", ()=>$abc28ada0f8a3d9a$export$1372a078b0bbb728);
    const $abc28ada0f8a3d9a$export$8fe15054f89178e3 = 'state.actions.fetch-categories-success.FETCH_CATEGORIES_SUCCESS';
    const $abc28ada0f8a3d9a$export$1372a078b0bbb728 = (payload)=>({
            type: $abc28ada0f8a3d9a$export$8fe15054f89178e3,
            payload: payload
        });
});
parcelRegister("jpaaK", function(module, exports) {
    $parcel$export(module.exports, "FETCH_CATEGORIES", ()=>$b9a08106a74df812$export$cce9a7031b65f96c);
    const $b9a08106a74df812$export$cce9a7031b65f96c = 'state.actions.fetch-categories.FETCH_CATEGORIES';
    const $b9a08106a74df812$export$416ec9f5729de215 = (payload)=>({
            type: $b9a08106a74df812$export$cce9a7031b65f96c,
            payload: payload
        });
});
parcelRegister("gTvcp", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$ab48fc04d604b95e$export$8ec5145af6f76965);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("9o0uh");
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $jrkeZ;
    var $eIzL1;
    var $dtw6v;
    var $791HF;
    var $gLt7z;
    var $knU3A;
    const $ab48fc04d604b95e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("791HF")).FETCH_KB_HUB)).mergeMap((action)=>{
            const state = store.getState();
            const projectKey = (0, (0, parcelRequire("gLt7z")).getProjectKey)(state);
            const linkedState = (0, (0, parcelRequire("knU3A")).getHubLinkedState)(state);
            if (linkedState === 'linked') return (0, $kVLXA.Observable).empty();
            return (0, (0, parcelRequire("jrkeZ")).fetchConfluenceLink)(action.payload.projectKey).mergeMap((link)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("dtw6v")).fetchKbHubSuccess)(link))).catch(()=>(0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("jrkeZ")).fetchConfluenceLinkRestful)(projectKey)).map((link)=>(0, (0, parcelRequire("dtw6v")).fetchKbHubSuccess)(link)).catch((err)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("eIzL1")).fetchKbHubFailure)(err))));
        });
});
parcelRegister("eIzL1", function(module, exports) {
    $parcel$export(module.exports, "FETCH_KB_HUB_FAILURE", ()=>$be2f3f4be23b75f6$export$100d6710da08cb59);
    $parcel$export(module.exports, "fetchKbHubFailure", ()=>$be2f3f4be23b75f6$export$7b9ad8413eaffe44);
    const $be2f3f4be23b75f6$export$100d6710da08cb59 = 'state.actions.fetch-knowledge-hub-failure.FETCH_KB_HUB_FAILURE';
    const $be2f3f4be23b75f6$export$7b9ad8413eaffe44 = (payload)=>({
            type: $be2f3f4be23b75f6$export$100d6710da08cb59,
            payload: payload
        });
});
parcelRegister("dtw6v", function(module, exports) {
    $parcel$export(module.exports, "FETCH_KB_HUB_SUCCESS", ()=>$db188543ec32993c$export$52043214fd798dd);
    $parcel$export(module.exports, "fetchKbHubSuccess", ()=>$db188543ec32993c$export$3b2b22c5e24bfc30);
    const $db188543ec32993c$export$52043214fd798dd = 'state.actions.fetch-knowledge-hub-success.FETCH_KB_HUB_SUCCESS';
    const $db188543ec32993c$export$3b2b22c5e24bfc30 = (payload)=>({
            type: $db188543ec32993c$export$52043214fd798dd,
            payload: payload
        });
});
parcelRegister("791HF", function(module, exports) {
    $parcel$export(module.exports, "FETCH_KB_HUB", ()=>$2cbea12bc7a00f0f$export$6838769d7df96fbb);
    const $2cbea12bc7a00f0f$export$6838769d7df96fbb = 'state.actions.fetch-knowledge-hub.FETCH_KB_HUB';
    const $2cbea12bc7a00f0f$export$647aec6b80785904 = (projectKey)=>({
            type: $2cbea12bc7a00f0f$export$6838769d7df96fbb,
            payload: {
                projectKey: projectKey
            }
        });
});
parcelRegister("4JAV5", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$f044973d8abb6a80$export$8ec5145af6f76965);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $i4zGm;
    var $azjdP;
    var $jzG6G;
    var $goH2j;
    const $f044973d8abb6a80$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, (0, parcelRequire("goH2j")).FETCH_LINKED_SPACES)).mergeMap((action)=>{
            const { projectKey: projectKey } = action.payload;
            return (0, (0, parcelRequire("i4zGm")).linkedSpaces)(projectKey).map((response)=>(0, (0, parcelRequire("jzG6G")).fetchLinkedSpacesSuccess)(response)).catch(()=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("azjdP")).fetchLinkedSpacesFailure)()));
        });
});
parcelRegister("azjdP", function(module, exports) {
    $parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", ()=>$cf0b03dea91f2721$export$9c186423b974805a);
    $parcel$export(module.exports, "fetchLinkedSpacesFailure", ()=>$cf0b03dea91f2721$export$e63a5f7249c4e5d6);
    var $NEu0c;
    const $cf0b03dea91f2721$export$9c186423b974805a = 'state.actions.fetch-linked-spaces-failure.FETCH_LINKED_SPACES_FAILURE';
    const $cf0b03dea91f2721$export$e63a5f7249c4e5d6 = ()=>({
            type: $cf0b03dea91f2721$export$9c186423b974805a,
            payload: {
                error: {
                    message: (0, (0, parcelRequire("NEu0c")).default).genericMessage,
                    header: (0, (0, parcelRequire("NEu0c")).default).genericHeader
                }
            }
        });
});
parcelRegister("NEu0c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc9fdd816f4c370f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fc9fdd816f4c370f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-header",
            "defaultMessage": "Something went wrong"
        },
        genericMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-message",
            "defaultMessage": "We couldn't load the linked spaces. Please refresh and try again."
        }
    });
});
parcelRegister("jzG6G", function(module, exports) {
    $parcel$export(module.exports, "FETCH_LINKED_SPACE_SUCCESS", ()=>$366933797ff4c171$export$5142badf262ccc86);
    $parcel$export(module.exports, "fetchLinkedSpacesSuccess", ()=>$366933797ff4c171$export$ad2cc5272eef487);
    const $366933797ff4c171$export$5142badf262ccc86 = 'state.actions.fetch-linked-spaces-success.FETCH_LINKED_SPACE_SUCCESS';
    const $366933797ff4c171$export$ad2cc5272eef487 = (payload)=>({
            type: $366933797ff4c171$export$5142badf262ccc86,
            payload: payload
        });
});
parcelRegister("iYJ1l", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$c4c23b3440ef4ce4$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $fmmX1;
    var $iHUHp;
    var $9aNfZ;
    var $l1APE;
    var $gLt7z;
    const $c4c23b3440ef4ce4$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("l1APE")).REMOVE_LABEL_FROM_ARTICLE)).mergeMap((action)=>{
            const { label: label, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            return (0, (0, parcelRequire("fmmX1")).removeLabelsFromArticles)({
                projectId: projectId,
                label: label,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onRemoveLabel success', {
                    articleId: articleId
                });
                return (0, (0, parcelRequire("9aNfZ")).removeLabelFromArticleSuccess)({
                    articleId: articleId,
                    label: label
                });
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onRemoveLabelFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("iHUHp")).removeLabelFromArticleFailure)({
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("9aNfZ", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_SUCCESS", ()=>$16ef0dd8936a9692$export$a9305d58f2d32098);
    $parcel$export(module.exports, "removeLabelFromArticleSuccess", ()=>$16ef0dd8936a9692$export$2aaf552c4301b8b9);
    const $16ef0dd8936a9692$export$a9305d58f2d32098 = 'state.actions.remove-label-from-article-success.REMOVE_LABEL_FROM_ARTICLE_SUCCESS';
    const $16ef0dd8936a9692$export$2aaf552c4301b8b9 = (payload)=>({
            payload: payload,
            type: $16ef0dd8936a9692$export$a9305d58f2d32098
        });
});
parcelRegister("l1APE", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE", ()=>$6c5650e2e1eb67b6$export$ad78add1bc20cf2e);
    $parcel$export(module.exports, "removeLabelFromArticle", ()=>$6c5650e2e1eb67b6$export$c7cf56492591fe0f);
    const $6c5650e2e1eb67b6$export$ad78add1bc20cf2e = 'state.actions.remove-label-from-article.REMOVE_LABEL_FROM_ARTICLE';
    const $6c5650e2e1eb67b6$export$c7cf56492591fe0f = (payload)=>({
            payload: payload,
            type: $6c5650e2e1eb67b6$export$ad78add1bc20cf2e
        });
});
parcelRegister("92ShW", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$699ec73c490fb4c9$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("8n054");
    parcelRequire("6cbqE");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("2agIZ");
    var $i4zGm;
    var $hkbfC;
    var $gLt7z;
    const $699ec73c490fb4c9$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("hkbfC")).SEARCH_ARTICLES)).mergeMap(()=>(0, (0, parcelRequire("gLt7z")).getBaseUrl)(store.getState()));
    const $699ec73c490fb4c9$export$83f762cb3c8bb65a = (activationId)=>{
        const stream$ = new (0, $cab1K.Subject)();
        const results$ = stream$.debounce(({ term: term })=>(0, $kVLXA.Observable).timer(term ? 300 : 0)).switchMap(({ term: term, projectId: projectId, limit: limit, searchOnEmptyTerm: searchOnEmptyTerm, categoryId: categoryId, expansions: expansions, orderBy: orderBy })=>{
            if (!searchOnEmptyTerm && !term) {
                const empty = {
                    results: [],
                    totalSize: 0,
                    start: 0,
                    limit: 0,
                    size: 0,
                    categoriesSupported: true
                };
                return (0, $kVLXA.Observable).of(empty);
            }
            return (0, (0, parcelRequire("i4zGm")).list)(projectId, activationId, {
                limit: limit,
                categoryId: categoryId,
                query: term,
                expand: expansions,
                orderby: orderBy
            });
        });
        return {
            search: (args)=>stream$.next(args),
            results$: results$
        };
    };
});
parcelRegister("hkbfC", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_ARTICLES", ()=>$b106701f9da61eca$export$9d662e85b068d1ae);
    const $b106701f9da61eca$export$9d662e85b068d1ae = 'state.actions.search-articles.SEARCH_ARTICLES';
    const $b106701f9da61eca$export$ce4856e0aa50b880 = (payload)=>({
            type: $b106701f9da61eca$export$9d662e85b068d1ae,
            payload: payload
        });
});
parcelRegister("6OXm8", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$611d4a2326bd0c8a$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $hhweD;
    var $cVUDi;
    var $fmmX1;
    var $6zk4x;
    var $ffNrT;
    var $19Gv3;
    var $gXg4u;
    var $gLt7z;
    const $611d4a2326bd0c8a$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("19Gv3")).UPDATE_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
            const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            const currentCategoryIds = (0, (0, parcelRequire("gXg4u")).getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
            return (0, (0, parcelRequire("fmmX1")).updateCategoriesForArticle)({
                projectId: projectId,
                categoryIds: categoryIds,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map(()=>{
                (0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(analyticsEvent, {
                    action: 'update',
                    actionSubjectId: articleId
                });
                return (0, (0, parcelRequire("ffNrT")).updateCategoriesForArticleSuccess)({
                    articleId: articleId,
                    categoryIds: categoryIds,
                    previousCategoryIds: currentCategoryIds
                });
            }).catch((error)=>{
                const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
                (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: analyticsEvent,
                    id: 'articleUpdate Failure',
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("6zk4x")).updateCategoriesForArticleFailure)({
                    statusCode: statusCode,
                    errorKey: errorKey,
                    errorMessage: errorMessage,
                    failedCategoryIds: categories,
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("ffNrT", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS", ()=>$80acc745b1c17a99$export$1c5489fde8a5332f);
    $parcel$export(module.exports, "updateCategoriesForArticleSuccess", ()=>$80acc745b1c17a99$export$c725200756c4c1a2);
    const $80acc745b1c17a99$export$1c5489fde8a5332f = 'state.actions.update-categories-for-article-success.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS';
    const $80acc745b1c17a99$export$c725200756c4c1a2 = (payload)=>({
            payload: payload,
            type: $80acc745b1c17a99$export$1c5489fde8a5332f
        });
});
parcelRegister("19Gv3", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE", ()=>$44779a20dce37d77$export$a58f1691e9b5c9e3);
    $parcel$export(module.exports, "updateCategoriesForArticle", ()=>$44779a20dce37d77$export$2613b83c3141003a);
    const $44779a20dce37d77$export$a58f1691e9b5c9e3 = 'state.actions.update-categories-for-article.UPDATE_CATEGORIES_FOR_ARTICLE';
    const $44779a20dce37d77$export$2613b83c3141003a = (payload)=>({
            payload: payload,
            type: $44779a20dce37d77$export$a58f1691e9b5c9e3
        });
});
parcelRegister("1eweq", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeHubContainer", ()=>$248571581b729595$export$bb94633c27dcd0a4);
    $parcel$export(module.exports, "KnowledgeHubActionsSubscriber", ()=>$248571581b729595$export$3982d9a4b6ad6814);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $1xzCS;
    const $248571581b729595$export$168a0875d66dd4b7 = (newState)=>({ setState: setState })=>{
            setState(newState);
        };
    const $248571581b729595$export$e155678cbf296809 = ()=>({ getState: getState })=>getState();
    const $248571581b729595$export$e324594224ef24da = {
        updateStore: $248571581b729595$export$168a0875d66dd4b7,
        getStoreState: $248571581b729595$export$e155678cbf296809
    };
    const $248571581b729595$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'knowledge-hub',
        initialState: (0, parcelRequire("1xzCS")).defaultState,
        actions: $248571581b729595$export$e324594224ef24da
    });
    const $248571581b729595$export$bb94633c27dcd0a4 = (0, (0, parcelRequire("gg7kZ")).createContainer)($248571581b729595$export$390f32400eaf98c9);
    const $248571581b729595$export$44bc38849b4bbf73 = (0, (0, parcelRequire("51nlc")).createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
        displayName: 'KnowledgeHubState'
    });
    const $248571581b729595$export$3982d9a4b6ad6814 = (0, (0, parcelRequire("51nlc")).createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
        displayName: 'KnowledgeHubActions',
        selector: null
    });
    const $248571581b729595$export$81f6ad95dee7b9c = (0, (0, parcelRequire("3sQ5x")).createHook)($248571581b729595$export$390f32400eaf98c9, {
        selector: null
    });
});
parcelRegister("1xzCS", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$349a74123be4d8a0$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$349a74123be4d8a0$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $kChFH;
    var $3nEyX;
    var $lJvk4;
    const $349a74123be4d8a0$var$reducer = (0, $3f2cs.combineReducers)({
        app: (0, parcelRequire("kChFH")).default,
        ui: (0, parcelRequire("lJvk4")).default,
        entities: (0, parcelRequire("3nEyX")).default
    });
    const $349a74123be4d8a0$export$49d5fc8cba920a0 = {
        app: (0, (0, parcelRequire("kChFH")).defaultState),
        ui: (0, (0, parcelRequire("lJvk4")).defaultState),
        entities: (0, (0, parcelRequire("3nEyX")).defaultState)
    };
    var $349a74123be4d8a0$export$2e2bcd8739ae039 = (sweetStateUpdater)=>(state = $349a74123be4d8a0$export$49d5fc8cba920a0, action)=>{
            const outputState = $349a74123be4d8a0$var$reducer(state, action);
            sweetStateUpdater(outputState);
            return outputState;
        };
});
parcelRegister("kChFH", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$1551bcf88a1371a5$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$1551bcf88a1371a5$export$2e2bcd8739ae039);
    var $lzeFL;
    var $g5X3G;
    var $kstMB;
    const $1551bcf88a1371a5$export$49d5fc8cba920a0 = {
        baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
        atlassianAccountId: '',
        cloudId: '',
        fabricPfDirUrl: '',
        locale: (0, (0, parcelRequire("lzeFL")).defaultLocale),
        userFullname: '',
        portalId: -1,
        projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(''),
        projectId: -1,
        projectName: '',
        projectType: '',
        isAdmin: false,
        isJiraAdmin: false,
        isProjectSimplified: false,
        sidebarCategoryLabel: '',
        activationId: 'ee20ebad-e5a1-42f6-899b-18706f0559e7'
    };
    var $1551bcf88a1371a5$export$2e2bcd8739ae039 = (state = $1551bcf88a1371a5$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("kstMB")).INITIALIZE_APP_PROPS:
                return {
                    ...state,
                    ...action.payload
                };
            case 0, (0, parcelRequire("kstMB")).UPDATE_CATEGORY_SIDEBAR_LABEL:
                return {
                    ...state,
                    sidebarCategoryLabel: action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("kstMB", function(module, exports) {
    $parcel$export(module.exports, "INITIALIZE_APP_PROPS", ()=>$802af204f69179eb$export$84856e4ae7cd7538);
    $parcel$export(module.exports, "UPDATE_CATEGORY_SIDEBAR_LABEL", ()=>$802af204f69179eb$export$52e22c956d5c6839);
    const $802af204f69179eb$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
    const $802af204f69179eb$export$52e22c956d5c6839 = 'state.actions.app.UPDATE_CATEGORY_SIDEBAR_LABEL';
    const $802af204f69179eb$export$5f0e35553cecddfe = (payload)=>({
            type: $802af204f69179eb$export$84856e4ae7cd7538,
            payload: payload
        });
    const $802af204f69179eb$export$c2eea28c04c00544 = (payload)=>({
            type: $802af204f69179eb$export$52e22c956d5c6839,
            payload: payload
        });
});
parcelRegister("3nEyX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$599b129cc2fb02a8$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "defaultState", ()=>$599b129cc2fb02a8$export$49d5fc8cba920a0);
    var $3f2cs = parcelRequire("3f2cs");
    var $fmcS9;
    var $gS1i9;
    var $kahXZ;
    var $5ev1t;
    var $aCUFo;
    var $jsmdo;
    var $3h2aI;
    var $599b129cc2fb02a8$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        hub: (0, parcelRequire("jsmdo")).default,
        articles: (0, parcelRequire("kahXZ")).default,
        browse: (0, parcelRequire("5ev1t")).default,
        categories: (0, parcelRequire("aCUFo")).default,
        spaces: (0, parcelRequire("3h2aI")).default,
        appLink: (0, parcelRequire("fmcS9")).default,
        appLinks: (0, parcelRequire("gS1i9")).default
    });
    const $599b129cc2fb02a8$export$49d5fc8cba920a0 = {
        hub: (0, (0, parcelRequire("jsmdo")).defaultState),
        articles: (0, (0, parcelRequire("kahXZ")).defaultState),
        browse: (0, (0, parcelRequire("5ev1t")).defaultState),
        categories: (0, (0, parcelRequire("aCUFo")).defaultState),
        spaces: (0, (0, parcelRequire("3h2aI")).defaultState),
        appLink: (0, (0, parcelRequire("fmcS9")).defaultState),
        appLinks: (0, (0, parcelRequire("gS1i9")).defaultState)
    };
});
parcelRegister("fmcS9", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$f5121befb21ec1b4$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$f5121befb21ec1b4$export$2e2bcd8739ae039);
    var $6FRaa;
    var $aZdbu;
    var $gMZw6;
    const $f5121befb21ec1b4$export$49d5fc8cba920a0 = {
        isLoaded: false,
        appLink: undefined
    };
    var $f5121befb21ec1b4$export$2e2bcd8739ae039 = (state = $f5121befb21ec1b4$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("gMZw6")).FETCH_APPLINK:
                {
                    const { error: error, ...stateWithoutError } = state;
                    const newState = {
                        ...stateWithoutError,
                        isLoaded: false
                    };
                    return newState;
                }
            case 0, (0, parcelRequire("aZdbu")).FETCH_APPLINK_SUCCESS:
                return {
                    ...state,
                    isLoaded: true,
                    appLink: action.payload
                };
            case 0, (0, parcelRequire("6FRaa")).FETCH_APPLINK_FAILURE:
                return {
                    ...state,
                    error: action.payload,
                    isLoaded: true
                };
            default:
                return state;
        }
    };
});
parcelRegister("gS1i9", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$39212e89b0790fee$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$39212e89b0790fee$export$2e2bcd8739ae039);
    var $3XkGj;
    var $7GY3F;
    var $4dXi2;
    const $39212e89b0790fee$export$49d5fc8cba920a0 = {
        isLoaded: false
    };
    var $39212e89b0790fee$export$2e2bcd8739ae039 = (state = $39212e89b0790fee$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("4dXi2")).FETCH_APPLINKS:
                return {
                    ...state,
                    error: undefined,
                    isLoaded: false
                };
            case 0, (0, parcelRequire("7GY3F")).FETCH_APPLINKS_SUCCESS:
                return {
                    appLinks: action.payload,
                    error: undefined,
                    hasConfluenceServer: action.payload.some((appLink)=>appLink.isServer),
                    isLoaded: true
                };
            case 0, (0, parcelRequire("3XkGj")).FETCH_APPLINKS_FAILURE:
                return {
                    appLinks: [],
                    error: action.payload,
                    hasConfluenceServer: false,
                    isLoaded: true
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("kahXZ", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$16983ab139c0b8e5$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$16983ab139c0b8e5$export$2e2bcd8739ae039);
    var $4wVpT = parcelRequire("4wVpT");
    var $1UikQ = parcelRequire("1UikQ");
    var $hqULQ;
    var $5sKH1;
    var $5XgTr;
    var $6ovlC;
    var $e8y9X;
    var $8j0bg;
    var $80A0Z;
    var $4VDwv;
    var $4C8gV;
    var $agxSw;
    var $la4EY;
    var $iMgsY;
    var $e4spq;
    var $3pXRi;
    var $iHUHp;
    var $9aNfZ;
    var $l1APE;
    var $hsOR7;
    var $fTBH5;
    var $6zk4x;
    var $ffNrT;
    var $19Gv3;
    const $16983ab139c0b8e5$export$49d5fc8cba920a0 = {};
    const $16983ab139c0b8e5$var$articleListToObject = (articles)=>articles.reduce((acc, article)=>({
                ...acc,
                [article.id]: {
                    ...article,
                    title: (0, (0, parcelRequire("hqULQ")).removeHighlightText)(article.title),
                    categories: article.categories && article.categories.map((category)=>category.id)
                }
            }), {});
    var $16983ab139c0b8e5$export$2e2bcd8739ae039 = (state = $16983ab139c0b8e5$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("3pXRi")).REMOVE_ARTICLE_FROM_CATEGORY:
            case 0, (0, parcelRequire("6ovlC")).ADD_CATEGORIES_FOR_ARTICLE:
            case 0, (0, parcelRequire("19Gv3")).UPDATE_CATEGORIES_FOR_ARTICLE:
                if (state[action.payload.articleId]) return {
                    ...state,
                    [action.payload.articleId]: {
                        ...state[action.payload.articleId],
                        isBusy: true
                    }
                };
                return state;
            case 0, (0, parcelRequire("iMgsY")).REMOVE_ARTICLE_FROM_CATEGORY_FAILURE:
            case 0, (0, parcelRequire("5sKH1")).ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
            case 0, (0, parcelRequire("6zk4x")).UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
                if (state[action.payload.articleId]) return {
                    ...state,
                    [action.payload.articleId]: {
                        ...state[action.payload.articleId],
                        isBusy: false
                    }
                };
                return state;
            case 0, (0, parcelRequire("e4spq")).REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS:
                if (state[action.payload.articleId]) {
                    const existingArticle = state[action.payload.articleId];
                    const { categoryId: categoryId } = action.payload;
                    const newCategoriesList = (existingArticle.categories || []).filter((id)=>id !== categoryId);
                    const featuredInCategoryList = (existingArticle.featuredInCategories || []).filter((id)=>id !== categoryId);
                    return {
                        ...state,
                        [action.payload.articleId]: {
                            ...existingArticle,
                            categories: newCategoriesList,
                            featuredInCategories: featuredInCategoryList,
                            isBusy: false
                        }
                    };
                }
                return state;
            case 0, (0, parcelRequire("5XgTr")).ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId, categoryIds: newlyAddedCategoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                    const allCategoryIds = [
                        ...previousCategoryIds,
                        ...newlyAddedCategoryIds
                    ];
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                        const featuredInCategories = (0, ($parcel$interopDefault($4wVpT)))(allCategoryIds, existingFeaturedInCategoryIds);
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                featuredInCategories: featuredInCategories,
                                categories: allCategoryIds,
                                isBusy: false
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("ffNrT")).UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                        const featuredInCategories = (0, ($parcel$interopDefault($4wVpT)))(categoryIds, existingFeaturedInCategoryIds);
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                featuredInCategories: featuredInCategories,
                                categories: categoryIds,
                                isBusy: false
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("4VDwv")).BROWSE_KNOWLEDGE_SUCCESS:
                return (0, ($parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload.results));
            case 0, (0, parcelRequire("hsOR7")).SEARCH_ARTICLES_SUCCESS:
                return (0, ($parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload));
            case 0, (0, parcelRequire("la4EY")).FETCH_ARTICLE:
                if (state[action.payload.id] && state[action.payload.id].error) {
                    const newState = {
                        ...state
                    };
                    delete newState[action.payload.id];
                    return newState;
                }
                return state;
            case 0, (0, parcelRequire("agxSw")).FETCH_ARTICLE_SUCCESS:
                {
                    const { payload: payload } = action;
                    const categories = payload.categories ? {
                        categories: payload.categories.map((category)=>category.id)
                    } : {};
                    const featuredInCategories = payload.featuredInCategories ? {
                        featuredInCategories: payload.featuredInCategories
                    } : {};
                    const labels = payload.labels?.length ? payload.labels.map(({ id: id, label: label, name: name })=>({
                            id: id,
                            label: label,
                            name: name
                        })) : [];
                    const labelState = {
                        labels: labels,
                        isLoading: false,
                        addLabelError: false
                    };
                    const { labels: existingLabels, isEditable: isEditable, ...payloadWithoutLabels } = payload;
                    const articleState = {
                        ...payloadWithoutLabels,
                        ...categories,
                        ...featuredInCategories,
                        labelState: labelState,
                        isEditable: false
                    };
                    return {
                        ...state,
                        [action.payload.id]: (0, ($parcel$interopDefault($1UikQ)))({}, state[action.payload.id], articleState)
                    };
                }
            case 0, (0, parcelRequire("4C8gV")).FETCH_ARTICLE_FAILURE:
                return {
                    ...state,
                    [action.payload.id]: {
                        error: action.payload.error
                    }
                };
            case 0, (0, parcelRequire("8j0bg")).ADD_LABELS_TO_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId, labels: labels } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const updatedLabels = labels.length ? labels.map(({ id: id, label: label, name: name })=>({
                                id: id,
                                label: label,
                                name: name
                            })) : [];
                        const labelState = {
                            labels: updatedLabels,
                            isLoading: false,
                            addLabelError: false
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("9aNfZ")).REMOVE_LABEL_FROM_ARTICLE_SUCCESS:
                {
                    const { label: label, articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const labelState = existingArticle.labelState || {};
                        const existingLabels = labelState.labels || [];
                        const updatedLabels = existingLabels?.length ? existingLabels.filter(({ label: existingLabel })=>label !== existingLabel) : [];
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: {
                                    labels: updatedLabels,
                                    isLoading: false,
                                    addLabelError: false
                                }
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("e8y9X")).ADD_LABELS_TO_ARTICLE_FAILURE:
                {
                    const { articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle && existingArticle.labelState) {
                        const existingLabels = existingArticle.labelState.labels || [];
                        const labelState = {
                            labels: existingLabels,
                            isLoading: false,
                            addLabelError: true
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("l1APE")).REMOVE_LABEL_FROM_ARTICLE:
            case 0, (0, parcelRequire("80A0Z")).ADD_LABELS_TO_ARTICLE:
                {
                    const { articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle && existingArticle.labelState) {
                        const existingLabels = existingArticle.labelState.labels || [];
                        const labelState = {
                            labels: existingLabels,
                            isLoading: true,
                            addLabelError: false
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("iHUHp")).REMOVE_LABEL_FROM_ARTICLE_FAILURE:
                {
                    const { articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle && existingArticle.labelState) {
                        const existingLabels = existingArticle.labelState.labels || [];
                        const labelState = {
                            labels: existingLabels,
                            isLoading: false,
                            addLabelError: false
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("fTBH5")).SET_ARTICLE_EDIT_PERMISSION:
                {
                    const { articleId: articleId, isEditable: isEditable } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            isEditable: isEditable
                        }
                    };
                    return state;
                }
            default:
                return state;
        }
    };
});
parcelRegister("4wVpT", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $9dThv = parcelRequire("9dThv");
    var $g7i7g = parcelRequire("g7i7g");
    var $d9Hx6 = parcelRequire("d9Hx6");
    var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
        var mapped = $1nIHN(arrays, $d9Hx6);
        return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
    });
    module.exports = $34c6b050456654f8$var$intersection;
});
parcelRegister("9dThv", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $6b7035a795ecd274$var$nativeMin = Math.min;
    function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
        while(othIndex--){
            var array = arrays[othIndex];
            if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
            maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
        }
        array = arrays[0];
        var index = -1, seen = caches[0];
        outer: while(++index < length && result.length < maxLength){
            var value = array[index], computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
                othIndex = othLength;
                while(--othIndex){
                    var cache = caches[othIndex];
                    if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                }
                if (seen) seen.push(computed);
                result.push(value);
            }
        }
        return result;
    }
    module.exports = $6b7035a795ecd274$var$baseIntersection;
});
parcelRegister("d9Hx6", function(module, exports) {
    var $f3SOL = parcelRequire("f3SOL");
    function $993de25d5a02863a$var$castArrayLikeObject(value) {
        return $f3SOL(value) ? value : [];
    }
    module.exports = $993de25d5a02863a$var$castArrayLikeObject;
});
parcelRegister("hqULQ", function(module, exports) {
    $parcel$export(module.exports, "removeHighlightText", ()=>$483996128e1ce34e$export$4fe678a311e29d1a);
    const $483996128e1ce34e$export$4fe678a311e29d1a = (text)=>text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
});
parcelRegister("iMgsY", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_FAILURE", ()=>$e6e2e62b66b39b7e$export$30c079f32002614a);
    const $e6e2e62b66b39b7e$export$30c079f32002614a = 'state.actions.remove-article-from-category-failure.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE';
    const $e6e2e62b66b39b7e$export$9c7b80de1b92cc2 = (payload)=>({
            payload: payload,
            type: $e6e2e62b66b39b7e$export$30c079f32002614a
        });
});
parcelRegister("e4spq", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS", ()=>$1b3b33db699d8db2$export$8bab89f0adf16580);
    const $1b3b33db699d8db2$export$8bab89f0adf16580 = 'state.actions.remove-article-from-category-success.REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS';
    const $1b3b33db699d8db2$export$37035f42efedefca = (payload)=>({
            type: $1b3b33db699d8db2$export$8bab89f0adf16580,
            payload: payload
        });
});
parcelRegister("3pXRi", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY", ()=>$df3a27bd08a194ec$export$ffc4687de776860c);
    $parcel$export(module.exports, "removeArticleFromCategory", ()=>$df3a27bd08a194ec$export$b6002acecf935894);
    const $df3a27bd08a194ec$export$ffc4687de776860c = 'state.actions.remove-article-from-category.REMOVE_ARTICLE_FROM_CATEGORY';
    const $df3a27bd08a194ec$export$b6002acecf935894 = (payload)=>({
            payload: payload,
            type: $df3a27bd08a194ec$export$ffc4687de776860c
        });
});
parcelRegister("hsOR7", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_ARTICLES_SUCCESS", ()=>$4257b84175002daa$export$b377bab65795997b);
    const $4257b84175002daa$export$b377bab65795997b = 'state.actions.search-articles-success.SEARCH_ARTICLES_SUCCESS';
    const $4257b84175002daa$export$327940e72204ca9b = (payload)=>({
            type: $4257b84175002daa$export$b377bab65795997b,
            payload: payload
        });
});
parcelRegister("5ev1t", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$22d8828255293e73$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$22d8828255293e73$export$2e2bcd8739ae039);
    var $16dzj = parcelRequire("16dzj");
    var $33YKl;
    var $4VDwv;
    var $kHzxc;
    var $0523Q;
    var $ffNrT;
    const $22d8828255293e73$export$49d5fc8cba920a0 = {
        limit: 20
    };
    var $22d8828255293e73$export$2e2bcd8739ae039 = (state = $22d8828255293e73$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("ffNrT")).UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { categoryIds: categoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                    if (categoryIds) {
                        const newState = {
                            ...state
                        };
                        const categoryIdsNeededCacheClear = (0, ($parcel$interopDefault($16dzj)))(categoryIds, previousCategoryIds);
                        categoryIdsNeededCacheClear.forEach((categoryId)=>{
                            if (newState[categoryId]) newState[categoryId].shouldClearCacheOnNextFetch = true;
                        });
                        return newState;
                    }
                    return state;
                }
            case 0, (0, parcelRequire("0523Q")).CLEAR_BROWSE:
                {
                    const newState = {
                        ...state
                    };
                    delete newState[action.payload];
                    return newState;
                }
            case 0, (0, parcelRequire("kHzxc")).BROWSE_KNOWLEDGE:
                if (state[action.payload.id] && state[action.payload.id].pages[`${action.payload.page}`] && state[action.payload.id].pages[`${action.payload.page}`].error) {
                    const newState = {
                        ...state,
                        loading: true
                    };
                    delete newState[action.payload.id].pages[`${action.payload.page}`];
                    return newState;
                }
                if (state[action.payload.id] && state[action.payload.id].shouldClearCacheOnNextFetch) {
                    const newState = {
                        ...state,
                        loading: true,
                        [action.payload.id]: {
                            ...state[action.payload.id],
                            shouldClearCacheOnNextFetch: false,
                            pages: {}
                        }
                    };
                    return newState;
                }
                return {
                    ...state,
                    loading: true
                };
            case 0, (0, parcelRequire("33YKl")).BROWSE_KNOWLEDGE_FAILURE:
                const newFailureState = {
                    ...state,
                    loading: false,
                    [action.payload.id]: {
                        pages: {
                            [`${action.payload.page}`]: {
                                error: action.payload.error
                            }
                        }
                    }
                };
                return newFailureState;
            case 0, (0, parcelRequire("4VDwv")).BROWSE_KNOWLEDGE_SUCCESS:
                const newSuccessState = {
                    ...state,
                    loading: false,
                    [action.payload.id]: {
                        totalSize: action.payload.totalSize,
                        categoriesSupported: action.payload.categoriesSupported,
                        pages: {
                            ...state[action.payload.id] ? state[action.payload.id].pages : {},
                            [`${action.payload.page}`]: action.payload.results.map((article)=>article.id)
                        },
                        nextCursor: action.payload.nextCursor || '',
                        prevCursor: action.payload.prevCursor || ''
                    }
                };
                return newSuccessState;
            default:
                return state;
        }
    };
});
parcelRegister("16dzj", function(module, exports) {
    var $2GdQn = parcelRequire("2GdQn");
    var $g7i7g = parcelRequire("g7i7g");
    var $7txx8 = parcelRequire("7txx8");
    var $f3SOL = parcelRequire("f3SOL");
    var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
        return $7txx8($2GdQn(arrays, $f3SOL));
    });
    module.exports = $0cd0e06461d5e057$var$xor;
});
parcelRegister("7txx8", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $7CoLY = parcelRequire("7CoLY");
    function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) return length ? $7CoLY(arrays[0]) : [];
        var index = -1, result = Array(length);
        while(++index < length){
            var array = arrays[index], othIndex = -1;
            while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
        }
        return $7CoLY($ekcP3(result, 1), iteratee, comparator);
    }
    module.exports = $571540db172adafd$var$baseXor;
});
parcelRegister("0523Q", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_BROWSE", ()=>$bf00c744d75604af$export$6795bd145eb16b7e);
    const $bf00c744d75604af$export$6795bd145eb16b7e = 'state.actions.clear-browse.CLEAR_BROWSE';
    const $bf00c744d75604af$export$862ad1bcf49b6105 = (categoryId)=>({
            type: $bf00c744d75604af$export$6795bd145eb16b7e,
            payload: categoryId
        });
});
parcelRegister("aCUFo", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$67411d71966dddb0$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$67411d71966dddb0$export$2e2bcd8739ae039);
    var $4VDwv;
    var $agxSw;
    var $4COnH;
    var $7gdJb;
    var $jpaaK;
    var $hsOR7;
    const $67411d71966dddb0$export$49d5fc8cba920a0 = {
        isLoaded: false,
        categories: [],
        isCategoriesSupported: false
    };
    const $67411d71966dddb0$var$reduceCategoriesFromArticles = (articles, existingCategories)=>{
        const categories = [
            ...existingCategories
        ];
        articles.reduce((acc, article)=>acc.concat(article.categories), []).forEach((category)=>{
            if (category && !categories.find((existingCategory)=>category.id === existingCategory.id)) categories.push(category);
        });
        return categories;
    };
    var $67411d71966dddb0$export$2e2bcd8739ae039 = (state = $67411d71966dddb0$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("7gdJb")).FETCH_CATEGORIES_SUCCESS:
                return {
                    categories: action.payload.categories,
                    isCategoriesSupported: action.payload.categoriesSupported,
                    isLoaded: true
                };
            case 0, (0, parcelRequire("4COnH")).FETCH_CATEGORIES_FAILURE:
                return {
                    ...state,
                    error: action.payload,
                    isLoaded: true
                };
            case 0, (0, parcelRequire("jpaaK")).FETCH_CATEGORIES:
                {
                    const newState = {
                        ...state,
                        isLoaded: false
                    };
                    delete newState.error;
                    return newState;
                }
            case 0, (0, parcelRequire("4VDwv")).BROWSE_KNOWLEDGE_SUCCESS:
                {
                    const newState = {
                        ...state,
                        categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload.results, state.categories)
                    };
                    return newState;
                }
            case 0, (0, parcelRequire("hsOR7")).SEARCH_ARTICLES_SUCCESS:
                {
                    const newState = {
                        ...state,
                        categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload, state.categories)
                    };
                    return newState;
                }
            case 0, (0, parcelRequire("agxSw")).FETCH_ARTICLE_SUCCESS:
                {
                    const newState = {
                        ...state,
                        categories: $67411d71966dddb0$var$reduceCategoriesFromArticles([
                            action.payload
                        ], state.categories)
                    };
                    return newState;
                }
            default:
                return state;
        }
    };
});
parcelRegister("jsmdo", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$8ca7f66155305974$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$8ca7f66155305974$export$2e2bcd8739ae039);
    var $eIzL1;
    var $dtw6v;
    var $bHD2d;
    var $k9iYw;
    const $8ca7f66155305974$export$49d5fc8cba920a0 = {
        linkedState: 'loading'
    };
    var $8ca7f66155305974$export$2e2bcd8739ae039 = (state = $8ca7f66155305974$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("dtw6v")).FETCH_KB_HUB_SUCCESS:
                {
                    const { projectKey: _, ...data } = action.payload;
                    return {
                        id: data.id,
                        confluenceUrl: (0, (0, parcelRequire("k9iYw")).removeTrailingSlash)(data.baseUrl),
                        spaceKey: data.spaceKey,
                        linkedState: 'linked'
                    };
                }
            case 0, (0, parcelRequire("eIzL1")).FETCH_KB_HUB_FAILURE:
                if (action.payload.error.key === 'sd.kb.link.error.link.not.found') return {
                    linkedState: 'unlinked'
                };
                return {
                    messageKey: action.payload.error.key,
                    linkedState: 'error'
                };
            case 0, (0, parcelRequire("bHD2d")).SET_KB_HUB:
                return action.payload;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("bHD2d", function(module, exports) {
    $parcel$export(module.exports, "SET_KB_HUB", ()=>$35c3183d0ed1f802$export$5d4aeddc17f0cd0f);
    $parcel$export(module.exports, "setKbHub", ()=>$35c3183d0ed1f802$export$3f646e047bd99e08);
    const $35c3183d0ed1f802$export$5d4aeddc17f0cd0f = 'state.actions.set-knowledge-hub.SET_KB_HUB';
    const $35c3183d0ed1f802$export$3f646e047bd99e08 = (payload)=>({
            type: $35c3183d0ed1f802$export$5d4aeddc17f0cd0f,
            payload: payload
        });
});
parcelRegister("k9iYw", function(module, exports) {
    $parcel$export(module.exports, "removeTrailingSlash", ()=>$f5e36f4cfb7d0348$export$b6d465111d914331);
    const $f5e36f4cfb7d0348$export$b6d465111d914331 = (str)=>str.replace(/\/$/, '');
});
parcelRegister("3h2aI", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$c0be59ff1e3dfebc$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$c0be59ff1e3dfebc$export$2e2bcd8739ae039);
    var $azjdP;
    var $jzG6G;
    var $goH2j;
    const $c0be59ff1e3dfebc$export$49d5fc8cba920a0 = {
        linkedSpaces: {
            data: [],
            error: null,
            loading: false
        }
    };
    var $c0be59ff1e3dfebc$export$2e2bcd8739ae039 = (state = $c0be59ff1e3dfebc$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("goH2j")).FETCH_LINKED_SPACES:
                return {
                    ...state,
                    linkedSpaces: {
                        data: [],
                        error: null,
                        loading: true
                    }
                };
            case 0, (0, parcelRequire("jzG6G")).FETCH_LINKED_SPACE_SUCCESS:
                return {
                    ...state,
                    linkedSpaces: {
                        error: null,
                        loading: false,
                        data: action.payload.spaces
                    }
                };
            case 0, (0, parcelRequire("azjdP")).FETCH_LINKED_SPACES_FAILURE:
                return {
                    ...state,
                    linkedSpaces: {
                        loading: false,
                        data: [],
                        error: action.payload.error
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("lJvk4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61fc5aff003b114a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "defaultState", ()=>$61fc5aff003b114a$export$49d5fc8cba920a0);
    var $3f2cs = parcelRequire("3f2cs");
    var $daO3a;
    var $61fc5aff003b114a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        articles: (0, parcelRequire("daO3a")).default
    });
    const $61fc5aff003b114a$export$49d5fc8cba920a0 = {
        articles: (0, (0, parcelRequire("daO3a")).defaultState)
    };
});
parcelRegister("daO3a", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$ffb3ac562043eddf$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$ffb3ac562043eddf$export$2e2bcd8739ae039);
    var $5sKH1;
    var $5XgTr;
    var $6ovlC;
    var $9fA8j;
    var $5ZGnB;
    var $6zk4x;
    var $ffNrT;
    var $19Gv3;
    var $fQZG5;
    const $ffb3ac562043eddf$export$49d5fc8cba920a0 = {};
    var $ffb3ac562043eddf$export$2e2bcd8739ae039 = (state = $ffb3ac562043eddf$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("6ovlC")).ADD_CATEGORIES_FOR_ARTICLE:
            case 0, (0, parcelRequire("19Gv3")).UPDATE_CATEGORIES_FOR_ARTICLE:
                {
                    const { categoryIds: categoryIds, articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            isShowingBulkCategoryAdder: !!(state[articleId] && state[articleId].isShowingBulkCategoryAdder),
                            categoriesInBulkCategoryAdder: state[articleId] ? state[articleId].categoriesInBulkCategoryAdder : [],
                            categoryIds: categoryIds
                        }
                    };
                }
            case 0, (0, parcelRequire("ffNrT")).UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
            case 0, (0, parcelRequire("5XgTr")).ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId } = action.payload;
                    const newState = {
                        ...state
                    };
                    delete newState[articleId];
                    return newState;
                }
            case 0, (0, parcelRequire("6zk4x")).UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
            case 0, (0, parcelRequire("5sKH1")).ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
                {
                    const { failedCategoryIds: failedCategoryIds, errorMessage: errorMessage, articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            failedCategoryIds: failedCategoryIds,
                            error: errorMessage
                        }
                    };
                }
            case 0, (0, parcelRequire("5ZGnB")).SHOW_BULK_CATEGORY_ADDER:
                {
                    const { articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            isShowingBulkCategoryAdder: true
                        }
                    };
                }
            case 0, (0, parcelRequire("9fA8j")).HIDE_BULK_CATEGORY_ADDER:
                {
                    const { articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            isShowingBulkCategoryAdder: false,
                            categoriesInBulkCategoryAdder: []
                        }
                    };
                }
            case 0, (0, parcelRequire("fQZG5")).UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER:
                {
                    const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            categoriesInBulkCategoryAdder: categoryIds
                        }
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9fA8j", function(module, exports) {
    $parcel$export(module.exports, "HIDE_BULK_CATEGORY_ADDER", ()=>$ed66b70bc3006a26$export$63cec6f97de61b9a);
    $parcel$export(module.exports, "hideBulkCategoryAdder", ()=>$ed66b70bc3006a26$export$541e941f3628edb2);
    const $ed66b70bc3006a26$export$63cec6f97de61b9a = 'state.actions.hide-bulk-category-adder.HIDE_BULK_CATEGORY_ADDER';
    const $ed66b70bc3006a26$export$541e941f3628edb2 = (payload)=>({
            payload: payload,
            type: $ed66b70bc3006a26$export$63cec6f97de61b9a
        });
});
parcelRegister("5ZGnB", function(module, exports) {
    $parcel$export(module.exports, "SHOW_BULK_CATEGORY_ADDER", ()=>$27a097cc2a8fd1f3$export$848c1458a48faa31);
    $parcel$export(module.exports, "showBulkCategoryAdder", ()=>$27a097cc2a8fd1f3$export$aea09bcda8ca9577);
    const $27a097cc2a8fd1f3$export$848c1458a48faa31 = 'state.actions.show-bulk-category-adder.SHOW_BULK_CATEGORY_ADDER';
    const $27a097cc2a8fd1f3$export$aea09bcda8ca9577 = (payload)=>({
            payload: payload,
            type: $27a097cc2a8fd1f3$export$848c1458a48faa31
        });
});
parcelRegister("fQZG5", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER", ()=>$3b0b6b45936d49fc$export$e08673e3855cdb43);
    $parcel$export(module.exports, "updateCategoriesInBulkCategoryAdder", ()=>$3b0b6b45936d49fc$export$f603b0637b290a5e);
    const $3b0b6b45936d49fc$export$e08673e3855cdb43 = 'state.actions.update-categories-in-bulk-category-adder.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER';
    const $3b0b6b45936d49fc$export$f603b0637b290a5e = (payload)=>({
            payload: payload,
            type: $3b0b6b45936d49fc$export$e08673e3855cdb43
        });
});
parcelRegister("7FkcY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f01143916800e31c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7gdJb;
    var $bHD2d;
    var $8WLSX;
    var $f01143916800e31c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(()=>({}), {
        onSetKbHub: (0, (0, parcelRequire("bHD2d")).setKbHub),
        setCategoriesData: (0, (0, parcelRequire("7gdJb")).fetchCategoriesSuccess)
    })((0, (0, parcelRequire("8WLSX")).default));
});
parcelRegister("8WLSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8de5c2338e3adc79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $8de5c2338e3adc79$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.onSetKbHub();
            this.setCategoriesData();
        }
        componentDidUpdate() {
            this.onSetKbHub();
            this.setCategoriesData();
        }
        onSetKbHub() {
            const { onSetKbHub: onSetKbHub, setCategoriesData: setCategoriesData, children: children, categories: categories, isCategoriesSupported: isCategoriesSupported, ...confluenceLink } = this.props;
            onSetKbHub(confluenceLink);
        }
        setCategoriesData() {
            const { setCategoriesData: setCategoriesData, categories: categories, isCategoriesSupported: isCategoriesSupported } = this.props;
            setCategoriesData({
                categories: categories,
                categoriesSupported: isCategoriesSupported
            });
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("6GLlD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1e4a0c92f65aa33$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $9noxX;
    var $e9YVH;
    var $9dbF6;
    var $9NiTW;
    var $cYaqS;
    const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYaqS")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "serviceDesk"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: (0, (0, parcelRequire("e9YVH")).toPackageName)(appName),
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, children))));
    var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cYaqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f72fff5a1e4c8937$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $4UFLs;
    var $g3A84;
    const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
        const isSettingsRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
        const Gate = isSettingsRoute ? (0, (0, parcelRequire("g3A84")).default) : (0, (0, parcelRequire("4UFLs")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
    };
    var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;
});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
parcelRegister("4UFLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9befbeaff9f5385d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daoB1;
    var $7tQej;
    var $bmKPg;
    var $iDvG9;
    const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
        const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        if (projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDvG9")).default), null, children);
        return hasServiceDeskAccess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira"
        });
    };
    var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;
});
parcelRegister("iDvG9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34dd3dc578b1a167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    var $bmKPg;
    var $dFOAR;
    var $fhAnU;
    const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        const [{ data: data, error: error }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        if (data || error) {
            if (!(0, (0, parcelRequire("fhAnU")).isAccessError)(error)) {
                const { userRole: userRole = '' } = data || {};
                if (userRole === 'agent' || userRole === 'agent-project-admin') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
                if (error) throw error;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
            });
        }
        return null;
    };
    var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;
});
parcelRegister("fhAnU", function(module, exports) {
    $parcel$export(module.exports, "isAccessError", ()=>$1a790f4bb1355504$export$ddaebe4928e793cb);
    const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
    ];
    const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;
});
parcelRegister("g3A84", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e7d6646168c089$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8pMQX;
    var $dFOAR;
    var $fhAnU;
    const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
        const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        const userRole = serviceDeskContext?.userRole;
        const hasAccessError = (0, (0, parcelRequire("fhAnU")).isAccessError)(serviceDeskContextError);
        if (userRole === 'agent-project-admin' && !hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (userRole !== undefined || hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null);
        if (serviceDeskContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).GenericError), null);
        return null;
    };
    var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $hTEpF;
    var $dC5iT;
    var $8CUq3;
    var $tcn7E;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $hDzhb;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("tcn7E")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $b8Qxt;
    var $dC5iT;
    var $8CUq3;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b8Qxt")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("b8Qxt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fd53c1f9dbca185$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e4VnT;
    var $1HkQx;
    var $eCBnN;
    var $9Xp6L;
    const $4fd53c1f9dbca185$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("e4VnT")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("eCBnN")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Xp6L")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
    var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;
});
parcelRegister("e4VnT", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$a32b74c088f4b53f$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1HkQx", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$a9c1aabaca189fa1$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$a9c1aabaca189fa1$export$57a2d4b573afd64a);
    var $lBXbx;
    var $8CJbG;
    const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("lBXbx")).SPACING),
            marginRight: (0, (0, parcelRequire("lBXbx")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("lBXbx")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("lBXbx")).SPACING}px 0` : (0, (0, parcelRequire("lBXbx")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("lBXbx")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
                ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("lBXbx")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("lBXbx")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("8CJbG")).getBaseTheme)();
        const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("8CJbG")).getBaseTheme)(),
            ...(0, (0, parcelRequire("8CJbG")).getColorPalette)(),
            lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("lBXbx", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$6ec31795911692d1$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$6ec31795911692d1$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$6ec31795911692d1$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$6ec31795911692d1$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$6ec31795911692d1$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$6ec31795911692d1$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$6ec31795911692d1$export$1758fda69688282e);
    var $k5uoT;
    const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
    const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
    const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
    const $6ec31795911692d1$export$82ea42e772d49e5b = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
    const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
    const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("8CJbG", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$eac5fe855702cfc1$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$eac5fe855702cfc1$export$fe2a6478976e8b17);
    var $8QpSo;
    var $kTHGn;
    const $eac5fe855702cfc1$var$T800 = '#067384';
    const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
    const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("kTHGn")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
        });
    const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
        };
    });
    const $eac5fe855702cfc1$var$getTheme = ()=>({
            ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
            ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
        });
    var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;
});
parcelRegister("eCBnN", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$d00516a0f8207944$export$f38728011c178796);
    var $8QpSo;
    var $8Y2ZY;
    const $d00516a0f8207944$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("8Y2ZY")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("8Y2ZY", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$012a854d92762508$export$7c77c3a9bb93870d);
    const $012a854d92762508$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("9Xp6L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e296c4d390ff4a21$export$2e2bcd8739ae039);
    var $c8FD2;
    var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c8FD2")).default);
});
parcelRegister("c8FD2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64df4f4e00539958$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp89O;
    const $64df4f4e00539958$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("lp89O")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;
});
parcelRegister("lp89O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a813ccd1d5fae376$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iQkqt;
    var $jVB7m;
    const $a813ccd1d5fae376$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("iQkqt")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("jVB7m")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;
});
parcelRegister("iQkqt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55dc1424d34091d6$export$2e2bcd8739ae039);
    var $eJUOt;
    var $eTMIA;
    var $8bliZ;
    var $g6MVu;
    const $55dc1424d34091d6$var$newLineRegex = /\n/g;
    function $55dc1424d34091d6$var$getNewLines(str) {
        return str.match($55dc1424d34091d6$var$newLineRegex);
    }
    function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g6MVu")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("eJUOt")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("8bliZ")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $55dc1424d34091d6$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("eTMIA")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("eTMIA")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("eJUOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9ccdbf71436a137$export$2e2bcd8739ae039);
    var $eTMIA;
    var $5FOwT;
    function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("eTMIA")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("5FOwT")).default)(lineNumber));
                return children;
            }
        };
    }
    var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;
});
parcelRegister("eTMIA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6df5b208b9d23752$export$2e2bcd8739ae039);
    var $5FOwT;
    function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("5FOwT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6257c3f70e94feb$export$2e2bcd8739ae039);
    function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("8bliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9f6debfd276481a$export$2e2bcd8739ae039);
    var $eTMIA;
    function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("eTMIA")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g6MVu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8213b6c690eefe35$export$2e2bcd8739ae039);
    function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("jVB7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98c01cbb865d4c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fBvqm;
    function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("fBvqm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdda3a2c4411588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lrHA4;
    var $31cgS;
    var $d3zI6;
    function $2fdda3a2c4411588$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("31cgS")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lrHA4")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("d3zI6")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("lrHA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e6443bd1dfeaac7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $abxiq;
    function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("abxiq", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$59fdc1b7b0ae96c9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jldZL;
    const $59fdc1b7b0ae96c9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $59fdc1b7b0ae96c9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("31cgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e16562bd8c2aca9b$export$2e2bcd8739ae039);
    const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("d3zI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbc4a00f80b5d8f$export$2e2bcd8739ae039);
    var $fBvqm;
    function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $3Fq5M;
    var $dC5iT;
    var $8CUq3;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $3bDjY;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        },
        virtualAgentAiAnswers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
            "defaultMessage": "Atlassian Intelligence answers"
        }
    });
});
parcelRegister("6FTcZ", function(module, exports) {
    $parcel$export(module.exports, "useKbConfluenceContext", ()=>$5955acba1bcddf7a$export$a8450b4f39918e6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjZiV;
    var $2YP9W;
    const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource);
    const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("2YP9W")).useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
    var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;
});
parcelRegister("4S0uJ", function(module, exports) {
    $parcel$export(module.exports, "PageStyle", ()=>$7307247c9fc02c84$export$c59987a647e9a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bAkIV;
    const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null, children));
    $7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
        Page: (0, (0, parcelRequire("bAkIV")).default)
    };
    var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
    const $7307247c9fc02c84$var$JSDSpaPageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zdiv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bAkIV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e769a1b108c1b03$export$2e2bcd8739ae039);
    var $cE92Q;
    var $bJcWY;
    var $aZdfU;
    var $5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cE92Q")).default);
});
parcelRegister("cE92Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f4d1a89146de6ed$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $f1WIN;
    function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2f4d1a89146de6ed$var$bannerStyles = {
        name: "4oew4k",
        styles: "width:100%;position:fixed"
    };
    const $2f4d1a89146de6ed$var$bannerContainerStyles = {
        name: "1x3pv69",
        styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
    };
    const $2f4d1a89146de6ed$var$pageContentStyles = {
        name: "15n167b",
        styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
    };
    const $2f4d1a89146de6ed$var$wrapperStyles = {
        name: "m5v4sl",
        styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
    };
    const $2f4d1a89146de6ed$var$mainContainerStyles = {
        name: "1cete8c",
        styles: "display:flex;flex:1 1 auto"
    };
    const $2f4d1a89146de6ed$var$navigationStyles = {
        name: "wrqbg1",
        styles: "position:relative;z-index:2"
    };
    const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, (0, parcelRequire("f1WIN")).defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$wrapperStyles,
            "data-testid": testId
        }, banner ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$bannerContainerStyles,
            style: {
                height: isBannerOpen ? `${bannerHeight}px` : '0'
            },
            "aria-hidden": !isBannerOpen,
            "data-testid": testId ? `${testId}--banner-container` : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$bannerStyles
        }, banner)) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$mainContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$navigationStyles
        }, navigation), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$pageContentStyles
        }, children)));
    };
    var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;
});
